import { ViewChild, Input, Component, OnInit, ElementRef } from '@angular/core';

import { GlobalService } from '../services/global.service';
import { ModalService } from '../shared/modal/modal.service';
import { SnackBarService } from '../shared/snackbar/snackbar.service';
import { LoadingService } from '../shared/loading/loading.service';

import { Router, NavigationEnd } from '@angular/router';

import Utils from '../shared/utility';

import { trigger, animate, transition, style } from '@angular/animations';
import { debounce, debounceTime } from 'rxjs/operators';

import Util from '../shared/utility';


import { MatDialog } from '@angular/material/dialog';
import { CostProjectionDetailsComponent } from '../shared/modal/cost-projection-details/cost-projection-details.component'
import { CostOfWaitingComponent } from '../shared/modal/cost-of-waiting/cost-of-waiting.component'
import { FundingSourceComponent } from '../shared/modal/funding-source/funding-source.component';
import { AdjustRatesComponent } from '../shared/modal/adjust-rates-of-return/adjust-rates.component';
import { RiskTolWizardComponent } from '../shared/modal/risk-tol-wizard/risk-tol-wizard.component';
import { RiskRolAdvisorAgreementComponent } from '../shared/modal/risk-rol-advisor-agreement/risk-rol-advisor-agreement.component';

import { investmentGrowthDecumation } from '../dummy-data/data'
import { Subject } from 'rxjs-compat';
import {FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';
import { SidebarService } from '../services/sidebar.service';
import { ProfileNotEligibleComponent } from 'app/shared/modal/profile-not-eligible/profile-not-eligible.component';
import { SSL_OP_SSLEAY_080_CLIENT_DH_BUG } from 'constants';

@Component({
  selector: 'app-healthcare',
  templateUrl: './healthcare.component.html',
  styleUrls: ['./healthcare.component.css'],
  host: {
    '[@fadeInAnimation]': ''
  },
  animations: [
    trigger('fadeInAnimation', [
      transition(':enter', [
        style({
          opacity: 0,
        }),
        animate('1000ms', style({
          opacity: 1,
        }))
      ]),
    ])
  ]
})
export class HealthCareComponent implements OnInit {
  public pHospMessage: string = "There is no premium cost for Medicare Part A, which covers hospitalization. The premium for Medicare Part B covers doctor visits and test costs.";
  public pDrug: string = "The premium for Medicare Part D covers prescription drug costs.";
  public pSupp: string = "The premium for MediGap covers coinsurance, co-payment and deductible out-of-pocket costs which are not covered by Medicare Parts A and B. MediGap coverage can no longer be purchased to cover Part D prescription drug costs. This coverage is provided through private insurers.";
  public pDental: string = "The premium for dental insurance will cover the standard dental care coverage. Medicare does not cover any routine dental or denture costs.";

  public oopHosp: string = "This represents the annual out-of-pocket costs for doctor visits, tests, etc. which are not covered by the Medicare Part B premium. These costs will be higher if you do not buy MediGap insurance.";
  public oopDrug: string = "This represents the annual out-of-pocket costs which will not be covered by the Medicare Part D premium. This can include the costs which must be paid by an individual if their annual drug costs are between $2750 and $4750 (the 2013 “donut hole” amounts.)";
  public oopHearing: string = "This represents the annual out-of-pocket costs for hearing and vision tests, eyeglasses, etc. which are not covered by Medicare Part B.";
  public oopDental: string = "This represents the annual out-of-pocket costs for dental care, dentures, etc. which are not covered by the standard Dental Insurance policy.";
  public fsMessage: string = "Add any expected income which is earmarked to healthcare cost funding in the inputs below. Values entered will reduce projected unfunded costs, and the investment solution to address that amount.";
  //public ssMMessage: string = "Medicare Part B premiums and Medicare Parts B and D surcharges are automatically deducted out of one’s Social Security benefit.";
  public investmentSolnMessage: string = "Select up to three unique rates of return throughout the client’s lifetime to produce multiple savings solutions for unfounded future health expenses: a one time investment, annual payments, or weekly payments.";
  public ssMMessage: string = "By law, Medicare deducts the cost of Medicare Part B, as well as potential means testing surcharges on Parts B and D, from Social Security checks.";

  public premiumsInfo: string = "Standard, baseline costs for health coverage, paid either to the government, or the insurance provider.";
  public additionalOOPInfo: string = "Costs not covered by premiums. May include copays, deductibles, and more.";

  public investmentToFundInfo: string = 'Based on rates of return indicated at bottom-center of this page, the one-time lumpsum investment required today to cover projected retirement healthcare costs, after additional funding sources are accounted for.';
  public estimatedFutureInfo: string = 'Projected retirement healthcare costs, based on checkboxes below, shown in future dollars (otherwise known as "future value")';
  public estimatedTodayInfo: string = 'Projected retirement healthcare costs, based on checkboxes below, shown in today`s dollars (otherwise known as "net present value")';

  public futureCostMessage: string = `Selecting "Today's Dollars" will show costs in the net present value, assuming an annual inflation rate of 3%. Selecting "Future Dollars" will show projected future costs in the given year.`;
  public preRetirementCoverageTypeMessage: string = "Includes coverage for hospitalization, doctor visits and tests. May include prescription drug coverage if Medicare Part D or Medicare Advantage is included in retirement projections.";
  
  public hcData: any;
  public hcDataV2: any;
  public p1CostsV2: any;
  public p2CostsV2: any;
  public tempCostsV2: any;
  public spouseHCOptionsVisible: boolean = false;

  public beginningBalance: 0;

  public tempHCData: any;
  public error: string;

  public client: any;

  public projectedFutureLifetimeCosts: number;
  public totalSocialSecurity: number = 0;
  public totalInvestment: number = 0;
  public totalRemainingGap: number = 0;
  public ssRemaining: number = 0;


  public currentRemainingTotal: number = 0;

  public additionalFunds: number = 0;

  public fundingItems: any[] = [];
  public partnerActive: boolean = false;
  public applyHealthcareToSpouse: boolean = false;

  public coverageTotal: number = 0;
  public premiumCoverageTotal: number = 0;
  public outOfPocketCoverageTotal: number = 0;
  public FrmPV: number = 1;
  public spouseHC: number = 0;
  public investmentOptionValue: 0;
  isPre65: boolean = true;
  clientEligibleForPre65: boolean = false;
  isSpousePre65: boolean = true;
  spouseEligibleForPre65: boolean = false;
  year1Total: number = 0;
  spouseYear1Total: number = 0;

  public lineChartData: any[];
  public pieChartData: any[];
  public barChartData: any[];
  public rOROptions: any[] = [
    {
      text: 'Option 1',
      value: '6%'
    },
    {
      text: 'Option 2',
      value: '7%',
      selected: true
    },
    {
      text: 'Option 3',
      value: '8%'
    }
  ];
  phaseOneYear: string = '2030';
  phaseTwoYear: string = '2040';

  public fundingSource: any;
  public startAge: any;
  public endAge: any;
  public inflationRate: any;
  public annContribution: any;
  showFundingBorder: boolean;
  showStartAgeBorder: boolean;
  showEndAgeBorder: boolean;
  showInflationBorder: boolean;
  showAnnContrBorder: boolean;

  showTable: boolean;
  annuallyWeeklyTtlYear: number;

  spouseProfileInfo: FormGroup;
  profileInfo: FormGroup;

  isAlreadyInitializeComponent: boolean = false;
  dropDownSelectedIndexAnnually: number = 0;
  dropDownSelectedIndexWeekly: number = 0;
  investmentDescription: string;
  spouseRetirementYear: number = 0;
  totalYear1Premiums: number = 0;
  spouseTotalYear1Premiums: number = 0;
  pre65Total: number = 0;
  spousePre65Total: number = 0;

  responseMMTBracket;
  public selectedIRMAABracketDisplay = '';
  retirementAge: number = 0;
  spouseRetirementAge: number = 0;
  isRetired: boolean;

  equitiesLargeCap;
  equitiesMidCap;
  equitiesSmallCap;
  equitiesInternational;
  equitiesReturn;
  fixedGovBonds;
  fixedCorpBonds;
  fixedReturn;
  cashMoneyMarket;
  cashMoneyMarketReturn;
  hasRiskTolBeenRan: boolean = false;
  currentRemainingTotalForRiskTolPort;
  portfolioRecommendationVisible: boolean = false
  portfolioRecommendationObject;
  isAlreadyRetired: boolean = false;
  isHCIllustration:boolean = true;
  rorPhaseOneYear;

  @ViewChild('FundingSource') fundingSourceInput: any;
  @ViewChild('AnnContribution') annContributionInput: any;
  @ViewChild('StartAge') startAgeInput: any;
  @ViewChild('EndAge') endAgeInput: any;
  @ViewChild('InflationRate') inflationRateInput: any;

  @ViewChild('rate2') rate2: any;

  @ViewChild('totalRemainingGapEl') totalRemainingGapEl: ElementRef;
  @ViewChild('totalFutureEstimatedCostsEl') totalFutureEstimatedCostsEl: ElementRef;
  @ViewChild('totalEstimatedCostsEl') totalEstimatedCostsEl: ElementRef;

  @ViewChild('p1Percent') p1Percent: ElementRef;
  @ViewChild('p1EndAge') p1EndAge: ElementRef;
  @ViewChild('p2Percent') p2Percent: ElementRef;
  @ViewChild('p2EndAge') p2EndAge: ElementRef;
  @ViewChild('p3Percent') p3Percent: ElementRef;

  @ViewChild('annualEl') annualEl: ElementRef;
  @ViewChild('weeklyEl') weeklyEl: ElementRef;


  @ViewChild('pcheck') pcheck: ElementRef;
  @ViewChild('oopcheck') oopcheck: ElementRef;

  @ViewChild('hdt') hdt: ElementRef;
  @ViewChild('pd') pd: ElementRef;
  @ViewChild('si') si: ElementRef;
  @ViewChild('di') di: ElementRef;
  @ViewChild('hd') hd: ElementRef;
  @ViewChild('pdrg') pdrg: ElementRef;
  @ViewChild('hvc') hvc: ElementRef;
  @ViewChild('dins') dins: ElementRef;
  @Input() percentageFormatting: (value: number) => any;
  investmentGrowthDecumation: any[];

  public premiumExpenses: any = {
    partB: true,
    partD: true,
    medigap: true,
    dental: true
  };

  public outOfPocketExpenses: any = {
    hospitalization: true,
    docsTests: true,
    rx: true,
    dental: true,
    hearingServices: true,
    vision: true,
    commercial: true
  };

  public lineChartOptions = {
    showXAxis: true,
    showYAxis: true,
    gradient: false,
    showLegend: true,
    xAxisLabel: '',
    yAxisLabel: '',
    roundDomains: false,
    timeline: false,
    curve: false,
    tooltipDisabled: false,
    colorScheme: {
      domain: ['#bad052', '#bad052', '#bad052']
    },
    autoScale: true
  }

  public pieChartOptions = {
    showLegend: false,
    //'#c0d465', '#c7d976', '#cede87', '#d5e298', '#dce7a9', '#e3ecba', '#eaf0cb'
    colorScheme: { domain: ['#bad054', '#eaf0cb', '#e3ecba', '#dce7a9', '#d5e298', '#cede87', '#c7d976', '#c0d465'] },
    showLabels: false,
    explodeSlices: false,
    doughnut: false,
    view: [500, 250],
    autoScale: true
  }

  public barChartOptions = {
    showXAxis: true,
    showYAxis: true,
    gradient: false,
    showLegend: false,
    showXAxisLabel: false,
    xAxisLabel: 'Country',
    showYAxisLabel: false,
    yAxisLabel: 'Population',
    roundEdges: false,
    colorScheme: {
      domain: ['#e8f0c7', '#d3e08e', '#bad054']
    }
  }

  public barVerticalStackedChartColorHolder = {
    //domain: ['#3385C5', '#E58931', '#20a59f']
    // domain: ['#5270ad', '#487879', '#63a49e']
    domain: ['#63a49e', '#5270ad','#487879']
  };
  
  public barVerticalStackedChartOption = {
    showXAxis: true,
    showYAxis: true,
    gradient: false,
    showLegend: false,
    showXAxisLabel: false,

    showYAxisLabel: false,


    roundEdges: false,
    colorScheme: {
      //domain: ['#3385C5', '#E58931', '#20a59f']
      // domain: ['#5270ad', '#487879', '#63a49e']
      domain: ['#63a49e', '#5270ad','#487879']
    },
    autoScale: true

  };
  imgSrc: string;
  isSrcReport: string;
 public selected: any = {
   isoneTimeInvestmentSelect: false,
   isannuallyRecurringInvestmentSelect: false,
   isweeklyRecurringInvestmentSelect: false,
 }

 public projectedYears: any;

 eventsSubject: Subject<void> = new Subject<void>();
 bodyCardSelectedIndexAnnually: number;
 bodyCardSelectedIndexWeekly: number;


 emitEventToChild() {
  this.eventsSubject.next();
}

  constructor(public sidebarService: SidebarService, private globalService: GlobalService, private modalService: ModalService, private snackBarService: SnackBarService, private router: Router, private loadingService: LoadingService, public dialog: MatDialog) {
    this.globalService.featFunding = JSON.parse(localStorage.getItem('featFunding'));
    this.globalService.featRiskTolerance = JSON.parse(localStorage.getItem('featRiskTolerance'));
    //this.globalService.featRiskTolerance = true;

    this.imgSrc = '../../../assets/icons/healthcare_illustration_dark_blue.svg';
    this.isSrcReport = "healthCareReport";
    this.selected.isoneTimeInvestmentSelect = true;
    
    localStorage.setItem('isCreateClient', "False");
    Object.assign(this, { investmentGrowthDecumation });
    modalService.modal$.subscribe((modal) => {
      if (modal.modalName == 'add-edit-clientClosed') { // TODO: Fix this hack -- naming it hidden.. modals in general need to be refactored
        this.getClient();
      }
    });

    this.ssClientAgeChanged.pipe(
      debounceTime(1500))
      .subscribe(model => {
          //this.magi = 100;
          this.ssClientAge = this.validateSSAge(Number(this.ssClientAge), this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed');
          this.getMMTData();
      });

    this.ssSpouseAgeChanged.pipe(
      debounceTime(1500))
      .subscribe(model => {
          //this.magi = 100;
          this.ssSpouseAge = this.validateSSAge(Number(this.ssSpouseAge), this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed');
          this.getMMTData();
      });

    //required for page refresh when updating client profile
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };

    sidebarService.clientUpdated.subscribe(()=>{
      if (this.isAlreadyInitializeComponent) {
        console.log('sidenav adj');
        this.router.navigate(['/clients/edit/healthcare/options/hc']);
      }
    });

    if(this.globalService.featRiskTolerance){
      this.router.events
        .filter(event => event instanceof NavigationEnd)
        .subscribe(event => this.handleRiskTolCheck((event as NavigationEnd).url));
    }
  }
  
  isRiskModalDisplayed: boolean = false;
  handleRiskTolCheck(url) {
    //url === '/clients/edit/long-term-care/options/ltcrt'
    if (url === '/clients/edit/healthcare/options/hcrt' && !this.isRiskModalDisplayed) {
      //console.log('running RT');
      //this.reDirectModal('riskTolerance');
      this.isRiskModalDisplayed = true;
    }
  }

  validateSSAge(age, survivor) {
    if (!survivor) {
        if (age < 62)
            return '62';
        if (age > 70)
            return '70';
    } else {
        if (age < 60)
            return '60';
        if (age > 70)
            return '70';
    }
    return age.toString();
}

  returnedFundingSource(data){
    console.log('retured data to HC page', data);
    //var tempTotal = this.futureTotalCost - (this.hcDataV2.FundingOptions.PartB.replace(/,/g,"").replace("$",""));
    this.contributionAmount = 0;    
    this.fundingItems = [];  
    
    if(data.length > 0){         
      for (var item in data){
        /* tempTotal = (tempTotal - data[item].totalContribution > 0) ? tempTotal - data[item].totalContribution : 0;
  
        this.fundingItems.push({
          fundingSource: data[item].fundingSource,
          startAge: data[item].startYear,
          endAge: data[item].endYear,
          annContribution: data[item].annualContribution,
          inflationRate: data[item].inflationRate,
          remainingUnfunded: tempTotal
        }); */
        this.contributionAmount += data[item].totalContribution;
        this.handleNewFundingItem(data[item].fundingSource, data[item].annualContribution, 
          data[item].startYear, data[item].endYear, data[item].inflationRate);
      }
    }
    
    this.getHCData(this.client, this.partnerActive, this.isRiskModalDisplayed);

    //console.log('new funding', this.fundingItems);
    //this.getHCData(this.client, this.partnerActive);
    //this.fundingTableCount();
  }

  generateLineChartData(data: any) {   

    if (this.hcDataV2) {
      //this is copied from the illustration section >>not sure if true, talk to Daley on this
      /*  var projectedYears = this.hcDataV2.IllustrationEntriesWithFunding.map(entry => {
         return {
           Year: this.currentYear,
           BeginningBalance: Utils.formatToCurrency(entry.BeginningBalance ? entry.BeginningBalance.toFixed(0) : 0),
           ExpectedRateReturn: (entry.CashFlowEntry.ExpectedRor ? entry.CashFlowEntry.ExpectedRor * 100 + '%': 0),
           // Premiums: '$' + 0,
           Contribution: Utils.formatToCurrency(entry.CashFlowEntry.Contribution > 0 ? entry.CashFlowEntry.Contribution.toFixed(0) : (entry.CashFlowEntry.TotalIncome + entry.CashFlowEntry.Contribution).toFixed(0)),
           // AdditionalCosts: '$' + 0,
           Total: Utils.formatToCurrency(entry.CashFlowEntry.Expense ? entry.CashFlowEntry.Expense.toFixed(0) : 0),
           NetOfSSDeductions: Utils.formatToCurrency(entry.CashFlowEntry.Expense.toFixed(0) - entry.CashFlowEntry.HealthAllocatedIncome.toFixed(0)),
           EngingBalance: Utils.formatToCurrency(Math.abs((entry.EndingBalance ? entry.EndingBalance.toFixed(0) : 0))),
         }
       }); */



      let currentYear = new Date().getFullYear();
      let retirementYear = this.hcDataV2.RetirementYear < currentYear ? currentYear : this.hcDataV2.RetirementYear;

      this.projectedYears = this.hcDataV2.IllustrationEntriesWithFunding.map(entry => {
        return {
          Year: this.currentYear,
          BeginningBalance: Utils.formatToCurrency(entry.BeginningBalance ? entry.BeginningBalance.toFixed(0) : 0),
          ExpectedRateReturn: (entry.CashFlowEntry.ExpectedRor ? entry.CashFlowEntry.ExpectedRor * 100 + '%' : 0),
          // Premiums: '$' + 0,
          Contribution: Utils.formatToCurrency(entry.CashFlowEntry.Contribution > 0 ? entry.CashFlowEntry.Contribution.toFixed(0) : (entry.CashFlowEntry.TotalIncome + entry.CashFlowEntry.Contribution).toFixed(0)),
          // AdditionalCosts: '$' + 0,
          Total: Utils.formatToCurrency(entry.CashFlowEntry.Expense ? entry.CashFlowEntry.Expense.toFixed(0) : 0),
          // NetOfSSDeductions: Utils.formatToCurrency(entry.CashFlowEntry.Expense.toFixed(0) - entry.CashFlowEntry.HealthAllocatedIncome.toFixed(0)),
          NetOfSSDeductions: Utils.formatToCurrency(Math.max(0, entry.CashFlowEntry.Expense.toFixed(0) - entry.CashFlowEntry.HealthAllocatedIncome.toFixed(0))),
          EngingBalance: Utils.formatToCurrency(Math.abs((entry.EndingBalance ? entry.EndingBalance.toFixed(0) : 0))),
        }
      });

      this.lineChartData = [
        this.hcDataV2.Expenses.slice(Math.abs(currentYear - retirementYear)).reduce((acc, expense, i) => {
          acc.series.push({ 'name': (retirementYear + i).toString(), 'value': this.formatNumber(expense) });
          return acc;
        //}, { name: 'Cost', series: [] })];


      //   this.p1CostsV2.reduce((acc, year, i) => {
      //   if (this.partnerActive) {
      //     acc.series.push({ "name": (retirementYear + i).toString(), "value": this.formatNumber(
      //       this.p1CostsV2[i].Premiums[0] + this.p1CostsV2[i].Premiums[1] + this.p1CostsV2[i].Premiums[2] + this.p1CostsV2[i].Premiums[3] +
      //       this.p1CostsV2[i].AdditionalOOP[0] + this.p1CostsV2[i].AdditionalOOP[1] + this.p1CostsV2[i].AdditionalOOP[2] + this.p1CostsV2[i].AdditionalOOP[3] + 
      //       (this.p2CostsV2[i].Premiums[0] + this.p2CostsV2[i].Premiums[1] + this.p2CostsV2[i].Premiums[2] + this.p2CostsV2[i].Premiums[3] || 0) +
      //       (this.p2CostsV2[i].AdditionalOOP[0] + this.p2CostsV2[i].AdditionalOOP[1] + this.p2CostsV2[i].AdditionalOOP[2] + this.p2CostsV2[i].AdditionalOOP[3]) || 0 
      //     )})
      //   } else {
      //     acc.series.push({ "name": (retirementYear + i).toString(), "value": this.formatNumber(
      //       this.p1CostsV2[i].Premiums[0] + this.p1CostsV2[i].Premiums[1] + this.p1CostsV2[i].Premiums[2] + this.p1CostsV2[i].Premiums[3] +
      //       this.p1CostsV2[i].AdditionalOOP[0] + this.p1CostsV2[i].AdditionalOOP[1] + this.p1CostsV2[i].AdditionalOOP[2] + this.p1CostsV2[i].AdditionalOOP[3]
      //     )})
      //   }

      //   return acc;
      // }, { name: 'Cost', series: []})];

        }, { name: 'Cost', series: []}),
        this.hcDataV2.Expenses.slice(Math.abs(currentYear - retirementYear)).reduce((acc, expense, i) => {
          acc.series.push({'name': (retirementYear +1+ i).toString(), 'value': this.formatNumber(expense)});
          return acc;
        }, { name: 'Cost', series: []})];
        
    }
  }

  generatePieChartData() {
    // tempTotal =  tempTotal + this.fundingItems.reduce((item, acc) => { console.log(acc); return acc + item.remainingUnfunded}, 0);
    var tempTotal = this.futureTotalCost - (this.hcDataV2.FundingOptions.PartB.replace(/,/g,"").replace("$",""));

    if (this.fundingItems.length) {
      tempTotal = this.fundingItems[this.fundingItems.length - 1].remainingUnfunded;
    }
    console.log('pie', this.fundingItems);
    
    this.pieChartData = [
      { "name": "Unfunded", "value": tempTotal },
      { "name": "Medicare Deduction from Social Security", "value": this.totalSocialSecurity }
    ]

    this.fundingItems.forEach((item) => { this.pieChartData.push({ "name": item.fundingSource, "value": item.contributionAmount }) });
  }

  public yAxisTickFormattingFn = this.yAxisTickFormatting.bind(this);

  yAxisTickFormatting(value) {
    return Utils.formatToCurrency(value);
  }

  generateBarChartData() {

    this.cowValues.one = this.hcDataV2.Illustrations[0].BeginningBalance ? Utils.formatToCurrency(this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0)) : 0;
    this.cowValues.three = (this.hcDataV2.Illustrations.length >= 3) ? this.hcDataV2.Illustrations[0].BeginningBalance ? Utils.formatToCurrency(this.hcDataV2.Illustrations[2].BeginningBalance.toFixed(0)) : 0 : 0;
    this.cowValues.five = (this.hcDataV2.Illustrations.length >= 5) ? this.hcDataV2.Illustrations[0].BeginningBalance ? Utils.formatToCurrency(this.hcDataV2.Illustrations[4].BeginningBalance.toFixed(0)) : 0 : 0;

    this.barChartData = [
      {
        "name": "Today",
        "value": this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0)
      },
      {
        "name": "3 Years",
        "value": (this.hcDataV2.Illustrations.length >= 3) ? this.hcDataV2.Illustrations[2].BeginningBalance.toFixed(0) : 0
      },
      {
        "name": "5 Years",
        "value": (this.hcDataV2.Illustrations.length >= 5) ? this.hcDataV2.Illustrations[4].BeginningBalance.toFixed(0) : 0
      }
    ]
  }
 
  
  generateInvestGrowthBarChartData() {

    this.cowValues.one = this.hcDataV2.Illustrations[0].BeginningBalance ? Utils.formatToCurrency(this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0)) : 0;
    this.cowValues.three = this.hcDataV2.Illustrations[0].BeginningBalance ? Utils.formatToCurrency(this.hcDataV2.Illustrations[2].BeginningBalance.toFixed(0)) : 0;
    this.cowValues.five = this.hcDataV2.Illustrations[0].BeginningBalance ? Utils.formatToCurrency(this.hcDataV2.Illustrations[4].BeginningBalance.toFixed(0)) : 0;
    

    this.barChartData = [
      {
        "name": "Today",
        "value": this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0)
      },
      {
        "name": "3 Years",
        "value": this.hcDataV2.Illustrations[2].BeginningBalance.toFixed(0)
      },
      {
        "name": "5 Years",
        "value": this.hcDataV2.Illustrations[4].BeginningBalance.toFixed(0)
      }
    ]
  }

  objAdjustRates;// = '';
  objRiskTolerance;
  objRickToleranceAccountAgreement;
  reDirectModal(modalName): void {
    if (modalName == 'costExplained') {
      const dialogRef = this.dialog.open(CostProjectionDetailsComponent, {
        //width: '1000px',
        //height: '700px',
        data: {hcDataV2: this.hcDataV2, partnerActive: this.partnerActive, FrmPV: this.FrmPV }
      });
    }
    if (modalName == 'costOfWaiting') {
      const dialogRef = this.dialog.open(CostOfWaitingComponent, {
        //width: '1000px',
        //height: '700px',
        data: {hcDataV2: this.hcDataV2 }
      });
    }
    if (modalName == 'addFundingSource') {
      const dialogRef = this.dialog.open(FundingSourceComponent, {
        width: '1000px',
        height: '700px',
        data: {hcDataV2: this.hcDataV2, modalName: modalName }
      });
    }
    if (modalName == 'adjustRates') {
      const dialogRef = this.dialog.open(AdjustRatesComponent, {
       /*  width: '1000px',
        height: '700px', */
        data: {client: this.client, obj: this.objAdjustRates, modalName: modalName }
      });

      //on close
      dialogRef.afterClosed().subscribe(result =>{
        //recalc illustration page here with new ROR values
        //console.log('from close', result);
        if(result){
          this.objAdjustRates = result;
          if(this.isRiskModalDisplayed){
            this.portfolioRecommendationObject.phase1Val = this.objAdjustRates.rorOne;
            this.portfolioRecommendationObject.phase2Val = this.objAdjustRates.rorTwo;
            this.hasRiskTolBeenRan = false;

            this.getPortfolioRecommendation();
          } else {
            this.getHCData(this.client, this.partnerActive);
          }
        }
      });
    }

    if(modalName == 'riskTolerance' && this.globalService.featRiskTolerance){
      this.isRiskModalDisplayed = true;

      var body = {
        ClientID: Number(localStorage.getItem("selectedClient"))
      };
      
      this.globalService.getClientRiskTolerance(body)
      .subscribe(
        risk => {     
          //console.log('from server', risk); 
          var riskResponse;
          if(risk != null){   
            riskResponse = risk;
          }

          const dialogRef = this.dialog.open(RiskTolWizardComponent, {
            data: {client: this.client, obj: riskResponse, modalName: modalName }
          });

          //on close
          dialogRef.afterClosed().subscribe(result =>{        
            if(result){
              this.objRiskTolerance = result;
              //this.getHCData(this.client, this.partnerActive);
              this.saveClientRiskTol(false);
            }
          });
        });  
    }

    if(modalName == 'riskToleranceAdvisorAgreement' && this.globalService.featRiskTolerance){
      const dialogRef = this.dialog.open(RiskRolAdvisorAgreementComponent, {
        data: {client: this.client, obj: '', modalName: modalName }
      });

      //on close
      dialogRef.afterClosed().subscribe(result =>{        
        if(result){
          this.objRickToleranceAccountAgreement = result;
          this.saveClientRiskTol(true);
        }
      });
    }

  }
  
  onBlur(event) {
    if (event.target.value !== '')
      event.target.value = parseFloat(event.target.value).toFixed(2)
  }

  ngOnInit() {
    this.isAlreadyInitializeComponent = true;
    this.profileInfo = new FormGroup({
      privateHealthInsurance: new FormControl(),
      preRetirementCoverageType: new FormControl(),
      inRetirementCoverageType: new FormControl(),
      pre65: new FormControl(),
      //Traditional Medicare (TM)
      medicarePartB: new FormControl(),
      medicarePartD: new FormControl(),
      supplemental: new FormControl(),
      supplementalPlanType: new FormControl(),

      //Medicare Adv HMO
      medicareAdvHMO: new FormControl(),

      //Medicare Adv PPO
      medicareAdvPPO: new FormControl(),

      //always avail
      dental: new FormControl(),
      hospitalDocsTestsOOP: new FormControl(),
      prescriptionDrugsOOP: new FormControl(),  
      hearingVisionOOP: new FormControl(),    
      dentalOOP: new FormControl(),    
      //TODO: need to save this new value
      //if runReportWithSpouse is set to TRUE, ignore form spouseProfileInfo
      runReportWithSpouse: new FormControl(),
      maritalStatus: new FormControl()
    });

    this.getClient();
  }
  

  tabSelected = new FormControl(0);
  runReportWithSpouse(toggle){
    //toggle the display of the tabs
    if(toggle){
      this.profileInfo.controls['runReportWithSpouse'].setValue(!this.profileInfo.value.runReportWithSpouse);
    }
    console.log('this.profileInfo.value.runReportWithSpouse', this.profileInfo.value.runReportWithSpouse);
    console.log('(this.isSpousePre65', this.isSpousePre65)
    //if true, we need map the checkboxes to be the same and checked
    if(this.profileInfo.value.runReportWithSpouse){
      //this.tabSelected.setValue(0);
      if(this.spouseEligibleForPre65 && this.isPre65){
        this.spouseProfileInfo.controls['privateHealthInsurance'].setValue(this.profileInfo.value.privateHealthInsurance);
        this.spouseProfileInfo.controls['preRetirementCoverageType'].setValue(this.profileInfo.value.preRetirementCoverageType);
      }

      this.spouseProfileInfo.controls['inRetirementCoverageType'].setValue(this.profileInfo.value.inRetirementCoverageType);

      this.spouseProfileInfo.controls['medicarePartB'].setValue(this.profileInfo.value.medicarePartB);
      this.spouseProfileInfo.controls['medicareAdvHMO'].setValue(this.profileInfo.value.medicareAdvHMO);
      this.spouseProfileInfo.controls['medicareAdvPPO'].setValue(this.profileInfo.value.medicareAdvPPO);
      this.spouseProfileInfo.controls['medicarePartD'].setValue(this.profileInfo.value.medicarePartD);
      this.spouseProfileInfo.controls['supplemental'].setValue(this.profileInfo.value.supplemental);
      this.spouseProfileInfo.controls['supplementalPlanType'].setValue(this.profileInfo.value.supplementalPlanType),
      this.spouseProfileInfo.controls['dental'].setValue(this.profileInfo.value.dental);

      this.spouseProfileInfo.controls['hospitalDocsTestsOOP'].setValue(this.profileInfo.value.hospitalDocsTestsOOP);
      this.spouseProfileInfo.controls['prescriptionDrugsOOP'].setValue(this.profileInfo.value.prescriptionDrugsOOP);
      this.spouseProfileInfo.controls['hearingVisionOOP'].setValue(this.profileInfo.value.hearingVisionOOP);
      this.spouseProfileInfo.controls['dentalOOP'].setValue(this.profileInfo.value.dentalOOP);
      this.spouseProfileInfo.controls['inRetirementCoverageType'].setValue(this.profileInfo.value.inRetirementCoverageType);

      this.getHCData(this.client, this.partnerActive);
    }
  }

  removeFundingItem(item) {
    this.fundingItems.splice(this.fundingItems.indexOf(item), 1);
    this.onRateChange(0);
    this.fundingTableCount();
  }

  public futureTotalCost: number;

  public sample: any = {
    ExpenseProjectionBody: "",
    FrmIncome: "",
    FullHorizonYears: "",
    FundingOptions: {},
    Illustrations: [],
    IncomeCompareAnalysis: {},
    P1Age: "",
    P1FullHorizonYears: "",
    P1Gender: "",
    P1HealthCareExpenses: "",
    P1HealthCareExpensesDiscounted: "",
    P1LifeTimeTotalsForComparison: "",
    P2Age: "",
    P2FullHorizonYears: "",
    P2Gender: "",
    P2HealthCareExpenses: "",
    P2HealthCareExpensesDiscounted: "",
    P2LifeTimeTotalsForComparison: "",
    PlanUntil1: "",
    PlanUntilYear: "",
    RetireYear: null,
    RetirementYear: 0,
    State: "",
    TotalProjectedCost: "",
    TotalProjectedCostPv: "",
    TotalYear1Cost: "",
    TotalYear1OOP: "",
    TotalYear1Premiums: "",
    YearOneTotal: "",
    YearsInRetirement: "",
    YearsToRetirement: "",
    hq: null,
    partners: null
  }

  public cowValues: any = {
    one: 0,
    three: 0,
    five: 0,
  };

  public investmentOption: number = 1;
  currentYear = new Date().getFullYear();
  clientIndex = 0;
  pre65ClientIndex = 0;
  spouseIndex = 0;
  pre65SpouseIndex = 0;
  HCReport;
  user;
  getHCData(client: any, includeSpouse?: any, useRiskTolSingleInvestment?: any) {
    this.enableControls('client');
    this.loadingService.isLoading(true);
    var currentAge = this.calculateAge(client.client.DOB);
    var currentYear = new Date().getFullYear();

    var spouse = {};

    var investmentItems = [];
    console.log('this.fundingItems', this.fundingItems.length)
    for (var item in this.fundingItems) {

      var contribution = {
        Description: this.fundingItems[item].fundingSource,
        Begins: this.fundingItems[item].startAge,
        Ends: this.fundingItems[item].endAge,
        StartAmount: this.fundingItems[item].annContribution,
        Cola: this.fundingItems[item].inflationRate,
      }
      //this.additionalFunds += this.fundingItems[item].annContribution;
      investmentItems.push(contribution);
    }

    console.log('this.fundingItems', this.fundingItems);
    console.log('this.fundingItems', investmentItems);

    if (this.fundingItems.length == 0) {
      //this.additionalFunds = 0;
    }

    if (this.client.clientProfile.Spouses
      && this.client.clientProfile.Spouses.length > 0
      && this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {
      this.partnerActive = true;
      this.enableControls('spouse');
    } else {
      this.partnerActive = false;
    }
    console.log('this.profileInfo.value.medicareAdvHMO', this.profileInfo.value.medicareAdvHMO );
    console.log('this.profileInfo.value.medicareAdvPPO', this.profileInfo.value.medicareAdvPPO);
    let spouseDOB = this.client.clientProfile.Spouses[0].dobStr ? this.client.clientProfile.Spouses[0].dobStr : (new Date(this.client.clientProfile.Spouses[0].dob) ? this.client.clientProfile.Spouses[0].dob : '');
   this.retirementAge = this.client.clientProfile.RetirementAge < 65 && (!this.profileInfo.value.privateHealthInsurance || this.profileInfo.value.privateHealthInsurance == 'false') ? 65 : this.client.clientProfile.RetirementAge;
   this.spouseRetirementAge = this.client.clientProfile.Spouses[0].retirementAge < 65 && (!this.spouseProfileInfo.value.privateHealthInsurance || this.spouseProfileInfo.value.privateHealthInsurance == 'false') && this.partnerActive ? 65 : this.client.clientProfile.Spouses[0].retirementAge;
    var HCReport = {
      InvestmentItems: JSON.stringify({ investmentItems }),

      //client
      P_Part_A_And_B: this.profileInfo.value.medicarePartB ? 1 : 0,//this.hdt ? this.hdt.nativeElement.checked ? 1 : 0 : 1,
      P_Part_D: ((this.profileInfo.value.medicareAdvHMO && this.profileInfo.value.inRetirementCoverageType == 'HMO') || (this.profileInfo.value.medicareAdvPPO && this.profileInfo.value.inRetirementCoverageType == 'PPO')) ? 0 : this.profileInfo.value.medicarePartD ? 1 : 0,//this.pd ? this.pd.nativeElement.checked ? 1 : 0 : 1,
      P_MediGap: this.profileInfo.value.supplemental ? 1 : 0,//this.si ? this.si.nativeElement.checked ? 1 : 0 : 0,
      P_Dental: this.profileInfo.value.dental ? 1 : 0,//this.di ? this.di.nativeElement.checked ? 1 : 0 : 0,
      P_Advantage: ((this.profileInfo.value.medicareAdvHMO && this.profileInfo.value.inRetirementCoverageType == 'HMO') || (this.profileInfo.value.medicareAdvPPO && this.profileInfo.value.inRetirementCoverageType == 'PPO'))? 1 : 0,
      OOP_Hosp_Docs: this.profileInfo.value.hospitalDocsTestsOOP ? 1 : 0,//this.hd ? this.hd.nativeElement.checked ? 1 : 0 : 0,
      OOP_Presc_Drug: this.profileInfo.value.prescriptionDrugsOOP ? 1 : 0,//this.pdrg ? this.pdrg.nativeElement.checked ? 1 : 0 : 0,
      OOP_Hearing_Vision: this.profileInfo.value.hearingVisionOOP ? 1 : 0,//this.hvc ? this.hvc.nativeElement.checked ? 1 : 0 : 0,
      OOP_Dental: this.profileInfo.value.dentalOOP ? 1 : 0,//this.dins ? this.dins.nativeElement.checked ? 1 : 0 : 0,
      
      //spouse/partner
      P_Part_A_And_B1: this.partnerActive ? this.spouseProfileInfo.value.medicarePartB ? 1 : 0 : 0,
      P_Part_D1: this.partnerActive ? ((this.spouseProfileInfo.value.medicareAdvHMO && this.spouseProfileInfo.value.inRetirementCoverageType == 'HMO') || (this.spouseProfileInfo.value.medicareAdvPPO && this.spouseProfileInfo.value.inRetirementCoverageType == 'PPO')) ? 0 : this.spouseProfileInfo.value.medicarePartD ? 1 : 0 : 0,
      P_MediGap1: this.partnerActive ? this.spouseProfileInfo.value.supplemental ? 1 : 0 : 0,
      P_Dental1: this.partnerActive ? this.spouseProfileInfo.value.dental ? 1 : 0 : 0,
      P_Advantage1: this.partnerActive ? ((this.spouseProfileInfo.value.medicareAdvHMO && this.spouseProfileInfo.value.inRetirementCoverageType == 'HMO') || (this.spouseProfileInfo.value.medicareAdvPPO && this.spouseProfileInfo.value.inRetirementCoverageType == 'PPO')) ? 1 : 0 : 0,
      OOP_Hosp_Docs1: this.partnerActive ? this.spouseProfileInfo.value.hospitalDocsTestsOOP ? 1 : 0 : 0,
      OOP_Presc_Drug1: this.partnerActive ? this.spouseProfileInfo.value.prescriptionDrugsOOP ? 1 : 0 : 0,
      OOP_Hearing_Vision1: this.partnerActive ? this.spouseProfileInfo.value.hearingVisionOOP ? 1 : 0 : 0,
      OOP_Dental1: this.partnerActive ? this.spouseProfileInfo.value.dentalOOP ? 1 : 0 : 0,
      
      CoverageType: this.profileInfo.value.preRetirementCoverageType == 'PPO' ? 0 : this.profileInfo.value.preRetirementCoverageType == 'HMO' ? 1 : 2,
      CoverageType1: (this.partnerActive) ? this.spouseProfileInfo.value.preRetirementCoverageType == 'PPO' ? 0 : this.spouseProfileInfo.value.preRetirementCoverageType == 'HMO' ? 1 : 2 : 0,
      PremiumType: this.profileInfo.value.inRetirementCoverageType == 'TM' ? 0 : this.profileInfo.value.inRetirementCoverageType == 'HMO' ? 1 : 2,
      PremiumType1: (this.partnerActive) ? this.spouseProfileInfo.value.inRetirementCoverageType == 'TM' ? 0 : this.spouseProfileInfo.value.inRetirementCoverageType == 'HMO' ? 1 : 2 : 0,
      PrivateInsurance: this.profileInfo.value.privateHealthInsurance || false,
      PrivateInsurance1: (this.partnerActive) ? this.spouseProfileInfo.value.privateHealthInsurance || false : false,

      FrmName0: this.client.client.FirstName + " " + this.client.client.LastName,
      FrmName1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].firstName + " " + this.client.clientProfile.Spouses[0].lastName : "",
      FrmHasPartner: this.partnerActive,
      FrmQType: this.client.clientProfile.HCT1D,
      FrmQExcercise: 1,
      FrmGender: this.client.client.GenderID,
      FrmQTypeII: this.client.clientProfile.HCT2D,
      FrmQTobacco: this.client.clientProfile.HCT,
      FrmQCancer: this.client.clientProfile.HCC,
      FrmQHistory: this.client.clientProfile.HCFHDC,
      FrmQMS: this.client.clientProfile.HCMS,
      FrmQCardio: this.client.clientProfile.HCCD,
      FrmQPhysical: 1,
      FrmQHighColesterol: this.client.clientProfile.HCHC,
      FrmQDiet: 1,
      FrmQHBP: this.client.clientProfile.HCHBP,      
      FrmQDCW: this.client.clientProfile.HCDCW,

      FrmQAlzheimer: this.client.clientProfile.HCALZ,
      FrmQParkinson: this.client.clientProfile.HCPARK,
      FrmQPTSD: this.client.clientProfile.HCPTSD,
      FrmQAmputation: this.client.clientProfile.HCAMP,
      FrmQObesity: this.client.clientProfile.HCOBS,
      
      FrmCurrentAge: this.calculateAge(this.client.client.DOB),

      // FrmPlanUntil: 0,
      // FrmPlanUntil0: 0,
      // FrmPlanUntil1: 0,
      // SpouseFrmPlanUntil: 0,
      selfConditions: JSON.stringify({
        HCHBP: this.client.clientProfile.HCHBP,
        HCHC: this.client.clientProfile.HCHC,
        HCT2D: this.client.clientProfile.HCT2D,
        HCCD: this.client.clientProfile.HCCD,
        HCC: this.client.clientProfile.HCC,
        HCT: this.client.clientProfile.HCT,
        HCT1D: this.client.clientProfile.HCT1D ? 1 : 0,
        HCMS: this.client.clientProfile.HCMS ? 1 : 0,
        HCDCW: this.client.clientProfile.HCDCW ? 1 : 0,
        HCFHDC: this.client.clientProfile.HCFHDC ? 1 : 0,
        HCCDYrsDiag: this.client.clientProfile.HCCDYrsDiag ? 1 : 0,
        HCCYrsDiag: this.client.clientProfile.HCCYrsDiag ? 1 : 0,

        HCALZ: this.client.clientProfile.HCALZ ? 1 : 0,
        HCPARK: this.client.clientProfile.HCPARK ? 1 : 0,
        HCAMP: this.client.clientProfile.HCAMP ? 1 : 0,
        HCPTSD: this.client.clientProfile.HCPTSD ? 1 : 0,
        HCOBS: this.client.clientProfile.HCOBS ? 1 : 0,
      }),

      spouseConditions: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.partnerActive ? JSON.stringify({
        HCHBP: this.client.clientProfile.Spouses[0].HCHBP,
        HCHC: this.client.clientProfile.Spouses[0].HCHC,
        HCT2D: this.client.clientProfile.Spouses[0].HCT2D,
        HCCD: this.client.clientProfile.Spouses[0].HCCD,
        HCC: this.client.clientProfile.Spouses[0].HCC,
        HCT: this.client.clientProfile.Spouses[0].HCT,
        HCT1D: this.client.clientProfile.Spouses[0].HCT1D ? 1 : 0,
        HCMS: this.client.clientProfile.Spouses[0].HCMS ? 1 : 0,
        HCDCW: this.client.clientProfile.Spouses[0].HCDCW ? 1 : 0,
        HCFHDC: this.client.clientProfile.Spouses[0].HCFHDC ? 1 : 0,
        HCCDYrsDiag: this.client.clientProfile.Spouses[0].HCCDYrsDiag ? 1 : 0,
        HCCYrsDiag: this.client.clientProfile.Spouses[0].HCCYrsDiag ? 1 : 0,

        HCALZ: this.client.clientProfile.Spouses[0].HCALZ ? 1 : 0,
        HCPARK: this.client.clientProfile.Spouses[0].HCPARK ? 1 : 0,
        HCAMP: this.client.clientProfile.Spouses[0].HCAMP ? 1 : 0,
        HCPTSD: this.client.clientProfile.Spouses[0].HCPTSD ? 1 : 0,
        HCOBS: this.client.clientProfile.Spouses[0].HCOBS ? 1 : 0,
      }) : "",

      SelfLifeExpectancy: this.client.clientProfile.LifeExpectancy || 0,
      SpouseLifeExpectancy: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].LifeExpectancy || 0 : 0,

      SpouseFrmQTobacco: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT ? 1 : 0 : 0,
      SpouseFrmQCancer: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCC ? 1 : 0 : 0,
      SpouseFrmQDiet: 1,
      SpouseFrmQCardio: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCCD ? 1 : 0 : 0,
      SpouseFrmQPhysical: 1,
      SpouseFrmGender: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].gender : 0,
      SpouseQHBP: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHBP ? 1 : 0 : 0,
      SpouseFrmQHBP: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHBP ? 1 : 0 : 0,
      SpouseFrmQDCW: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCDCW ? 1 : 0 : 0,
      SpouseFrmQMS: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCMS ? 1 : 0 : 0,
      SpouseCurrentAge: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.calculateAge(this.client.clientProfile.Spouses[0].dob) : 0,
      SpouseFrmQHighColesterol: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHC ? 1 : 0 : 0,
      SpouseFrmQTypeII: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT2D ? 1 : 0 : 0,
      SpouseQExcercise: 1,
      SpouseQHistory: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCFHDC ? 1 : 0 : 0,

      SpouseQHighColesterol: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHC ? 1 : 0 : 0,
      SpouseQTypeII: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT2D ? 1 : 0 : 0,
      SpouseFrmQType: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT1D ? 1 : 0 : 0,

      SpouseFrmQAlzheimer: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCALZ ? 1 : 0 : 0,
      SpouseFrmQParkinson: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCPARK ? 1 : 0 : 0,
      SpouseFrmQPTSD: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCPTSD ? 1 : 0 : 0,
      SpouseFrmQAmputation: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCAMP ? 1 : 0 : 0,
      SpouseFrmQObesity: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCOBS ? 1 : 0 : 0,

      PaymentTotal: 0,
      //PaymentYears: this.annualEl && this.annualEl.nativeElement ? this.annualEl.nativeElement.value : 10,
      PaymentYears: (this.investmentOption == 1) ? this.annualEl && this.annualEl.nativeElement ? this.annualEl.nativeElement.value : (this.annuallyWeeklyTtlYear < 10 ? 1 : 10) 
        : (this.investmentOption == 2) ? this.bodyCardSelectedIndexAnnually : this.bodyCardSelectedIndexWeekly,

      // FrmIncome: 'Ind1',

      FrmPhase1Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorOne)) : 6,
      FrmPhase1Periods: this.objAdjustRates ? Number(this.objAdjustRates.throughYearOne) : Math.max(65 - Number(this.calculateAge(this.client.client.DOB))),
      FrmPhase2Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorTwo)) : 6,
      FrmPhase2Periods: this.objAdjustRates ? (Number(this.objAdjustRates.throughYearTwo)) : 10,
      FrmPhase3Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorThree)) : 6,

      // FrmRetireYear1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? Math.max(currentYear,this.getRetirementYear(this.client.clientProfile.Spouses[0].retirementAge, this.client.clientProfile.Spouses[0].dob)) : 0,
      FrmRetireYear1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? Math.max(currentYear,this.getRetirementYear(this.spouseRetirementAge, this.client.clientProfile.Spouses[0].dob)) : 0,
      //FrmRetireYear1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? Math.max(currentYear,this.getRetirementYear(this.client.clientProfile.Spouses[0].retirementAge, this.client.clientProfile.Spouses[0].dob)) : 0,
      
      FrmPV: this.FrmPV,
      // FrmRetireYear0: Math.max(currentYear, this.getRetirementYear(this.client.clientProfile.RetirementAge, this.client.client.DOB)),
      FrmRetireYear0: Math.max(currentYear, this.getRetirementYear(this.retirementAge, this.client.client.DOB)),
      //FrmRetireYear0: Math.max(currentYear, this.getRetirementYear(this.client.clientProfile.RetirementAge, this.client.client.DOB)),

      FrmState: this.client.clientProfile.UseNationalAverage ? '' : this.client.clientProfile.RetirementState,
      
      //TODO: set/add household income?
      HouseholdYearOneIncome: (this.client.clientProfile.HouseholdYearOneIncome) ? this.client.clientProfile.HouseholdYearOneIncome : null,
      SpouseCurrentIncome: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? Number(this.client.clientProfile.Spouses[0].currentIncome) || 0 : 0,
      SelfCurrentIncome: (this.client.clientProfile.HouseholdYearOneIncome) ? this.client.clientProfile.HouseholdYearOneIncome : (this.client.clientProfile.CurrentIncome != null && this.client.clientProfile.CurrentIncome != undefined) ? this.client.clientProfile.CurrentIncome : 0,
      Bracket: (!this.client.clientProfile.CurrentIncome) ? this.client.clientProfile.Bracket : null,
      MAGI: (this.client.clientProfile.MAGIPercentIncome == null) ? 100 : this.client.clientProfile.MAGIPercentIncome,

      SelfIRR: (this.client.clientProfile.IRR != null && this.client.clientProfile.IRR != undefined) ? this.client.clientProfile.IRR : 0,
      InvestmentOption: this.investmentOption || 1,
      UseNationalAverage: this.client.clientProfile.UseNationalAverage ? 1 : 0,
      SpouseDOB: spouseDOB,

      ClientPIA: this.client.clientProfile.PIA,
      SelfPIA: (this.client.clientProfile.PIA) ? this.client.clientProfile.PIA : 0,
      SpousePIA: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? Number(this.client.clientProfile.Spouses[0].pia) || 0 : 0,
      MaritalState: this.client.clientProfile.Spouses[0].maritalStatus,
      PreRetirementInflationRate: (this.client.clientProfile.InflationRate == null) ? 0.03 : this.client.clientProfile.InflationRate / 100,
      InRetirementInflationRate: (this.client.clientProfile.InRetirementInflationRate == null) ? 0.03 : this.client.clientProfile.InRetirementInflationRate / 100,
      
      FrmState1: this.client.clientProfile.Spouses[0].state || '',
      SelfDOB: this.client.client.DOB,
      // SelfRetirementAge: this.client.clientProfile.RetirementAge,
      SelfRetirementAge: this.retirementAge,
      IsClientRetireEarly: (this.client.clientProfile.RetirementAge < 65),
      // SpouseRetirementAge: this.client.clientProfile.Spouses[0].retirementAge,
      SpouseRetirementAge: this.spouseRetirementAge,
      IsSpouseRetireEarly: (this.client.clientProfile.Spouses[0].retirementAge < 65),

      //TODO: set up for different plans for different clients
      SelfSupplementalPlan: (this.profileInfo.value.supplementalPlanType) ? this.profileInfo.value.supplementalPlanType : (this.client.clientProfile.SelfSupplementalPlan) ? this.client.clientProfile.SelfSupplementalPlan : "G",
      SpouseSupplementalPlan:  (this.partnerActive) ? (this.spouseProfileInfo.value.supplementalPlanType) ? this.spouseProfileInfo.value.supplementalPlanType : (this.client.clientProfile.SpouseSupplementalPlan) ? this.client.clientProfile.SpouseSupplementalPlan : "G" : "",

      MidRetAdjYear: this.client.midRetirementAdj ? this.client.midRetirementAdj.Year : 0,
      MidRetRedPer:  this.client.midRetirementAdj ? this.client.midRetirementAdj.ReductionPerc : 0,// / 100 : 0,
      MidRetRedDollar:  this.client.midRetirementAdj ? this.client.midRetirementAdj.ReductionDollar : 0,
      MidRetIncomeInflationRate: this.client.midRetirementAdj ? (this.client.midRetirementAdj.IncomeInflationRate) : 0,// / 100 : 0,
    }

    if (includeSpouse)
      spouse = client.clientProfile.Spouses[0];

    this.client.retirementState = this.client.state;
    // to get the commercial insurance
    // HCReport.P_Part_A_And_B = this.isPre65 && (this.profileInfo.value.inRetirementCoverageType == 'TM') ? 1 : HCReport.P_Part_A_And_B;
    // if (includeSpouse) {
    //   HCReport.P_Part_A_And_B1 = this.isSpousePre65 && (this.spouseProfileInfo.value.inRetirementCoverageType == 'TM') ? 1 : HCReport.P_Part_A_And_B1;
    // }

    //P_Part_A_And_B is required for SS deductions
    //and right now you can only turn off P_Part_A_And_B in TM, all other premium types lock/disable it
    if(this.profileInfo.value.inRetirementCoverageType != 'TM'){
      HCReport.P_Part_A_And_B = 1;
    }

    if (includeSpouse) {
      console.log('here i am 01')
      if(this.spouseProfileInfo.value.inRetirementCoverageType != 'TM'){
        console.log('here i am 02')
        HCReport.P_Part_A_And_B1 = 1;
      }
    }

    if(this.globalService.featRiskTolerance && useRiskTolSingleInvestment){
      HCReport.FrmPhase1Rate = (this.objAdjustRates) ? this.objAdjustRates.rorOne : (this.portfolioRecommendationObject.phase1Val ? Number(this.portfolioRecommendationObject.phase1Val):0);
      HCReport.FrmPhase1Periods = (this.objAdjustRates) ? this.objAdjustRates.throughYearOne : this.getPhaseAgeDiff(1);
      HCReport.FrmPhase2Rate = (this.objAdjustRates) ? this.objAdjustRates.rorTwo : (this.portfolioRecommendationObject.phase2Val ? Number(this.portfolioRecommendationObject.phase2Val):0);
      HCReport.FrmPhase2Periods = (this.objAdjustRates) ? this.objAdjustRates.throughYearTwo : this.getPhaseAgeDiff(2);
      HCReport.FrmPhase3Rate = (this.objAdjustRates) ? this.objAdjustRates.rorThree : (this.portfolioRecommendationObject.phase2Val ? Number(this.portfolioRecommendationObject.phase2Val):0);

      if (this.isAlreadyRetired) {
        HCReport.FrmPhase2Rate = HCReport.FrmPhase1Rate;
        HCReport.FrmPhase2Periods = Number(this.client.clientProfile.LifeExpectancy) - Number(this.client.clientProfile.RetirementAge);
        HCReport.FrmPhase3Rate = HCReport.FrmPhase1Rate;
      }
    }

    this.HCReport = HCReport;

    var user = {
      UserID: Number(localStorage.getItem('roleId')) <= 2 ? localStorage.getItem('selectedAdvisorID') : localStorage.getItem('userId'),
      CompanyCode: Number(localStorage.getItem('roleId')) <= 2 ? localStorage.getItem('selectedAdvisorOrgID') : localStorage.getItem('orgID'),
      ClientID: localStorage.getItem('selectedClient')
    }
    this.user = user;
    console.log('HCReport', HCReport)
    this.globalService.getHCDataV2(HCReport, user)
      .subscribe(
        data => {
          this.hcDataV2 = data;
          console.log('hcDataV2', this.hcDataV2)
          this.onCheckBoxChange('client');
          if (this.partnerActive) {
            let date = new Date();
            let spouseRetirementAge = Number(this.client.clientProfile.Spouses[0].retirementAge);
            let spouseAge =  Number(this.globalService.calculateAge(client.clientProfile.Spouses[0].dob));
            console.log('date.getFullYear()', date.getFullYear());
            console.log('spouseRetirementAge', spouseRetirementAge);
            this.spouseRetirementYear = Number(date.getFullYear()) + (spouseRetirementAge > spouseAge ? (spouseRetirementAge - spouseAge): 0);
            // spouseRetirementAge > spouseAge ? (spouseRetirementAge - spouseAge) : 0;
            this.onCheckBoxChange('spouse');
          }
          this.hcDataV2.IllustrationEntriesWithFunding = JSON.parse(this.hcDataV2.IllustrationEntriesWithFunding);

          // if (!this.isPre65 && !this.isSpousePre65) {
          //   this.hcDataV2.IllustrationEntriesWithFunding = JSON.parse(this.hcDataV2.IllustrationEntriesWithFunding);
          // } else {
          //   this.hcDataV2.IllustrationEntriesWithFunding = JSON.parse(this.hcDataV2.IllustrationEntriesWithFunding);
          // }
          
          this.p1CostsV2 = JSON.parse(this.FrmPV == 0 ? data.P1HealthCareExpensesDiscounted : data.P1HealthCareExpenses);
          this.p2CostsV2 = this.partnerActive ? JSON.parse(this.FrmPV == 0 ? data.P2HealthCareExpensesDiscounted : data.P2HealthCareExpenses) : {};
          this.tempCostsV2 = this.p1CostsV2;

          console.log('p1costsv2', this.p1CostsV2);
          console.log('p2CostsV2', this.p2CostsV2);

          //Commented out: was causing page breaking issues with couples
          //not sure why it exists tbh
          /* if (this.p1CostsV2[0].Total == 0) {
            var tempCosts = [];

            for (var item in this.p2CostsV2) {
              if (this.p2CostsV2[item].Total != 0) {
                tempCosts.push(this.p2CostsV2[item]);
              }
            }

            this.p1CostsV2 = tempCosts;
          } */
          
          var clientIndex = 0;
          var spouseIndex = 0;
          
          //console.log('11', this.p1CostsV2);
          // this.hcDataV2.RetirementYear = Math.max(currentYear, this.getRetirementYear(this.client.clientProfile.RetirementAge, this.client.client.DOB));
          this.hcDataV2.RetirementYear = Math.max(currentYear, this.getRetirementYear(this.retirementAge, this.client.client.DOB));

          // check index for client is spouse retires earlier
          if (this.client.clientProfile.Spouses && this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {
            //this.hcDataV2.RetirementYear = Math.max(currentYear, this.getRetirementYear(this.client.clientProfile.RetirementAge, this.client.client.DOB));
            if(this.spouseRetirementYear < this.hcDataV2.RetirementYear){
              clientIndex = (this.hcDataV2.RetirementYear - this.spouseRetirementYear);
              this.clientIndex = clientIndex;
              console.log('clientIndex', this.clientIndex);
            } else {
              spouseIndex = (this.spouseRetirementYear - this.hcDataV2.RetirementYear);
              this.spouseIndex = spouseIndex;
              console.log('spouseIndex', this.spouseIndex);
            }       
          }

          console.log('spouseIndex', spouseIndex);
          
          this.hcDataV2.TotalYear1OOP = Utils.formatToCurrency((this.p1CostsV2[clientIndex].AdditionalOOP[0] + this.p1CostsV2[clientIndex].AdditionalOOP[1] + this.p1CostsV2[clientIndex].AdditionalOOP[2] + this.p1CostsV2[clientIndex].AdditionalOOP[3]).toFixed(0));
          //this.partnerActive ? (this.p1CostsV2[0].AdditionalOOP[0] + this.p1CostsV2[0].AdditionalOOP[1] + this.p1CostsV2[0].AdditionalOOP[2] + this.p1CostsV2[0].AdditionalOOP[3] + this.p2CostsV2[0].AdditionalOOP[0] + this.p2CostsV2[0].AdditionalOOP[1] + this.p2CostsV2[0].AdditionalOOP[2] + this.p2CostsV2[0].AdditionalOOP[3]).toFixed(0) : (this.p1CostsV2[0].AdditionalOOP[0] + this.p1CostsV2[0].AdditionalOOP[1] + this.p1CostsV2[0].AdditionalOOP[2] + this.p1CostsV2[0].AdditionalOOP[3]).toFixed(0);
          // this.hcDataV2.TotalYear1Premiums = Utils.formatToCurrency((this.p1CostsV2[0].Premiums[0] + this.p1CostsV2[0].Premiums[1] + this.p1CostsV2[0].Premiums[2] + this.p1CostsV2[0].Premiums[3]).toFixed(0));//this.partnerActive ? (this.p1CostsV2[0].Premiums[0] + this.p1CostsV2[0].Premiums[1] + this.p1CostsV2[0].Premiums[2] + this.p1CostsV2[0].Premiums[3] + this.p2CostsV2[0].Premiums[0] + this.p2CostsV2[0].Premiums[1] + this.p2CostsV2[0].Premiums[2] + this.p2CostsV2[0].Premiums[3]).toFixed(0) : (this.p1CostsV2[0].Premiums[0] + this.p1CostsV2[0].Premiums[1] + this.p1CostsV2[0].Premiums[2] + this.p1CostsV2[0].Premiums[3]).toFixed(0);
          this.hcDataV2.TotalYear1Premiums = Utils.formatToCurrency((this.p1CostsV2[clientIndex].Premiums[0] + this.p1CostsV2[clientIndex].Premiums[1] + this.p1CostsV2[clientIndex].Premiums[2] + this.p1CostsV2[clientIndex].Premiums[3]).toFixed(0));
          //console.log('13');
          this.hcDataV2.YearOneTotal = Utils.formatToCurrency((this.p1CostsV2[clientIndex].AdditionalOOP[0] 
            + this.p1CostsV2[clientIndex].AdditionalOOP[1] 
            + this.p1CostsV2[clientIndex].AdditionalOOP[2] 
            + this.p1CostsV2[clientIndex].AdditionalOOP[3]
            + this.p1CostsV2[clientIndex].Premiums[0] 
            + this.p1CostsV2[clientIndex].Premiums[1] 
            + this.p1CostsV2[clientIndex].Premiums[2] 
            + this.p1CostsV2[clientIndex].Premiums[3]).toFixed(0));
                    
          if (this.client.clientProfile.Spouses && this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {

            //this.hcDataV2.RetirementYear = Math.min(this.hcDataV2.RetirementYear, this.getRetirementYear(this.client.clientProfile.Spouses[0].retirementAge, this.client.clientProfile.Spouses[0].dob));
            //this.hcDataV2.RetirementYear = Math.max(currentYear, this.hcDataV2.RetirementYear);

            // this.hcDataV2.RetireYear = Math.min(this.hcDataV2.RetirementYear, this.getRetirementYear(this.client.clientProfile.Spouses[0].retirementAge, this.client.clientProfile.Spouses[0].dob));
            this.hcDataV2.RetireYear = Math.min(this.hcDataV2.RetirementYear, this.getRetirementYear(this.spouseRetirementAge, this.client.clientProfile.Spouses[0].dob));
            this.hcDataV2.RetireYear = Math.max(currentYear, this.hcDataV2.RetireYear);

            this.hcDataV2.TotalYear1OOP1 = Utils.formatToCurrency((this.p2CostsV2[spouseIndex].AdditionalOOP[0] + this.p2CostsV2[spouseIndex].AdditionalOOP[1] + this.p2CostsV2[spouseIndex].AdditionalOOP[2] + this.p2CostsV2[spouseIndex].AdditionalOOP[3]).toFixed(0));
            this.hcDataV2.TotalYear1Premiums1 = Utils.formatToCurrency((this.p2CostsV2[spouseIndex].Premiums[0] + this.p2CostsV2[spouseIndex].Premiums[1] + this.p2CostsV2[spouseIndex].Premiums[2] + this.p2CostsV2[spouseIndex].Premiums[3]).toFixed(0));
            //console.log('13');      
            
            this.hcDataV2.YearOneTotal1 = Utils.formatToCurrency((this.p2CostsV2[spouseIndex].AdditionalOOP[0] 
              + this.p2CostsV2[spouseIndex].AdditionalOOP[1] 
              + this.p2CostsV2[spouseIndex].AdditionalOOP[2] 
              + this.p2CostsV2[spouseIndex].AdditionalOOP[3]
              + this.p2CostsV2[spouseIndex].Premiums[0] 
              + this.p2CostsV2[spouseIndex].Premiums[1] 
              + this.p2CostsV2[spouseIndex].Premiums[2] 
              + this.p2CostsV2[spouseIndex].Premiums[3]).toFixed(0));

          }
          
          if(this.hcDataV2.IncomeCompareAnalysis != null){
            this.hcDataV2.IncomeCompareAnalysis = JSON.parse(this.hcDataV2.IncomeCompareAnalysis);
            this.hcDataV2.IncomeCompareAnalysis.incomeCompareRows.shift();
          }

          this.futureTotalCost = Number(this.hcDataV2.TotalProjectedCost.toString().replace(/,/g, "").replace("$", ""));
          console.log('this.futureTotalCost', this.futureTotalCost)
          this.projectedFutureLifetimeCosts = Number(this.hcDataV2.TotalProjectedCostPv.toString().replace(/,/g, "").replace("$", ""));
          //console.log('14');

          this.totalSocialSecurity = Number(this.hcDataV2.FundingOptions.PartB.toString().replace(/,/g, "").replace("$", ""));

          this.totalInvestment = this.totalSocialSecurity + this.additionalFunds;

          this.hcDataV2.Illustrations = JSON.parse(this.hcDataV2.Illustrations);
          //console.log('15');

          this.totalRemainingGap = Number(this.hcDataV2.Illustrations[0].BeginningBalance); //Number(this.hcDataV2.FundingOptions.InvestmentAmountCoverage.toString().replace(",","").replace("$",""));
          
          // this.currentRemainingTotal = Utils.formatToCurrency(this.futureTotalCost - this.totalSocialSecurity);
          // this.currentRemainingTotal = this.futureTotalCost - this.totalSocialSecurity;
          this.currentRemainingTotal = this.futureTotalCost - this.totalInvestment;
          this.currentRemainingTotal = Number(this.currentRemainingTotal) < 0 ? 0: this.currentRemainingTotal;
          if(this.addFunds){
            //if in here, Additional Funds were added
            this.currentRemainingTotal = this.formatNumber((this.currentRemainingTotal - Number(this.contributionAmount) > 0) ? (this.currentRemainingTotal - Number(this.contributionAmount)) : 0);
          }

          if (this.fundingItems.length > 0) {
            var tempTotal = this.futureTotalCost - this.totalSocialSecurity;

            for (var i = 0; i < this.fundingItems.length; i++) {
              this.fundingItems[i].remainingUnfunded = this.fundingItems[i - 1] ? this.fundingItems[i - 1].remainingUnfunded - this.fundingItems[i].contributionAmount : tempTotal - this.fundingItems[i].contributionAmount;
            }

          }
          
          //console.log('16');
          // this.yearlyCost = this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0) < 1 ? Utils.formatToCurrency(0): this.hcDataV2.FundingOptions.CalcPayments.AnnualPaymentAmount;
          this.yearlyCost = this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0) < 1 ? 0: Utils.removeCurrencyFormatting(this.hcDataV2.FundingOptions.CalcPayments.AnnualPaymentAmount);
          console.log('yearlyCost', this.yearlyCost);
          console.log('this.annuallyWeeklyTtlYear', this.annuallyWeeklyTtlYear);
          this.futureYearlyCost = Number(this.yearlyCost) * (this.annuallyWeeklyTtlYear >= 10 ? 10: this.annuallyWeeklyTtlYear);
          console.log('future yearly', this.futureYearlyCost);
          // this.futureYearlyCost = this.annualEl ? this.hcDataV2.FundingOptions.CalcPayments.AnnualPaymentAmount.toString().replace(/,/g, "").replace("$", "") * this.annualEl.nativeElement.value : this.hcDataV2.FundingOptions.CalcPayments.AnnualPaymentAmount.toString().replace(/,/g, "").replace("$", "") * 10;
          // this.weeklyCost = Utils.formatToCurrency(this.annualEl ? Number(((Number(this.futureYearlyCost) / this.annualEl.nativeElement.value) / 52).toFixed(0)) : Number(((Number(this.futureYearlyCost) / 10) / 52).toFixed(0)));
          this.weeklyCost = this.annualEl ? Number(((Number(this.futureYearlyCost) / this.annualEl.nativeElement.value) / 52).toFixed(0)) : Number(((Number(this.futureYearlyCost) / 10) / 52).toFixed(0));
          // this.futureWeeklyCost = this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0) < 1 ? Utils.formatToCurrency(0) :Utils.removeCurrencyFormatting(this.hcDataV2.FundingOptions.CalcPayments.WeeklyPaymentAmount) * 52 * (this.annualEl ? this.annualEl.nativeElement.value : (this.annuallyWeeklyTtlYear < 10 ? 1 : 10));
          this.futureWeeklyCost  = Number(this.weeklyCost) * 52 * ((this.annuallyWeeklyTtlYear >= 10 ? 10: this.annuallyWeeklyTtlYear));
          console.log('futureYearlyCost',this.hcDataV2.FundingOptions.CalcPayments.AnnualPaymentAmount);

          // this.futureYearlyCost = Utils.formatToCurrency(this.futureYearlyCost);
          // this.beginningBalance = Utils.formatToCurrency(this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0));
          this.beginningBalance = this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0);
          if(this.globalService.featRiskTolerance && useRiskTolSingleInvestment){
            this.portfolioRecommendationObject.singleInvestment = this.beginningBalance;
          }
          
          console.log('this.hcDataV2',this.hcDataV2);
          this.generateLineChartData({});
          this.generatePieChartData();
          this.generateBarChartData();
          this.getInvestmentGrowthData();
          this.getMMTData();

          // this.totalYear1Premiums = this.hcDataV2.TotalYear1Premiums;
          // this.spouseTotalYear1Premiums = this.hcDataV2.TotalYear1Premiums1 || 0;
          // this.loadingService.isLoading(false);
          
          // if Pre65 call again getHCData() to reload the graph on the basis of selected Medicare
          console.log('Pre65', this.isPre65, this.isSpousePre65)
          // if (this.isPre65 || this.isSpousePre65) {
          //   this.getHCDataCopy(this.client, this.partnerActive)
          // } else {
          //   // this.getInvestmentGrowthData();
          //   let p1CostsV2 = this.p1CostsV2;
          //   let p2CostsV2 = this.p2CostsV2;
          //   console.log('p1Costs', p1CostsV2[0].Premiums[0], p1CostsV2[0].Premiums[1], p1CostsV2[0].Premiums[2], p1CostsV2[0].Premiums[3]);
          //   var p1Costs = p1CostsV2[0].Premiums[0] + p1CostsV2[0].Premiums[1] + p1CostsV2[0].Premiums[2] + p1CostsV2[0].Premiums[3];
          //   var p2Costs = this.partnerActive ? p2CostsV2[0].Premiums[0] + p2CostsV2[0].Premiums[1] + p2CostsV2[0].Premiums[2] + p2CostsV2[0].Premiums[3] : 0;
          //   this.hcDataV2.TotalYear1Premiums = Utils.formatToCurrency((p1Costs).toFixed(0));
          //   this.hcDataV2.TotalYear1Premiums1 = this.partnerActive ? Utils.formatToCurrency((p2Costs).toFixed(0)): null;

          //   this.totalYear1Premiums = this.hcDataV2.TotalYear1Premiums;
          //   this.spouseTotalYear1Premiums = this.hcDataV2.TotalYear1Premiums1 || 0;
          //   this.year1Total = this.hcDataV2.YearOneTotal;
          //   this.spouseYear1Total = this.hcDataV2.YearOneTotal1;
          //   this.loadingService.isLoading(false);
          // }
          let p1CostsV2 = this.p1CostsV2;
          let p2CostsV2 = this.p2CostsV2;
          console.log('p1Costs', p1CostsV2[clientIndex].Premiums[0], p1CostsV2[clientIndex].Premiums[1], p1CostsV2[clientIndex].Premiums[2], p1CostsV2[clientIndex].Premiums[3]);
          /* var p1Costs = p1CostsV2[clientIndex].Premiums[0] + p1CostsV2[clientIndex].Premiums[1] + p1CostsV2[clientIndex].Premiums[2] + p1CostsV2[clientIndex].Premiums[3];
          var p2Costs = this.partnerActive ? p2CostsV2[spouseIndex].Premiums[0] + p2CostsV2[spouseIndex].Premiums[1] + p2CostsV2[spouseIndex].Premiums[2] + p2CostsV2[spouseIndex].Premiums[3] : 0;
          this.hcDataV2.TotalYear1Premiums = Utils.formatToCurrency((p1Costs).toFixed(0));
          this.hcDataV2.TotalYear1Premiums1 = this.partnerActive ? Utils.formatToCurrency((p2Costs).toFixed(0)): null;

          this.totalYear1Premiums = this.hcDataV2.TotalYear1Premiums;
          this.spouseTotalYear1Premiums = this.hcDataV2.TotalYear1Premiums1 || 0;          
          this.year1Total = this.hcDataV2.YearOneTotal;
          this.spouseYear1Total = this.hcDataV2.YearOneTotal1; */
          let clientYearsToRetirement = 0;
          let spouseYearsToRetirement = 0;

          if(this.isPre65) {
            var pre65ClientIndex = 0;
            if (this.partnerActive) {
              clientYearsToRetirement = this.client.clientProfile.RetirementAge - this.calculateAge(this.client.client.DOB);
              spouseYearsToRetirement = this.client.clientProfile.Spouses[0].retirementAge - this.calculateAge(this.client.clientProfile.Spouses[0].dob);
              pre65ClientIndex = clientYearsToRetirement > spouseYearsToRetirement ? clientYearsToRetirement - spouseYearsToRetirement: pre65ClientIndex;
              this.pre65ClientIndex = pre65ClientIndex;
            }          
            // this.year1Total = Util.formatToCurrency(Util.removeCurrencyFormatting(this.year1Total) + parseInt((p1CostsV2[pre65ClientIndex].Premiums[0]).toFixed(0)));
            this.pre65Total = Utils.formatToCurrency((p1CostsV2[pre65ClientIndex].Premiums[0]).toFixed(0));
            console.log('pre65 costs', p1CostsV2[pre65ClientIndex]);
            // var pre65ClientIndex = 65 - this.client.clientProfile.RetirementAge;
            // if(this.isSpousePre65 && this.partnerActive){
            //   pre65ClientIndex = (this.client.clientProfile.RetirementAge - this.calculateAge(this.client.client.DOB) > this.client.clientProfile.Spouses[0].retirementAge - this.calculateAge(this.client.clientProfile.Spouses[0].dob))
            //   ? (this.client.clientProfile.RetirementAge - this.calculateAge(this.client.client.DOB)) - (this.client.clientProfile.Spouses[0].retirementAge - this.calculateAge(this.client.clientProfile.Spouses[0].dob))
            //   : (this.client.clientProfile.Spouses[0].retirementAge - this.calculateAge(this.client.clientProfile.Spouses[0].dob)) - (this.client.clientProfile.RetirementAge - this.calculateAge(this.client.client.DOB));
            // }
            // this.year1Total = Util.formatToCurrency(Util.removeCurrencyFormatting(this.year1Total) + parseInt((p1CostsV2[pre65ClientIndex].Premiums[0]).toFixed(0)));
            // this.pre65Total = Utils.formatToCurrency((p1CostsV2[pre65ClientIndex].Premiums[0]).toFixed(0));
          }

          if(this.isSpousePre65 && this.partnerActive){
            var pre65SpouseIndex = 0;
            clientYearsToRetirement = this.client.clientProfile.RetirementAge - this.calculateAge(this.client.client.DOB);
            spouseYearsToRetirement = this.client.clientProfile.Spouses[0].retirementAge - this.calculateAge(this.client.clientProfile.Spouses[0].dob);
            pre65SpouseIndex = spouseYearsToRetirement > clientYearsToRetirement ? spouseYearsToRetirement - clientYearsToRetirement: pre65SpouseIndex;
            this.pre65SpouseIndex == pre65SpouseIndex;
            // if(this.spouseProfileInfo.value.privateHealthInsurance || this.spouseProfileInfo.value.preRetirementCoverageType){
            //   this.spouseYear1Total = Util.formatToCurrency(Util.removeCurrencyFormatting(this.spouseYear1Total) + parseInt((p2CostsV2[pre65SpouseIndex].Premiums[0]).toFixed(0)));
            // }
            this.spousePre65Total = this.partnerActive ? Utils.formatToCurrency((p2CostsV2[pre65SpouseIndex].Premiums[0]).toFixed(0)): 0;
            console.log('pre65 spouse costs', p2CostsV2[pre65SpouseIndex]);
          }

          // if(this.isSpousePre65 && this.partnerActive){
          //   var pre65SpouseIndex = 65 - this.client.clientProfile.Spouses[0].retirementAge;
          //   if(this.isPre65 && (this.client.clientProfile.RetirementAge - this.calculateAge(this.client.client.DOB) < this.client.clientProfile.Spouses[0].retirementAge - this.calculateAge(this.client.clientProfile.Spouses[0].dob))){
          //     pre65SpouseIndex = (this.client.clientProfile.RetirementAge - this.calculateAge(this.client.client.DOB) > this.client.clientProfile.Spouses[0].retirementAge - this.calculateAge(this.client.clientProfile.Spouses[0].dob))
          //     ? (this.client.clientProfile.RetirementAge - this.calculateAge(this.client.client.DOB)) - (this.client.clientProfile.Spouses[0].retirementAge - this.calculateAge(this.client.clientProfile.Spouses[0].dob))
          //     : (this.client.clientProfile.Spouses[0].retirementAge - this.calculateAge(this.client.clientProfile.Spouses[0].dob)) - (this.client.clientProfile.RetirementAge - this.calculateAge(this.client.client.DOB));
          //   }
          //   this.spouseYear1Total = Util.formatToCurrency(Util.removeCurrencyFormatting(this.spouseYear1Total) + parseInt((p2CostsV2[pre65SpouseIndex].Premiums[0]).toFixed(0)));
          //   this.spousePre65Total = this.partnerActive ? Utils.formatToCurrency((p2CostsV2[pre65SpouseIndex].Premiums[0]).toFixed(0)): 0;
          // }


          var p1Costs = p1CostsV2[((this.isPre65) ? pre65ClientIndex : clientIndex)].Premiums[0] + p1CostsV2[((this.isPre65) ? pre65ClientIndex : clientIndex)].Premiums[1] + p1CostsV2[((this.isPre65) ? pre65ClientIndex : clientIndex)].Premiums[2] + p1CostsV2[((this.isPre65) ? pre65ClientIndex : clientIndex)].Premiums[3];
          if(this.profileInfo.value.medicareAdvPPO || this.profileInfo.value.medicareAdvHMO){
            if(this.profileInfo.value.medicareAdvPPO == true || this.profileInfo.value.medicareAdvHMO == true){
              p1Costs += p1CostsV2[clientIndex].PartDSurcharge;
            }
          }
          
          var p2Costs = this.partnerActive ? p2CostsV2[((this.isSpousePre65) ? pre65SpouseIndex : spouseIndex)].Premiums[0] + p2CostsV2[((this.isSpousePre65) ? pre65SpouseIndex : spouseIndex)].Premiums[1] + p2CostsV2[((this.isSpousePre65) ? pre65SpouseIndex : spouseIndex)].Premiums[2] + p2CostsV2[((this.isSpousePre65) ? pre65SpouseIndex : spouseIndex)].Premiums[3] : 0;
          if(this.spouseProfileInfo){
            if(this.spouseProfileInfo.value.medicareAdvPPO || this.spouseProfileInfo.value.medicareAdvHMO){
              if(this.spouseProfileInfo.value.medicareAdvPPO == true || this.spouseProfileInfo.value.medicareAdvHMO == true){
                p2Costs += p2CostsV2[spouseIndex].PartDSurcharge;
              }
            }
          }

          this.hcDataV2.TotalYear1OOP = Utils.formatToCurrency((this.p1CostsV2[((this.isPre65) ? pre65ClientIndex : clientIndex)].AdditionalOOP[0] + this.p1CostsV2[((this.isPre65) ? pre65ClientIndex : clientIndex)].AdditionalOOP[1] + this.p1CostsV2[((this.isPre65) ? pre65ClientIndex : clientIndex)].AdditionalOOP[2] + this.p1CostsV2[((this.isPre65) ? pre65ClientIndex : clientIndex)].AdditionalOOP[3]).toFixed(0));          
          this.hcDataV2.TotalYear1Premiums = Utils.formatToCurrency((p1Costs).toFixed(0));

          this.hcDataV2.TotalYear1OOP1 = !this.partnerActive ? null : Utils.formatToCurrency((this.p2CostsV2[((this.isSpousePre65) ? pre65SpouseIndex : spouseIndex)].AdditionalOOP[0] + this.p2CostsV2[((this.isSpousePre65) ? pre65SpouseIndex : spouseIndex)].AdditionalOOP[1] + this.p2CostsV2[((this.isSpousePre65) ? pre65SpouseIndex : spouseIndex)].AdditionalOOP[2] + this.p2CostsV2[((this.isSpousePre65) ? pre65SpouseIndex : spouseIndex)].AdditionalOOP[3]).toFixed(0));
          this.hcDataV2.TotalYear1Premiums1 = this.partnerActive ? Utils.formatToCurrency((p2Costs).toFixed(0)): null;

          this.totalYear1Premiums = this.hcDataV2.TotalYear1Premiums;
          this.spouseTotalYear1Premiums = this.hcDataV2.TotalYear1Premiums1 || 0;    

          this.year1Total = Util.formatToCurrency(Util.removeCurrencyFormatting(this.hcDataV2.TotalYear1Premiums) + Util.removeCurrencyFormatting(this.hcDataV2.TotalYear1OOP));//this.hcDataV2.YearOneTotal;
          this.spouseYear1Total = Util.formatToCurrency((this.hcDataV2.TotalYear1Premiums1 || this.hcDataV2.TotalYear1OOP1) ? Util.removeCurrencyFormatting(this.hcDataV2.TotalYear1Premiums1) + Util.removeCurrencyFormatting(this.hcDataV2.TotalYear1OOP1) : 0);//this.hcDataV2.YearOneTotal1;

          this.loadingService.isLoading(false);
          // this.loadingService.isLoading(false);

        },
        error => this.error = <any>error);
  }

//   getHCDataCopy(client: any, includeSpouse?: any) {
//     var currentYear = new Date().getFullYear();

//     var spouse = {};

//     var investmentItems = [];
//     console.log('this.fundingItems', this.fundingItems.length)
//     for (var item in this.fundingItems) {

//       var contribution = {
//         Description: this.fundingItems[item].fundingSource,
//         Begins: this.fundingItems[item].startAge,
//         Ends: this.fundingItems[item].endAge,
//         StartAmount: this.fundingItems[item].annContribution,
//         Cola: this.fundingItems[item].inflationRate,
//       }
//       //this.additionalFunds += this.fundingItems[item].annContribution;
//       investmentItems.push(contribution);
//     }
//  console.log('this.isPre65', this.isPre65);
//  console.log('this.profileInfo.value.medicareAdvHMO', this.profileInfo.value.medicareAdvHMO)
//  let spouseDOB = this.client.clientProfile.Spouses[0].dobStr ? this.client.clientProfile.Spouses[0].dobStr : (new Date(this.client.clientProfile.Spouses[0].dob) ? this.client.clientProfile.Spouses[0].dob : '');
//     var HCReport = {
//       InvestmentItems: JSON.stringify({ investmentItems }),

//       //client
//       P_Part_A_And_B: (this.profileInfo.value.medicarePartB || this.profileInfo.value.medicareAdvHMO || this.profileInfo.value.medicareAdvPPO) && !this.isPre65 ? 1 : 0,//this.hdt ? this.hdt.nativeElement.checked ? 1 : 0 : 1,
//       P_Part_D: this.profileInfo.value.medicarePartD && !this.isPre65? 1 : 0,//this.pd ? this.pd.nativeElement.checked ? 1 : 0 : 1,
//       P_MediGap: this.profileInfo.value.supplemental && !this.isPre65 ? 1 : 0,//this.si ? this.si.nativeElement.checked ? 1 : 0 : 0,
//       P_Dental: this.profileInfo.value.dental ? 1 : 0,//this.di ? this.di.nativeElement.checked ? 1 : 0 : 0,
//       P_Advantage: ((this.profileInfo.value.medicareAdvHMO && this.profileInfo.value.inRetirementCoverageType == 'HMO') || (this.profileInfo.value.medicareAdvPPO && this.profileInfo.value.inRetirementCoverageType == 'PPO')) && !this.isPre65? 1 : 0,
//       OOP_Hosp_Docs: this.profileInfo.value.hospitalDocsTestsOOP ? 1 : 0,//this.hd ? this.hd.nativeElement.checked ? 1 : 0 : 0,
//       OOP_Presc_Drug: this.profileInfo.value.prescriptionDrugsOOP ? 1 : 0,//this.pdrg ? this.pdrg.nativeElement.checked ? 1 : 0 : 0,
//       OOP_Hearing_Vision: this.profileInfo.value.hearingVisionOOP ? 1 : 0,//this.hvc ? this.hvc.nativeElement.checked ? 1 : 0 : 0,
//       OOP_Dental: this.profileInfo.value.dentalOOP ? 1 : 0,//this.dins ? this.dins.nativeElement.checked ? 1 : 0 : 0,

//       //spouse/partner
//       P_Part_A_And_B1: this.partnerActive ? (this.spouseProfileInfo.value.medicarePartB || this.spouseProfileInfo.value.medicareAdvHMO || this.spouseProfileInfo.value.medicareAdvPPO) && !this.isSpousePre65 ? 1 : 0 : 0,
//       P_Part_D1: this.partnerActive ? this.spouseProfileInfo.value.medicarePartD && !this.isSpousePre65 ? 1 : 0 : 0,
//       P_MediGap1: this.partnerActive ? this.spouseProfileInfo.value.supplemental && !this.isSpousePre65 ? 1 : 0 : 0,
//       P_Dental1: this.partnerActive ? this.spouseProfileInfo.value.dental ? 1 : 0 : 0,
//       P_Advantage1: this.partnerActive ? ((this.spouseProfileInfo.value.medicareAdvHMO && this.spouseProfileInfo.value.inRetirementCoverageType == 'HMO') || (this.spouseProfileInfo.value.medicareAdvPPO && this.spouseProfileInfo.value.inRetirementCoverageType == 'PPO')) && !this.isSpousePre65 ? 1 : 0 : 0,
//       OOP_Hosp_Docs1: this.partnerActive ? this.spouseProfileInfo.value.hospitalDocsTestsOOP ? 1 : 0 : 0,
//       OOP_Presc_Drug1: this.partnerActive ? this.spouseProfileInfo.value.prescriptionDrugsOOP ? 1 : 0 : 0,
//       OOP_Hearing_Vision1: this.partnerActive ? this.spouseProfileInfo.value.hearingVisionOOP ? 1 : 0 : 0,
//       OOP_Dental1: this.partnerActive ? this.spouseProfileInfo.value.dentalOOP ? 1 : 0 : 0,

//       CoverageType: this.profileInfo.value.preRetirementCoverageType == 'PPO' ? 0 : this.profileInfo.value.preRetirementCoverageType == 'HMO' ? 1 : 2,
//       CoverageType1: (this.partnerActive) ? this.spouseProfileInfo.value.preRetirementCoverageType == 'PPO' ? 0 : this.spouseProfileInfo.value.preRetirementCoverageType == 'HMO' ? 1 : 2 : 0,
//       PremiumType: this.profileInfo.value.inRetirementCoverageType == 'TM' ? 0 : this.profileInfo.value.inRetirementCoverageType == 'HMO' ? 1 : 2,
//       PremiumType1: (this.partnerActive) ? this.spouseProfileInfo.value.inRetirementCoverageType == 'TM' ? 0 : this.spouseProfileInfo.value.inRetirementCoverageType == 'HMO' ? 1 : 2 : 0,
//       PrivateInsurance: this.profileInfo.value.privateHealthInsurance || false,
//       PrivateInsurance1: (this.partnerActive) ? this.spouseProfileInfo.value.privateHealthInsurance || false : false,

//       FrmName0: this.client.client.FirstName + " " + this.client.client.LastName,
//       FrmName1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].firstName + " " + this.client.clientProfile.Spouses[0].lastName : "",
//       FrmHasPartner: this.partnerActive,
//       FrmQType: this.client.clientProfile.HCT1D,
//       FrmQExcercise: 1,
//       FrmGender: this.client.client.GenderID,
//       FrmQTypeII: this.client.clientProfile.HCT2D,
//       FrmQTobacco: this.client.clientProfile.HCT,
//       FrmQCancer: this.client.clientProfile.HCC,
//       FrmQHistory: this.client.clientProfile.HCFHDC,
//       FrmQMS: this.client.clientProfile.HCMS,
//       FrmQCardio: this.client.clientProfile.HCCD,
//       FrmQPhysical: 1,
//       FrmQHighColesterol: this.client.clientProfile.HCHC,
//       FrmQDiet: 1,
//       FrmQHBP: this.client.clientProfile.HCHBP,

//       FrmQAlzheimer: this.client.clientProfile.HCALZ,
//       FrmQParkinson: this.client.clientProfile.HCPARK,
//       FrmQPTSD: this.client.clientProfile.HCPTSD,
//       FrmQAmputation: this.client.clientProfile.HCAMP,
//       FrmQObesity: this.client.clientProfile.HCOBS,

//       FrmCurrentAge: this.calculateAge(this.client.client.DOB),

//       // FrmPlanUntil: 0,
//       // FrmPlanUntil0: 0,
//       // FrmPlanUntil1: 0,
//       // SpouseFrmPlanUntil: 0,
//       selfConditions: JSON.stringify({
//         HCHBP: this.client.clientProfile.HCHBP,
//         HCHC: this.client.clientProfile.HCHC,
//         HCT2D: this.client.clientProfile.HCT2D,
//         HCCD: this.client.clientProfile.HCCD,
//         HCC: this.client.clientProfile.HCC,
//         HCT: this.client.clientProfile.HCT,
//         HCT1D: this.client.clientProfile.HCT1D ? 1 : 0,
//         HCMS: this.client.clientProfile.HCMS ? 1 : 0,
//         HCDCW: this.client.clientProfile.HCDCW ? 1 : 0,
//         HCFHDC: this.client.clientProfile.HCFHDC ? 1 : 0,
//         HCCDYrsDiag: this.client.clientProfile.HCCDYrsDiag ? 1 : 0,
//         HCCYrsDiag: this.client.clientProfile.HCCYrsDiag ? 1 : 0,

//         HCALZ: this.client.clientProfile.HCALZ ? 1 : 0,
//         HCPARK: this.client.clientProfile.HCPARK ? 1 : 0,
//         HCAMP: this.client.clientProfile.HCAMP ? 1 : 0,
//         HCPTSD: this.client.clientProfile.HCPTSD ? 1 : 0,
//         HCOBS: this.client.clientProfile.HCOBS ? 1 : 0,
//       }),

//       spouseConditions: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.partnerActive ? JSON.stringify({
//         HCHBP: this.client.clientProfile.Spouses[0].HCHBP,
//         HCHC: this.client.clientProfile.Spouses[0].HCHC,
//         HCT2D: this.client.clientProfile.Spouses[0].HCT2D,
//         HCCD: this.client.clientProfile.Spouses[0].HCCD,
//         HCC: this.client.clientProfile.Spouses[0].HCC,
//         HCT: this.client.clientProfile.Spouses[0].HCT,
//         HCT1D: this.client.clientProfile.Spouses[0].HCT1D ? 1 : 0,
//         HCMS: this.client.clientProfile.Spouses[0].HCMS ? 1 : 0,
//         HCDCW: this.client.clientProfile.Spouses[0].HCDCW ? 1 : 0,
//         HCFHDC: this.client.clientProfile.Spouses[0].HCFHDC ? 1 : 0,
//         HCCDYrsDiag: this.client.clientProfile.Spouses[0].HCCDYrsDiag ? 1 : 0,
//         HCCYrsDiag: this.client.clientProfile.Spouses[0].HCCYrsDiag ? 1 : 0,

//         HCALZ: this.client.clientProfile.Spouses[0].HCALZ ? 1 : 0,
//         HCPARK: this.client.clientProfile.Spouses[0].HCPARK ? 1 : 0,
//         HCAMP: this.client.clientProfile.Spouses[0].HCAMP ? 1 : 0,
//         HCPTSD: this.client.clientProfile.Spouses[0].HCPTSD ? 1 : 0,
//         HCOBS: this.client.clientProfile.Spouses[0].HCOBS ? 1 : 0,
//       }) : "",

//       SelfLifeExpectancy: this.client.clientProfile.LifeExpectancy || 0,
//       SpouseLifeExpectancy: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].LifeExpectancy || 0 : 0,

//       SpouseFrmQTobacco: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT ? 1 : 0 : 0,
//       SpouseFrmQCancer: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCC ? 1 : 0 : 0,
//       SpouseFrmQDiet: 1,
//       SpouseFrmQCardio: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCCD ? 1 : 0 : 0,
//       SpouseFrmQPhysical: 1,
//       SpouseFrmGender: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].gender : 0,
//       SpouseQHBP: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHBP ? 1 : 0 : 0,
//       SpouseFrmQHBP: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHBP ? 1 : 0 : 0,
//       SpouseFrmQDCW: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCDCW ? 1 : 0 : 0,
//       SpouseFrmQMS: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCMS ? 1 : 0 : 0,
//       SpouseCurrentAge: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.calculateAge(this.client.clientProfile.Spouses[0].dob) : 0,
//       SpouseFrmQHighColesterol: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHC ? 1 : 0 : 0,
//       SpouseFrmQTypeII: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT2D ? 1 : 0 : 0,
//       SpouseQExcercise: 1,
//       SpouseQHistory: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCFHDC ? 1 : 0 : 0,

//       SpouseQHighColesterol: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHC ? 1 : 0 : 0,
//       SpouseQTypeII: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT2D ? 1 : 0 : 0,
//       SpouseFrmQType: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT1D ? 1 : 0 : 0,

//       SpouseFrmQAlzheimer: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCALZ ? 1 : 0 : 0,
//       SpouseFrmQParkinson: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCPARK ? 1 : 0 : 0,
//       SpouseFrmQPTSD: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCPTSD ? 1 : 0 : 0,
//       SpouseFrmQAmputation: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCAMP ? 1 : 0 : 0,
//       SpouseFrmQObesity: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCOBS ? 1 : 0 : 0,

//       PaymentTotal: 0,
//       PaymentYears: this.annualEl && this.annualEl.nativeElement ? this.annualEl.nativeElement.value : 10,

//       // FrmIncome: 'Ind1',

//       FrmPhase1Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorOne)) : 6,
//       FrmPhase1Periods: this.objAdjustRates ? Number(this.objAdjustRates.throughYearOne) : Math.max(65 - Number(this.calculateAge(this.client.client.DOB))),
//       FrmPhase2Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorTwo)) : 6,
//       FrmPhase2Periods: this.objAdjustRates ? (Number(this.objAdjustRates.throughYearTwo)) : 10,
//       FrmPhase3Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorThree)) : 6,

//       FrmRetireYear1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.getRetirementYear(this.client.clientProfile.Spouses[0].retirementAge, this.client.clientProfile.Spouses[0].dob) : 0,
//       FrmPV: this.FrmPV,
//       FrmRetireYear0: Math.max(currentYear, this.getRetirementYear(this.client.clientProfile.RetirementAge, this.client.client.DOB)),
//       FrmState: this.client.clientProfile.UseNationalAverage ? '' : this.client.clientProfile.RetirementState,
      
//       SpouseCurrentIncome: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? Number(this.client.clientProfile.Spouses[0].currentIncome) || 0 : 0,
//       SelfCurrentIncome: (this.client.clientProfile.CurrentIncome != null && this.client.clientProfile.CurrentIncome != undefined) ? this.client.clientProfile.CurrentIncome : 0,
//       Bracket: (!this.client.clientProfile.CurrentIncome) ? this.client.clientProfile.Bracket : null,

//       SelfIRR: (this.client.clientProfile.IRR != null && this.client.clientProfile.IRR != undefined) ? this.client.clientProfile.IRR : 0,
//       InvestmentOption: this.investmentOption || 1,
//       UseNationalAverage: this.client.clientProfile.UseNationalAverage ? 1 : 0,
//       SpouseDOB: spouseDOB,
//       ClientPIA: this.client.clientProfile.PIA,
//       SpousePIA: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? Number(this.client.clientProfile.Spouses[0].pia) || 0 : 0,
//       FrmState1: this.client.clientProfile.Spouses[0].state || '',
//       SelfDOB: this.client.client.DOB,
//       SelfRetirementAge: this.client.clientProfile.RetirementAge,
//       SpouseRetirementAge: this.client.clientProfile.Spouses[0].retirementAge,
//     }

//     if (includeSpouse)
//       spouse = client.clientProfile.Spouses[0];

//     this.client.retirementState = this.client.state;
//     // to get the commercial insurance
//     HCReport.P_Part_A_And_B = this.isPre65 && ((this.profileInfo.value.preRetirementCoverageType == 'HMO') || (this.profileInfo.value.preRetirementCoverageType == 'PPO') || (this.profileInfo.value.preRetirementCoverageType == 'HDHP'))  ? 1 : HCReport.P_Part_A_And_B;
//     if (includeSpouse) {
//       HCReport.P_Part_A_And_B1 = this.isSpousePre65 && ((this.spouseProfileInfo.value.preRetirementCoverageType == 'HMO') || (this.spouseProfileInfo.value.preRetirementCoverageType == 'PPO') || (this.spouseProfileInfo.value.preRetirementCoverageType == 'HDHP')) ? 1 : HCReport.P_Part_A_And_B1;
//     }

//     //HCReport.P_Part_A_And_B = 1;

//     var user = {
//       UserID: Number(localStorage.getItem('roleId')) <= 2 ? localStorage.getItem('selectedAdvisorID') : localStorage.getItem('userId'),
//       CompanyCode: Number(localStorage.getItem('roleId')) <= 2 ? localStorage.getItem('selectedAdvisorOrgID') : localStorage.getItem('orgID'),
//       ClientID: localStorage.getItem('selectedClient')
//     }
//     console.log('HCReport', HCReport)
//     this.globalService.getHCDataV2(HCReport, user)
//       .subscribe(
//         data => {
//           let hcDataV2 = data;
//           console.log('hcDataV2', hcDataV2)
//           // this.hcDataV2.IllustrationEntriesWithFunding = JSON.parse(hcDataV2.IllustrationEntriesWithFunding)
         
//           this.spouseYear1Total = this.hcDataV2.YearOneTotal1;
//           if(this.isPre65){
//             //HACK: this is a UI hack because something isnt being returned correclty from API
//             //but every call after this works
//             //hcDataV2.YearOneTotal = Util.formatToCurrency(Util.removeCurrencyFormatting(hcDataV2.YearOneTotal) + Util.removeCurrencyFormatting(this.hcDataV2.YearOneTotal));
//             let p1CostsV2 = JSON.parse(this.FrmPV == 0 ? data.P1HealthCareExpensesDiscounted : data.P1HealthCareExpenses);
//             hcDataV2.TotalYear1Premiums = Utils.formatToCurrency((p1CostsV2[0].Premiums[0] + p1CostsV2[0].Premiums[1] + p1CostsV2[0].Premiums[2] + p1CostsV2[0].Premiums[3]).toFixed(0));
//             hcDataV2.TotalYear1OOP = Utils.formatToCurrency((p1CostsV2[0].AdditionalOOP[0] + p1CostsV2[0].AdditionalOOP[1] + p1CostsV2[0].AdditionalOOP[2] + p1CostsV2[0].AdditionalOOP[3]).toFixed(0));
//             hcDataV2.YearOneTotal = Util.formatToCurrency(Util.removeCurrencyFormatting(hcDataV2.TotalYear1Premiums) + Util.removeCurrencyFormatting(hcDataV2.TotalYear1OOP));
//             this.pre65Total = Utils.formatToCurrency((p1CostsV2[0].Premiums[0]).toFixed(0));
//             this.totalYear1Premiums = hcDataV2.TotalYear1Premiums;
//             this.year1Total = hcDataV2.YearOneTotal;
//           } else {
//             let p1CostsV2 = this.p1CostsV2;
//             console.log('p1Costs', p1CostsV2[0].Premiums[0], p1CostsV2[0].Premiums[1], p1CostsV2[0].Premiums[2], p1CostsV2[0].Premiums[3]);
//             var p1Costs = p1CostsV2[0].Premiums[0] + p1CostsV2[0].Premiums[1] + p1CostsV2[0].Premiums[2] + p1CostsV2[0].Premiums[3];
//             this.hcDataV2.TotalYear1Premiums = Utils.formatToCurrency((p1Costs).toFixed(0));
//             this.totalYear1Premiums = this.hcDataV2.TotalYear1Premiums;
//             this.year1Total = this.hcDataV2.YearOneTotal;
//           }

//           if(this.isSpousePre65 && this.partnerActive) {
//             let p2CostsV2 = this.partnerActive ? JSON.parse(this.FrmPV == 0 ? data.P2HealthCareExpensesDiscounted : data.P2HealthCareExpenses) : {};
//             hcDataV2.TotalYear1Premiums1 = this.partnerActive ? Utils.formatToCurrency((p2CostsV2[0].Premiums[0] + p2CostsV2[0].Premiums[1] + p2CostsV2[0].Premiums[2] + p2CostsV2[0].Premiums[3]).toFixed(0)): null;
//             hcDataV2.TotalYear1OOP1 = (this.partnerActive) ? Utils.formatToCurrency((p2CostsV2[0].AdditionalOOP[0] + p2CostsV2[0].AdditionalOOP[1] + p2CostsV2[0].AdditionalOOP[2] + p2CostsV2[0].AdditionalOOP[3]).toFixed(0)) : "";
//             console.log('spouse is pre65 in data copy', this.isSpousePre65);
//             if(this.client.clientProfile.Spouses[0].maritalStatus == 'Married'){
//               //HACK: this is a UI hack because something isnt being returned correclty from API
//               //but every call after this works
//               //hcDataV2.YearOneTotal1 = Util.formatToCurrency(Util.removeCurrencyFormatting(hcDataV2.YearOneTotal1) + Util.removeCurrencyFormatting(this.hcDataV2.YearOneTotal1));
//               hcDataV2.YearOneTotal1 = Utils.formatToCurrency((p2CostsV2[0].AdditionalOOP[0] 
//                 + p2CostsV2[0].AdditionalOOP[1] 
//                 + p2CostsV2[0].AdditionalOOP[2] 
//                 + p2CostsV2[0].AdditionalOOP[3]
//                 + p2CostsV2[0].Premiums[0] 
//                 + p2CostsV2[0].Premiums[1] 
//                 + p2CostsV2[0].Premiums[2] 
//                 + p2CostsV2[0].Premiums[3]).toFixed(0));

//               //hcDataV2.YearOneTotal1 = Util.formatToCurrency(Util.removeCurrencyFormatting(hcDataV2.YearOneTotal1) + Util.removeCurrencyFormatting(this.hcDataV2.YearOneTotal1));
//               hcDataV2.YearOneTotal1 = Util.formatToCurrency(Util.removeCurrencyFormatting(hcDataV2.TotalYear1Premiums1) + Util.removeCurrencyFormatting(hcDataV2.TotalYear1OOP1));
//               this.spousePre65Total = Utils.formatToCurrency((p2CostsV2[0].Premiums[1]).toFixed(0));
//             }
//             this.spouseTotalYear1Premiums = hcDataV2.TotalYear1Premiums1 || 0;
//             console.log('spouseTotalYear1Premiums', this.spouseTotalYear1Premiums);
//             this.spouseYear1Total = hcDataV2.YearOneTotal1;//hcDataV2.YearOneTotal1;
//             console.log('spouseYear1Total', this.spouseYear1Total);      
//           } else {                  
//           let p2CostsV2 = this.p2CostsV2;
//           var p2Costs = this.partnerActive ? p2CostsV2[0].Premiums[0] + p2CostsV2[0].Premiums[1] + p2CostsV2[0].Premiums[2] + p2CostsV2[0].Premiums[3] : 0
//           this.hcDataV2.TotalYear1Premiums1 = this.partnerActive ? Utils.formatToCurrency((p2Costs).toFixed(0)): null;
//           this.spouseTotalYear1Premiums = this.hcDataV2.TotalYear1Premiums1 || 0;
//           }
//           // this.getInvestmentGrowthData();
//           this.loadingService.isLoading(false);
//         },
//         error => this.error = <any>error);
//   }

  // TODO: Make utility file
  /* calculateAge(birthday) {
    birthday = new Date(birthday);
    var ageDifMs = Date.now() - birthday;
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  } */

  calculateAge(birthday) {
    var bday = new Date(birthday);
    var today = new Date();
    return today.getFullYear() - bday.getFullYear();
  }

  getClient() {
    this.globalService.getClientData(Number(localStorage.getItem("selectedClient")), 4)
      .subscribe(
        client => {
          this.client = client;

          if (this.client.clientProfile.LifeExpectancy < this.client.clientProfile.RetirementAge || this.client.clientProfile.LifeExpectancy < 65 && !this.client.clientProfile.IsPrivHealthIns) {
            const dialogRef = this.dialog.open(ProfileNotEligibleComponent, {
              width: '600px',
              height: '250px',
              disableClose: true
            });  
          }

          console.log('this.client', this.client);
          let retirementAge = this.client.clientProfile.RetirementAge;
          console.log('retirementAge', retirementAge)
          console.log('this.globalService.calculateAge(this.client.client.DOB',this.globalService.calculateAge(this.client.client.DOB))
          this.isPre65 = (Number(retirementAge || 0) >= 65 || !this.client.clientProfile.IsPrivHealthIns) ? false 
            : (Number(this.globalService.calculateAge(this.client.client.DOB)) >= 65) ? false 
            : true;
            console.log('this.isPre65', this.isPre65)
          this.clientEligibleForPre65 = Number(retirementAge || 0) >= 65 || (Number(this.globalService.calculateAge(this.client.client.DOB)) >= 65) ? false : true;

          let dOB = new Date(this.client.client.DOB);
          let timeDiff = Math.abs(Date.now() - dOB.getTime());
          let clientAge = Math.floor((timeDiff / (1000 * 3600 * 24))/365.25);

          this.client.clientProfile.Spouses = JSON.parse(this.client.clientProfile.Spouses);

          if (this.client.clientProfile.Spouses.length > 1) {
            this.client.clientProfile.Spouses = Utils.calculateMostProfitableSpouse(this.client, this.client.clientProfile.Spouses);
          }
          let spouseAge = 0;
          let spouseRetirementAge = 0;
          if (this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {
            console.log('here i am');
            this.partnerActive = true;
            spouseAge = Number(this.globalService.calculateAge(client.clientProfile.Spouses[0].dob));
            spouseRetirementAge = Number(client.clientProfile.Spouses[0].retirementAge || 0);
            console.log('spouseAge', spouseAge, spouseRetirementAge);
            this.isSpousePre65 = ((spouseRetirementAge >= 65 || spouseAge >= 65 || !this.client.clientProfile.IsSpousePrivHealthIns) ? false: true);
            this.spouseEligibleForPre65 = Number(spouseRetirementAge || 0) >= 65 || (spouseAge) >= 65 ? false : true;
          } else {
            this.partnerActive = false;
          }

          if (clientAge > retirementAge) {
            console.log('here 01');
            this.isRetired = true;
            let dropDownSelectedIndex = 3;
            let clientLifeExpectance = this.client.clientProfile.LifeExpectancy;
            if (this.partnerActive) {
              if (spouseAge >= spouseRetirementAge) {
                console.log('here 02');
                this.isRetired = true;
              } else {
                console.log('here 03');
                this.isRetired = false;
              }
              let spouseLifeExpectancy = this.client.clientProfile.Spouses[0].LifeExpectancy;
              let spouseLifeRemainingYr = spouseLifeExpectancy - spouseAge;
              let clientLifeRemainingYr = clientLifeExpectance - clientAge;
              if (spouseLifeRemainingYr < clientLifeRemainingYr) {
                this.annuallyWeeklyTtlYear = spouseLifeExpectancy - (spouseAge + 5);
                  if (this.annuallyWeeklyTtlYear < 0) {
                    this.annuallyWeeklyTtlYear = spouseLifeExpectancy - spouseAge;
                  }
              } else {
                if((retirementAge - clientAge) > 1){
                  this.annuallyWeeklyTtlYear = clientLifeExpectance - (clientAge + 5);
                  if (this.annuallyWeeklyTtlYear < 0) {
                    this.annuallyWeeklyTtlYear = clientLifeExpectance - clientAge;
                  }
                } else{
                  this.annuallyWeeklyTtlYear = ((spouseRetirementAge - spouseAge) > 1) ? spouseRetirementAge - spouseAge : 1;
                }
              }

            } else {
              this.annuallyWeeklyTtlYear = clientLifeExpectance - (clientAge + 5);
              if (this.annuallyWeeklyTtlYear < 0) {
                this.annuallyWeeklyTtlYear = clientLifeExpectance - clientAge;
              }
            }

            if (this.annuallyWeeklyTtlYear == 0) {
              dropDownSelectedIndex = 0;
            } else if (this.annuallyWeeklyTtlYear < 3) {
              dropDownSelectedIndex = 1;
            }

            this.dropDownSelectedIndexWeekly = this.dropDownSelectedIndexAnnually = dropDownSelectedIndex;
          } else {
            this.annuallyWeeklyTtlYear = ((retirementAge - clientAge) > 1) ? retirementAge - clientAge : 1;
          }

          this.client.clientProfile.Children = JSON.parse(this.client.clientProfile.Children);

          //reset premiums/OOPs as an object
          this.client.clientProfile.Premiums = JSON.parse(this.client.clientProfile.Premiums);
          this.client.clientProfile.OOPCosts = JSON.parse(this.client.clientProfile.OOPCosts);
          console.log('this.client.clientProfile.Premiums.SupplimentalInsurance', this.client.clientProfile.Premiums.SupplimentalInsurance);
          console.log('this.isPre65', this.isPre65);
          // let privateHealthInsurance = this.client.clientProfile.CoverageType ? this.client.clientProfile.IsPrivHealthIns: (this.isPre65 ? 'true':this.client.clientProfile.IsPrivHealthIns);
          let privateHealthInsurance = this.isPre65 && this.client.clientProfile.IsPrivHealthIns ? 'true' : 'false';
          console.log('privateHealthInsurance', privateHealthInsurance)
          let preRetirementCoverageType = this.client.clientProfile.CoverageType ? this.client.clientProfile.CoverageType : (this.isPre65 ? 'HMO':this.client.clientProfile.CoverageType);
          console.log('preRetirementCoverageType', preRetirementCoverageType)
          this.profileInfo = new FormGroup({
            privateHealthInsurance: new FormControl(privateHealthInsurance),
            preRetirementCoverageType: new FormControl(preRetirementCoverageType),
            inRetirementCoverageType: new FormControl(this.client.clientProfile.PremiumType),
            pre65: new FormControl(true),

            //Traditional Medicare (TM)

            medicarePartB: new FormControl((this.client.clientProfile.PremiumType == "TM") ? this.client.clientProfile.Premiums.MedicarePartB : false),
            medicarePartD: new FormControl((this.client.clientProfile.PremiumType == "TM" ) ? this.client.clientProfile.Premiums.MedicarePartD : false),
            supplemental: new FormControl((this.client.clientProfile.PremiumType == "TM") ? this.client.clientProfile.Premiums.SupplimentalInsurance : false),
            supplementalPlanType: new FormControl(this.client.clientProfile.SelfSupplementalPlan),

            //Medicare Adv HMO
            // medicareAdvHMO: new FormControl((this.client.clientProfile.PremiumType == "HMO") ? this.client.clientProfile.Premiums.MedicareAdvantageHMO : false),
            medicareAdvHMO: new FormControl((this.client.clientProfile.PremiumType == "HMO") ? true : false),

            //Medicare Adv PPO
            medicareAdvPPO: new FormControl((this.client.clientProfile.PremiumType == "PPO") ? true : false),

            //always avail
            dental: new FormControl(this.client.clientProfile.Premiums.DentalInsurance),
            hospitalDocsTestsOOP: new FormControl(this.client.clientProfile.OOPCosts.HospitalAndTest),
            prescriptionDrugsOOP: new FormControl(this.client.clientProfile.OOPCosts.PrescriptionDrugs),  
            hearingVisionOOP: new FormControl(this.client.clientProfile.OOPCosts.HearingAndVisionCosts),    
            dentalOOP: new FormControl(this.client.clientProfile.OOPCosts.DentalCosts), 
            //TODO: need to save this new value
            //if runReportWithSpouse is set to TRUE, ignore form spouseProfileInfo
            runReportWithSpouse: new FormControl(this.client.clientProfile.IsHSApplySpouse),
            maritalStatus: new FormControl()
          });
          this.profileInfo.controls['pre65'].disable();

          if(this.partnerActive){
           
            //reset premiums as an object
            this.client.clientProfile.SpousePremiums = JSON.parse(this.client.clientProfile.SpousePremiums);
            this.client.clientProfile.SpouseOOPCosts = JSON.parse(this.client.clientProfile.SpouseOOPCosts);
            console.log('this.client.clientProfile.SpouseCoverageType', this.client.clientProfile.SpouseCoverageType);

            // let spousePrivateHealthInsurance = this.client.clientProfile.SpouseCoverageType ? this.client.clientProfile.IsSpousePrivHealthIns: (this.isSpousePre65 ? 'true':this.client.clientProfile.IsSpousePrivHealthIns);
            //let spousePrivateHealthInsurance = this.isSpousePre65 && this.client.clientProfile.IsSpousePrivHealthIns ? 'true' : 'false';
            let spousePrivateHealthInsurance = this.client.clientProfile.SpouseCoverageType ? this.client.clientProfile.IsSpousePrivHealthIns: (this.isSpousePre65 ? 'true':this.client.clientProfile.IsSpousePrivHealthIns);
            spousePrivateHealthInsurance = spousePrivateHealthInsurance == true ? 'true': (spousePrivateHealthInsurance == false ? 'false': spousePrivateHealthInsurance);
            let spousePreRetirementCoverageType = this.client.clientProfile.SpouseCoverageType ? this.client.clientProfile.SpouseCoverageType : (this.isSpousePre65 ? 'HMO':this.client.clientProfile.SpouseCoverageType);

            this.spouseProfileInfo = new FormGroup({
              privateHealthInsurance: new FormControl(spousePrivateHealthInsurance),
              preRetirementCoverageType: new FormControl(spousePreRetirementCoverageType),
              inRetirementCoverageType: new FormControl(this.client.clientProfile.SpousePremiumType),
              spousePre65: new FormControl(true),

              //Traditional Medicare (TM)
              medicarePartB: new FormControl((this.client.clientProfile.SpousePremiumType == "TM") ? this.client.clientProfile.SpousePremiums.SpouseMedicarePartB : false),
              medicarePartD: new FormControl((this.client.clientProfile.SpousePremiumType == "TM") ? this.client.clientProfile.SpousePremiums.SpouseMedicarePartD : false),
              supplemental: new FormControl((this.client.clientProfile.SpousePremiumType == "TM") ? this.client.clientProfile.SpousePremiums.SpouseSupplimentalInsurance : false),
              supplementalPlanType: new FormControl(this.client.clientProfile.SpouseSupplementalPlan),

              //Medicare Adv HMO
              medicareAdvHMO: new FormControl((this.client.clientProfile.SpousePremiumType == "HMO") ? true : false),

              //Medicare Adv PPO
              medicareAdvPPO: new FormControl((this.client.clientProfile.SpousePremiumType == "PPO") ? true : false),

              //always avail
              dental: new FormControl(this.client.clientProfile.SpousePremiums? this.client.clientProfile.SpousePremiums.SpouseDentalInsurance: null),
              hospitalDocsTestsOOP: new FormControl(this.client.clientProfile.SpouseOOPCosts? this.client.clientProfile.SpouseOOPCosts.SpouseHospitalAndTest: null),
              prescriptionDrugsOOP: new FormControl(this.client.clientProfile.SpouseOOPCosts? this.client.clientProfile.SpouseOOPCosts.SpousePrescriptionDrugs: null),  
              hearingVisionOOP: new FormControl(this.client.clientProfile.SpouseOOPCosts? this.client.clientProfile.SpouseOOPCosts.SpouseHearingAndVisionCosts: null),    
              dentalOOP: new FormControl(this.client.clientProfile.SpouseOOPCosts? this.client.clientProfile.SpouseOOPCosts.SpouseDentalCosts: null),   
              //TODO: need to save this new value
              runReportWithSpouse: new FormControl(this.client.clientProfile.IsHSApplySpouse),
              maritalStatus: new FormControl()
            }); 
            this.spouseProfileInfo.controls['spousePre65'].disable();

            //HACK: if same as client on pageload (because saved to profile)
            //this should be fixed in the HC questionnaire
            /* if(this.client.clientProfile.IsHSApplySpouse){
              this.spouseProfileInfo.setValue(this.profileInfo.value);
              //NOTE: idk if the above would cause an issue with pre65 stuff on spouse, so resetting here
              //cant force spouse to use clients pre retirement stuff if spouse is not retiring before 65 - right?
              this.spouseProfileInfo.controls['privateHealthInsurance'].setValue(spousePrivateHealthInsurance);
              this.spouseProfileInfo.controls['preRetirementCoverageType'].setValue(spousePreRetirementCoverageType);
            } */
          } 

          //HACK
          this.client.clientProfile.HCCDYrsDiag = this.client.clientProfile.HCCDYrsDiag ? 1 : 0;
          this.client.clientProfile.HCCYrsDiag = this.client.clientProfile.HCCYrsDiag ? 1 : 0;

          //display Risk Tol modal
          if(this.isRiskModalDisplayed){
            this.reDirectModal('riskTolerance');
          }

          //need to set spouse to be like client if bool is true
          if(this.profileInfo.value.runReportWithSpouse){
            this.runReportWithSpouse(false);
          } else{
            //get healthcare data
            this.getHCData(client, this.partnerActive);
          }
        },
        error => this.error = <any>error);
  }

  // includePartner(e) {
  //   this.getHCData(this.client, true);
  // }
  

  formatNumber(amount) {
    return Math.round(amount);
  }

  formatNumber2(amount) {
    amount = amount.toFixed(0);
    return Utils.formatToCurrency(amount);
  }

  formatToNumber(amount){
    return Utils.formatToNumber(amount);
  }

  clientHubRedirect(){
    this.router.navigate(['/clients/edit']);
  }

  calcBracket() {
        let isOptionCurrentIncome = (this.client.clientProfile.CurrentIncome && this.client.clientProfile.InflationRate && this.client.clientProfile.IRR) ? true : false;
    // console.log('this.isOptionCurrentIncome ', this.isOptionCurrentIncome)
    let houseHoldYearOneIncome = this.client.clientProfile.HouseholdYearOneIncome ? this.client.clientProfile.HouseholdYearOneIncome : '';

    if ((isOptionCurrentIncome || houseHoldYearOneIncome) && this.client.clientProfile.Bracket == null) {
      this.handleSavingHC();
    } else {
      let currentYear = new Date().getFullYear();

      let clientRetirementYear = Math.max(currentYear, this.getRetirementYear(this.client.clientProfile.RetirementAge, this.client.client.DOB));
      let spouseRetirementYear = this.client.clientProfile.Spouses[0].maritalStatus == 'Married'? this.getRetirementYear(this.client.clientProfile.Spouses[0].retirementAge, this.client.clientProfile.Spouses[0].dob): 0;
      /* if (spouseRetirementYear != 0 && spouseRetirementYear < clientRetirementYear) {
        this.getMMTBracket(spouseRetirementYear > currentYear ? spouseRetirementYear : currentYear);
      } else {
        this.getMMTBracket(clientRetirementYear > currentYear ? clientRetirementYear: currentYear);
      } */
      
      this.getMMTBracket(currentYear);
    }

    // if (!isOptionCurrentIncome && !houseHoldYearOneIncome) {

    // } else {
    //   this.handleSavingHC();
    // }
  }

  handleSavingHC() {

    this.enableControls('client');
    if(this.partnerActive){
      this.enableControls('spouse');
    }    

    var Report = {
      ClientID: this.client.client.ID,
      AdvisorID: this.client.client.AdvisorID,
      CompanyCode: this.client.client.OrganizationID,
      ReportTypeID: 3,
    }
    console.log('this.profileInfo', this.profileInfo)
    console.log('this.spouseProfileInfo', this.spouseProfileInfo)

    var investmentItems = [];

    var investmentItem;

    var currentAge = this.calculateAge(this.client.client.DOB);
    var currentYear = new Date().getFullYear();

    for (var item in this.fundingItems) {

      var contribution = {
        Description: this.fundingItems[item].fundingSource,
        Begins: this.fundingItems[item].startAge,
        StartAmount: this.fundingItems[item].annContribution,
        Ends: this.fundingItems[item].endAge,
        Cola: this.fundingItems[item].inflationRate,
        // ContributionType: 0,
      }

      investmentItems.push(contribution);
    }

    console.log('this.fundingItems', this.fundingItems);
    console.log('this.fundingItems', investmentItems);

    // InvestmentItems: JSON.stringify({ investmentItems }),
    let spouseDOB = this.client.clientProfile.Spouses[0].dobStr ? this.client.clientProfile.Spouses[0].dobStr : (new Date(this.client.clientProfile.Spouses[0].dob) ? this.client.clientProfile.Spouses[0].dob : '');
    let isIncome = (this.client.clientProfile.CurrentIncome && this.client.clientProfile.InflationRate && this.client.clientProfile.IRR) || this.client.clientProfile.HouseholdYearOneIncome ? true : false;
    // console.log('this.isOptionCurrentIncome ', this.isOptionCurrentIncome)
    var ReportHC = {
      // ID: 0,
      InvestmentItems:  JSON.stringify({ investmentItems }),
      /* P_Part_A_And_B: this.hdt ? this.hdt.nativeElement.checked ? 1 : 0 : 1,
      P_Part_D: this.pd ? this.pd.nativeElement.checked ? 1 : 0 : 1,
      P_MediGap: this.si ? this.si.nativeElement.checked ? 1 : 0 : 0,
      P_Dental: this.di ? this.di.nativeElement.checked ? 1 : 0 : 0,
      OOP_Hosp_Docs: this.hd ? this.hd.nativeElement.checked ? 1 : 0 : 0,
      OOP_Presc_Drug: this.pdrg ? this.pdrg.nativeElement.checked ? 1 : 0 : 0,
      OOP_Hearing_Vision: this.hvc ? this.hvc.nativeElement.checked ? 1 : 0 : 0,
      OOP_Dental: this.dins ? this.dins.nativeElement.checked ? 1 : 0 : 0, */

      //client
      P_Part_A_And_B: this.profileInfo.value.medicarePartB ? 1 : 0,//this.hdt ? this.hdt.nativeElement.checked ? 1 : 0 : 1,
      P_Part_D: ((this.profileInfo.value.medicareAdvHMO && this.profileInfo.value.inRetirementCoverageType == 'HMO') || (this.profileInfo.value.medicareAdvPPO && this.profileInfo.value.inRetirementCoverageType == 'PPO')) ? 0 : this.profileInfo.value.medicarePartD ? 1 : 0,//this.pd ? this.pd.nativeElement.checked ? 1 : 0 : 1,
      P_MediGap: this.profileInfo.value.supplemental ? 1 : 0,//this.si ? this.si.nativeElement.checked ? 1 : 0 : 0,
      P_Dental: this.profileInfo.value.dental ? 1 : 0,//this.di ? this.di.nativeElement.checked ? 1 : 0 : 0,
      OOP_Hosp_Docs: this.profileInfo.value.hospitalDocsTestsOOP ? 1 : 0,//this.hd ? this.hd.nativeElement.checked ? 1 : 0 : 0,
      OOP_Presc_Drug: this.profileInfo.value.prescriptionDrugsOOP ? 1 : 0,//this.pdrg ? this.pdrg.nativeElement.checked ? 1 : 0 : 0,
      OOP_Hearing_Vision: this.profileInfo.value.hearingVisionOOP ? 1 : 0,//this.hvc ? this.hvc.nativeElement.checked ? 1 : 0 : 0,
      OOP_Dental: this.profileInfo.value.dentalOOP ? 1 : 0,//this.dins ? this.dins.nativeElement.checked ? 1 : 0 : 0,

      //spouse/partner
      P_Part_A_And_B1: this.partnerActive ? this.spouseProfileInfo.value.medicarePartB ? 1 : 0 : 0,
      P_Part_D1: this.partnerActive ? ((this.spouseProfileInfo.value.medicareAdvHMO && this.spouseProfileInfo.value.inRetirementCoverageType == 'HMO') || (this.spouseProfileInfo.value.medicareAdvPPO && this.spouseProfileInfo.value.inRetirementCoverageType == 'PPO')) ? 0 : this.spouseProfileInfo.value.medicarePartD ? 1 : 0 : 0,
      P_MediGap1: this.partnerActive ? this.spouseProfileInfo.value.supplemental ? 1 : 0 : 0,
      P_Dental1: this.partnerActive ? this.spouseProfileInfo.value.dental ? 1 : 0 : 0,
      OOP_Hosp_Docs1: this.partnerActive ? this.spouseProfileInfo.value.hospitalDocsTestsOOP ? 1 : 0 : 0,
      OOP_Presc_Drug1: this.partnerActive ? this.spouseProfileInfo.value.prescriptionDrugsOOP ? 1 : 0 : 0,
      OOP_Hearing_Vision1: this.partnerActive ? this.spouseProfileInfo.value.hearingVisionOOP ? 1 : 0 : 0,
      OOP_Dental1: this.partnerActive ? this.spouseProfileInfo.value.dentalOOP ? 1 : 0 : 0,

      FrmName0: this.client.client.FirstName + "/" + this.client.client.LastName,
      FrmName1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].firstName + "/" + this.client.clientProfile.Spouses[0].lastName : "",
      FrmHasPartner: this.partnerActive,
      FrmQType: this.client.clientProfile.HCT1D,
      FrmQExcercise: 1,
      FrmGender: this.client.client.GenderID,
      FrmQTypeII: this.client.clientProfile.HCT2D,
      FrmQTobacco: this.client.clientProfile.HCT,
      FrmQCancer: this.client.clientProfile.HCC,
      FrmQHistory: this.client.clientProfile.HCFHDC,
      FrmQCardio: this.client.clientProfile.HCCD,
      FrmQPhysical: 1,
      FrmQHighColesterol: this.client.clientProfile.HCHC,
      FrmQDiet: 1,
      FrmQHBP: this.client.clientProfile.HCHBP,
      FrmQDCW: this.client.clientProfile.HCDCW,
      FrmQMS: this.client.clientProfile.HCMS,

      FrmQAlzheimer: this.client.clientProfile.HCALZ,
      FrmQParkinson: this.client.clientProfile.HCPARK,
      FrmQPTSD: this.client.clientProfile.HCPTSD,
      FrmQAmputation: this.client.clientProfile.HCAMP,
      FrmQObesity: this.client.clientProfile.HCOBS,

      FrmCurrentAge: this.calculateAge(this.client.client.DOB),

      FrmPlanUntil: this.hcDataV2.PlanUntilYear,
      FrmPlanUntil0: this.hcDataV2.PlanUntilYear,
      FrmPlanUntil1: this.hcDataV2.PlanUntil1,
      SpouseFrmPlanUntil: this.hcDataV2.PlanUntil1,

      SpouseFrmQTobacco: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT ? 1 : 0 : 0,
      SpouseFrmQCancer: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCC ? 1 : 0 : 0,
      SpouseFrmQDiet: 1,
      SpouseFrmQCardio: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCCD ? 1 : 0 : 0,
      SpouseFrmQPhysical: 1,
      SpouseFrmGender: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].gender : 0,
      SpouseQHBP: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHBP ? 1 : 0 : 0,
      SpouseFrmQHBP: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHBP ? 1 : 0 : 0,
      SpouseFrmQDCW: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCDCW ? 1 : 0 : 0,
      SpouseFrmQMS: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCMS ? 1 : 0 : 0,

      SpouseCurrentAge: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.calculateAge(this.client.clientProfile.Spouses[0].dob) : 0,
      SpouseFrmQHighColesterol: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHC ? 1 : 0 : 0,
      SpouseQHighColesterol: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHC ? 1 : 0 : 0,
      SpouseQTypeII: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT2D ? 1 : 0 : 0,
      SpouseFrmQType: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT1D ? 1 : 0 : 0,

      SpouseFrmQAlzheimer: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCALZ ? 1 : 0 : 0,
      SpouseFrmQParkinson: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCPARK ? 1 : 0 : 0,
      SpouseFrmQPTSD: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCPTSD ? 1 : 0 : 0,
      SpouseFrmQAmputation: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCAMP ? 1 : 0 : 0,
      SpouseFrmQObesity: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCOBS ? 1 : 0 : 0,


      SpouseQExcercise: 1,
      SpouseQHistory: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCFHDC ? 1 : 0 : 0,

      PaymentTotal: 0,
      //PaymentYears: this.annualEl && this.annualEl.nativeElement ? this.annualEl.nativeElement.value : 10,
      PaymentYears: (this.investmentOption == 1) ? this.annualEl && this.annualEl.nativeElement ? this.annualEl.nativeElement.value : (this.annuallyWeeklyTtlYear < 10 ? 1 : 10) 
        : (this.investmentOption == 2) ? this.bodyCardSelectedIndexAnnually : this.bodyCardSelectedIndexWeekly,

      FrmIncome: this.hcDataV2.FrmIncome,

      FrmPhase1Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorOne)) : 6,
      FrmPhase1Periods: this.objAdjustRates ? Number(this.objAdjustRates.throughYearOne) : Math.max(65 - Number(this.calculateAge(this.client.client.DOB))),
      FrmPhase2Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorTwo)) : 6,
      FrmPhase2Periods: this.objAdjustRates ? (Number(this.objAdjustRates.throughYearTwo)) : 10,
      FrmPhase3Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorThree)) : 6,

      FrmRetireYear1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? Math.max(currentYear,this.getRetirementYear(this.client.clientProfile.Spouses[0].retirementAge, this.client.clientProfile.Spouses[0].dob)) : 0,
      //FrmRetireYear1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? Math.max(currentYear,this.getRetirementYear(this.spouseRetirementAge, this.client.clientProfile.Spouses[0].dob)) : 0,

      FrmPV: this.FrmPV,
      FrmRetireYear0: Math.max(currentYear, this.getRetirementYear(this.client.clientProfile.RetirementAge, this.client.client.DOB)),
      //FrmRetireYear0: Math.max(currentYear, this.getRetirementYear(this.retirementAge, this.client.client.DOB)),

      FrmState: this.client.clientProfile.RetirementState,
      FundCosts: this.futureTotalCost,

      SelfLifeExpectancy: this.client.clientProfile.LifeExpectancy || 0,
      SpouseLifeExpectancy: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].LifeExpectancy || 0 : 0,
      InvestmentOption: this.investmentOption,
      UseNationalAverage: this.client.clientProfile.UseNationalAverage ? 1 : 0,
      SpouseDOB: spouseDOB,
      SelfDOB: this.client.client.DOB,

      SelfRetirementAge: this.client.clientProfile.RetirementAge,
      //SelfRetirementAge: this.retirementAge,
      //IsClientRetireEarly: (this.client.clientProfile.RetirementAge < 65),
      SpouseRetirementAge: this.client.clientProfile.Spouses[0].retirementAge,
      //SpouseRetirementAge: this.spouseRetirementAge,
      //IsSpouseRetireEarly: (this.client.clientProfile.Spouses[0].retirementAge < 65),
      
      MaritalState: this.client.clientProfile.Spouses[0].maritalStatus,

      Bracket: (!this.client.clientProfile.CurrentIncome) ? this.client.clientProfile.Bracket : null,
      HouseholdYearOneIncome: this.client.clientProfile.HouseholdYearOneIncome || 0,
      PreRetirementInflationRate: (this.client.clientProfile.InflationRate == null) ? 0.03 : this.client.clientProfile.InflationRate / 100,
      InRetirementInflationRate: (this.client.clientProfile.InRetirementInflationRate == null) ? 0.03 : this.client.clientProfile.InRetirementInflationRate / 100,
      FrmState1: this.client.clientProfile.Spouses[0].state || '',
      SelfIRR: (this.client.clientProfile.IRR != null && this.client.clientProfile.IRR != undefined) ? this.client.clientProfile.IRR : 0,      
      MAGI: (this.client.clientProfile.MAGIPercentIncome == null) ? 100 : this.client.clientProfile.MAGIPercentIncome,
      
      ClientPIA: this.client.clientProfile.PIA,
      SelfPIA: (this.client.clientProfile.PIA) ? this.client.clientProfile.PIA : 0,
      SpousePIA: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? Number(this.client.clientProfile.Spouses[0].pia) || 0 : 0,
      
      PremiumType: this.profileInfo.value.inRetirementCoverageType == 'TM' ? 0 : this.profileInfo.value.inRetirementCoverageType == 'HMO' ? 1 : 2,
      PremiumType1: (this.partnerActive) ? this.spouseProfileInfo.value.inRetirementCoverageType == 'TM' ? 0 : this.spouseProfileInfo.value.inRetirementCoverageType == 'HMO' ? 1 : 2 : 0,
      PrivateInsurance: (this.profileInfo.value.privateHealthInsurance == 'true' || this.profileInfo.value.privateHealthInsurance == true) ? 1: 0,
      PrivateInsurance1: (this.partnerActive) ? (this.spouseProfileInfo.value.privateHealthInsurance == 'true' || this.spouseProfileInfo.value.privateHealthInsurance == true) ? 1 : 0: 0,
      SelfCurrentIncome: (this.client.clientProfile.CurrentIncome != null && this.client.clientProfile.CurrentIncome != undefined) ? this.client.clientProfile.CurrentIncome : 0,
      SpouseCurrentIncome: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && isIncome ? Number(this.client.clientProfile.Spouses[0].currentIncome) || 0 : 0,
      P_Advantage: ((this.profileInfo.value.medicareAdvHMO && this.profileInfo.value.inRetirementCoverageType == 'HMO') || (this.profileInfo.value.medicareAdvPPO && this.profileInfo.value.inRetirementCoverageType == 'PPO'))? 1 : 0,
      P_Advantage1: this.partnerActive ? ((this.spouseProfileInfo.value.medicareAdvHMO && this.spouseProfileInfo.value.inRetirementCoverageType == 'HMO') || (this.spouseProfileInfo.value.medicareAdvPPO && this.spouseProfileInfo.value.inRetirementCoverageType == 'PPO')) ? 1 : 0 : 0,
      CoverageType: this.profileInfo.value.preRetirementCoverageType == 'PPO' ? 0 : this.profileInfo.value.preRetirementCoverageType == 'HMO' ? 1 : 2,
      CoverageType1: (this.partnerActive) ? this.spouseProfileInfo.value.preRetirementCoverageType == 'PPO' ? 0 : this.spouseProfileInfo.value.preRetirementCoverageType == 'HMO' ? 1 : 2 : 0,

      SelfSupplementalPlan: this.profileInfo.value.supplementalPlanType,
      SpouseSupplementalPlan: (this.partnerActive) ? this.spouseProfileInfo.value.supplementalPlanType : "",
      BracketRange: this.selectedIRMAABracketDisplay,

      MidRetAdjYear: this.client.midRetirementAdj ? this.client.midRetirementAdj.Year : 0,
      MidRetRedPer:  this.client.midRetirementAdj ? this.client.midRetirementAdj.ReductionPerc : 0,/// 100 : 0,
      MidRetRedDollar:  this.client.midRetirementAdj ? this.client.midRetirementAdj.ReductionDollar : 0,
      MidRetIncomeInflationRate: this.client.midRetirementAdj ? (this.client.midRetirementAdj.IncomeInflationRate) : 0,// / 100 : 0,
    }
    
    if(this.profileInfo.value.inRetirementCoverageType != 'TM'){
      ReportHC.P_Part_A_And_B = 1;
    }

    if (this.partnerActive) {
      if(this.spouseProfileInfo.value.inRetirementCoverageType != 'TM'){
        ReportHC.P_Part_A_And_B1 = 1;
      }
    }
    console.log('ReportHC', ReportHC);
 
    this.globalService.createReportHC(Report, ReportHC)
      .subscribe(
        resp => {
          this.snackBarService.add("Please wait while your healthcare report is being generated.", 0);
          // this.router.navigate(['/reports/create']);
          //this.router.navigateByUrl('/reports/create?d=t');

          this.downloadReport(resp.ReportID, resp.AdvisorID, resp.ClientID, resp.CompanyCode, resp.ReportTypeID);
        },
        error => this.error = <any>error);
  }



  downloadReport(reportID, advisorID, clientID, orgID, reportTypeID) {
    this.loadingService.isLoading(true);

    // let isOptionCurrentIncome = (this.client.clientProfile.CurrentIncome && this.client.clientProfile.InflationRate && this.client.clientProfile.IRR) ? true : false;
    // // console.log('this.isOptionCurrentIncome ', this.isOptionCurrentIncome)
    // let houseHoldYearOneIncome = this.client.clientProfile.HouseholdYearOneIncome ? this.client.clientProfile.HouseholdYearOneIncome : '';

    // if (!isOptionCurrentIncome && !houseHoldYearOneIncome) {
    //   let currentYear = new Date().getFullYear();

    //   let clientRetirementYear = Math.max(currentYear, this.getRetirementYear(this.client.clientProfile.RetirementAge, this.client.client.DOB));
    //   let spouseRetirementYear = this.client.clientProfile.Spouses[0].maritalStatus == 'Married'? this.getRetirementYear(this.client.clientProfile.Spouses[0].retirementAge, this.client.clientProfile.Spouses[0].dob): 0;
    //   if (spouseRetirementYear != 0 && spouseRetirementYear < clientRetirementYear) {
    //     this.getMMTBracket(spouseRetirementYear, reportID, advisorID, clientID, orgID, reportTypeID);
    //   } else {
    //     this.getMMTBracket(clientRetirementYear, reportID, advisorID, clientID, orgID, reportTypeID);
    //   }
    // } else {
      var ReportFields = { reportID, advisorID, clientID, orgID, ReportTypeID: reportTypeID, token: localStorage.getItem("bearer") };
  
      this.globalService.generateReport(ReportFields, this.client.client, ReportFields)
        .subscribe(
          resp => {;
            this.loadingService.isLoading(false);
          },
          error => {
            this.error = <any>error;
            this.loadingService.isLoading(false);
          });

    // }

  }


  getMMTBracket(bracketYear) {
    let includePartner = this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? 'true' : 'false';

    console.log('bracketYear', bracketYear);
    this.globalService.getMMTBracket(includePartner, bracketYear)
            .subscribe(
                data => {
                  this.responseMMTBracket = data;
                  console.log('MMT Brackets for Client', data);
                  this.bracketChange(this.client.clientProfile.Bracket);
                  
                },
                error => console.log(error));
  }

  bracketChange(value: any) {
    console.log('this.responseMMTBracket.Bracket6', this.responseMMTBracket.Bracket6)
    //Utils.formatToCurrency(
    console.log('bracket check', value);
    if(value <= 1){
      this.selectedIRMAABracketDisplay = Utils.formatToCurrency(this.responseMMTBracket.Bracket1) + " to " + Utils.formatToCurrency(this.responseMMTBracket.Bracket2 - 1);
    } else if(value == 2){
      this.selectedIRMAABracketDisplay = Utils.formatToCurrency(this.responseMMTBracket.Bracket2) + " to " + Utils.formatToCurrency(this.responseMMTBracket.Bracket3 - 1);
    } else if(value == 3){
      this.selectedIRMAABracketDisplay = Utils.formatToCurrency(this.responseMMTBracket.Bracket3) + " to " + Utils.formatToCurrency(this.responseMMTBracket.Bracket4 - 1);
    } else if(value == 4){
      this.selectedIRMAABracketDisplay = Utils.formatToCurrency(this.responseMMTBracket.Bracket4) + " to " + Utils.formatToCurrency(this.responseMMTBracket.Bracket5 - 1);
    } else if(value == 5){
      this.selectedIRMAABracketDisplay = Utils.formatToCurrency(this.responseMMTBracket.Bracket5) + " to " + Utils.formatToCurrency(this.responseMMTBracket.Bracket6 - 1);
    } else {
      this.selectedIRMAABracketDisplay = Utils.formatToCurrency(this.responseMMTBracket.Bracket6) + " or more";
    }
    console.log('this.selectedIRMAABracketDisplay', this.selectedIRMAABracketDisplay);
    this.handleSavingHC();
    // let selectedIRMAABracketDisplay = this.selectedIRMAABracketDisplay;
    // var ReportFields = { reportID, advisorID, clientID, orgID, ReportTypeID: reportTypeID, token: localStorage.getItem("bearer"), selectedIRMAABracketDisplay };
  
    // this.globalService.generateReport(ReportFields, this.client.client, ReportFields)
    //   .subscribe(
    //     resp => {;
    //       this.loadingService.isLoading(false);
    //     },
    //     error => {
    //       this.error = <any>error;
    //       this.loadingService.isLoading(false);
    //     });
  }

  getRetirementYear(retirementAge, dob) {
    var currentAge = this.calculateAge(dob);
    var diff = retirementAge - currentAge;
    var year = new Date().getFullYear();
    return year + diff;
  }

  formatPercent(percentage) {
    return (percentage * 100).toFixed(0);
  }

  addFunds: boolean;
  contributionAmount;
  //rateControl = new FormControl("", [Validators.max(100), Validators.min(0)])
  handleNewFundingItem(fundingSource: string, annContribution: any, startAge: number, endAge: number, inflationRate: number) {

    this.addFunds = true;

    //check year here
    if (startAge < this.currentYear) {
      startAge = this.currentYear;
    }

    if (endAge < startAge || endAge > (this.client.clientProfile.LifeExpectancy - this.calculateAge(this.client.client.DOB)) + this.currentYear) {
      endAge = (this.client.clientProfile.LifeExpectancy - this.calculateAge(this.client.client.DOB)) + this.currentYear;
    }

    annContribution = Utils.formatToNumber(annContribution)
    //this.contributionAmount += this.getFutureContributionAmountV2(annContribution, endAge - startAge, inflationRate, startAge, null);

    this.totalRemainingGap = this.formatNumber((this.totalRemainingGap - Number(this.contributionAmount)));

    //this.futureTotalCost = this.formatNumber((this.futureTotalCost - Number(contributionAmount) > 0) ? (this.futureTotalCost - Number(contributionAmount)) : 0);
    //this.currentRemainingTotal = this.formatNumber((this.currentRemainingTotal - Number(this.contributionAmount) > 0) ? (this.currentRemainingTotal - Number(this.contributionAmount)) : 0);
    
    /* if (Number(this.totalRemainingGap) >= 0 ) {
       this.animateValue(this.totalRemainingGapEl, 0, this.roundAndFormat(this.totalRemainingGap, 0));
     } else {
       this.animateValue(this.totalRemainingGapEl, 0, { shortValue: 0, suffix: ''});
     } */

    //this.ssRemaining = this.totalRemainingGap;
    console.log('this.fundingItems', this.fundingItems);
    this.fundingItems.push({
      fundingSource,
      annContribution,
      startAge,
      endAge,
      inflationRate,
      contributionAmount: this.formatNumber(this.contributionAmount),
      remainingUnfunded: this.formatNumber(this.totalRemainingGap)
    });

    /* this.fundingSourceInput.nativeElement.value = '';
    this.annContributionInput.nativeElement.value = '';
    this.startAgeInput.nativeElement.value = '';
    this.endAgeInput.nativeElement.value = '';
    this.inflationRateInput.nativeElement.value = ''; */


    //this.getHCData(this.client, this.partnerActive);
    // this.generatePieChartData();
    // this.generateBarChartData();
  }

  getFutureValue(startAmount, years, inflation) {
    inflation = inflation / 100;
    var total = 0;


    for (var i = 0; i <= years; i++) {
      total = total + startAmount * Math.pow(1 + inflation, i);
    }

    return total;
  }

  getFutureValueOfCost(startAmount, years, inflation) {
    return startAmount * Math.pow(1 + inflation, years);
  }

  getFutureContributionAmountV2(startAmount, years, inflation, startAge, idx) {
    var result = 0;

    for (let i = 0; i < years + 1; i++) {
      result = result + (startAmount * Math.pow((1 + inflation / 100), i));
    }

    return result;
  }

  getFutureContributionAmount(startAmount, years, inflation, startAge, idx) {
    var startingBalance = 0;
    var interestEarned = 0;
    var contribution = Number(startAmount);
    var endingBalance = Number(startAmount);
    startAge = Number(startAge);

    for (let i = 0; i < years; i++) {
      if (startAge + i <= this.p1EndAge.nativeElement.value) {
        startingBalance = endingBalance;
        interestEarned = startingBalance * (Number(this.p1Percent.nativeElement.value) / 100);
        contribution = contribution * (1 + (inflation / 100));
        endingBalance = startingBalance + interestEarned + contribution;
      } else if (startAge + i <= this.p2EndAge.nativeElement.value) {
        startingBalance = endingBalance;
        interestEarned = startingBalance * (Number(this.p2Percent.nativeElement.value) / 100);
        contribution = contribution * (1 + (inflation / 100));
        endingBalance = startingBalance + interestEarned + contribution;
      } else {
        startingBalance = endingBalance;
        interestEarned = startingBalance * (Number(this.p3Percent.nativeElement.value) / 100);
        contribution = contribution * (1 + (inflation / 100));
        endingBalance = startingBalance + interestEarned + contribution;
      }
    }

    if (idx != null) {
      // this.fundingItems[idx].annContribution = endingBalance;
      this.fundingItems[idx].remainingUnfunded = Number(this.totalRemainingGap - endingBalance).toFixed(0);
      this.fundingItems[idx].contributionAmount = Number(endingBalance).toFixed(0);
    }

    return Number(endingBalance).toFixed(0);
  }

  onRateChange(percentValue) {

    //get HC data
    this.getHCData(this.client, this.partnerActive);

    //check value
    if (percentValue != undefined) {
      if (percentValue.value > 12) {
        //percentValue.id 
        return percentValue.value = 12;
      }
    }
  }

  public visible: boolean = true;

  calculateCoverageTotal(el?: any, amount?: number, isPremium?: boolean, coverageKeyName?: string[], scenario?: string) {
    //console.log('coverageKeyName', coverageKeyName);
    //console.log('el', el);
    if(scenario == "client"){
      if(coverageKeyName[0] == "partBPremium"){
        //console.log('clinet part b true');
        if(el){
          this.profileInfo.controls['supplemental'].enable();
        } else {
          this.profileInfo.controls['supplemental'].setValue(0);
          this.profileInfo.controls['supplemental'].disable();
        }
      }
    } else { //spouse
      if(coverageKeyName[0] == "partBPremium"){
        if(el){
          this.spouseProfileInfo.controls['supplemental'].enable();
        } else {
          this.spouseProfileInfo.controls['supplemental'].setValue(0);
          this.spouseProfileInfo.controls['supplemental'].disable();
        }
      }
    }

    if(this.profileInfo.value.runReportWithSpouse){
      this.runReportWithSpouse(false);
    } else {
      this.getHCData(this.client, this.partnerActive);
    }

    this.visible = true;


    this.coverageTotal = el ? this.coverageTotal + this.formatNumber(amount) : this.coverageTotal - this.formatNumber(amount);

    if (isPremium)
      this.premiumCoverageTotal = el ? this.premiumCoverageTotal + this.formatNumber(amount) : this.premiumCoverageTotal - this.formatNumber(amount);
    else
      this.outOfPocketCoverageTotal = el ? this.outOfPocketCoverageTotal + this.formatNumber(amount) : this.outOfPocketCoverageTotal - this.formatNumber(amount);

    //this.generateLineChartData({});

/*     this.premiumExpenses = {
      partB: this.hdt.nativeElement.checked,
      partD: this.pd.nativeElement.checked,
      medigap: this.si.nativeElement.checked,
      dental: this.di.nativeElement.checked
    };

    this.outOfPocketExpenses = {
      hospitalization: this.hd.nativeElement.checked,
      docsTests: this.hd.nativeElement.checked,
      rx: this.pdrg.nativeElement.checked,
      dental: this.dins.nativeElement.checked,
      hearingServices: this.hvc.nativeElement.checked,
      vision: this.hvc.nativeElement.checked,
      commercial: true
    };



    if (
      !this.premiumExpenses.partB &&
      !this.premiumExpenses.partD &&
      !this.premiumExpenses.medigap &&
      !this.premiumExpenses.dental &&
      !this.outOfPocketExpenses.hospitalization &&
      !this.outOfPocketExpenses.docsTests &&
      !this.outOfPocketExpenses.rx &&
      !this.outOfPocketExpenses.dental &&
      !this.outOfPocketExpenses.hearingServices &&
      !this.outOfPocketExpenses.vision
    ) {
      this.visible = false;
      this.hcDataV2 = this.sample;

    } else {
      this.visible = true;
      this.getHCData(this.client, this.partnerActive);

      this.coverageTotal = el.checked ? this.coverageTotal + this.formatNumber(amount) : this.coverageTotal - this.formatNumber(amount);

      if (isPremium)
        this.premiumCoverageTotal = el.checked ? this.premiumCoverageTotal + this.formatNumber(amount) : this.premiumCoverageTotal - this.formatNumber(amount);
      else
        this.outOfPocketCoverageTotal = el.checked ? this.outOfPocketCoverageTotal + this.formatNumber(amount) : this.outOfPocketCoverageTotal - this.formatNumber(amount);

      this.generateLineChartData({});
    }
 */

  }

  OnMedigapPlanChange(){
    if(this.profileInfo.value.runReportWithSpouse){
      this.runReportWithSpouse(false);
    }
    else{
    //get healthcare data
    this.getHCData(this.client, this.partnerActive);
    }
  }

  onCheckBoxChange(scenario) {
    this.enableControls(scenario);
    if (scenario == 'client') {

      if(this.profileInfo.value.inRetirementCoverageType == 'TM' && !this.profileInfo.value.medicarePartB){
        this.profileInfo.controls['supplemental'].setValue(0);
        this.profileInfo.controls['supplemental'].disable();     
        
        // if(!this.profileInfo.value.medicarePartD && !this.profileInfo.value.dental){
        //   this.profileInfo.controls['medicarePartD'].setValue(1);
        //   this.profileInfo.controls['medicarePartD'].enable();     
        // }
      } else {
        this.profileInfo.controls['supplemental'].enable();     
      }

      if (this.profileInfo.value.medicarePartB && !this.profileInfo.value.medicarePartD && !this.profileInfo.value.supplemental && !this.profileInfo.value.dental && !this.profileInfo.value.hospitalDocsTestsOOP && !this.profileInfo.value.prescriptionDrugsOOP && !this.profileInfo.value.hearingVisionOOP && !this.profileInfo.value.dentalOOP) {
        this.profileInfo.controls['medicarePartB'].disable();
      }
      if (!this.profileInfo.value.medicarePartB && this.profileInfo.value.medicarePartD && !this.profileInfo.value.supplemental && !this.profileInfo.value.dental && !this.profileInfo.value.hospitalDocsTestsOOP && !this.profileInfo.value.prescriptionDrugsOOP && !this.profileInfo.value.hearingVisionOOP && !this.profileInfo.value.dentalOOP) {
        this.profileInfo.controls['medicarePartD'].disable();
      }
      if (!this.profileInfo.value.medicarePartB && !this.profileInfo.value.medicarePartD && this.profileInfo.value.supplemental && !this.profileInfo.value.dental && !this.profileInfo.value.hospitalDocsTestsOOP && !this.profileInfo.value.prescriptionDrugsOOP && !this.profileInfo.value.hearingVisionOOP && !this.profileInfo.value.dentalOOP) {
        this.profileInfo.controls['supplemental'].disable();
      }
      if (this.profileInfo.value.inRetirementCoverageType == 'TM' && !this.profileInfo.value.medicarePartB && !this.profileInfo.value.medicarePartD && !this.profileInfo.value.supplemental && this.profileInfo.value.dental && !this.profileInfo.value.hospitalDocsTestsOOP && !this.profileInfo.value.prescriptionDrugsOOP && !this.profileInfo.value.hearingVisionOOP && !this.profileInfo.value.dentalOOP) {
        console.log('here i am 01');
        console.log('his.profileInfo.value.medicarePartB', this.profileInfo.value.medicarePartB);
        this.profileInfo.controls['dental'].disable();
      }
      if (this.profileInfo.value.inRetirementCoverageType == 'HMO' && this.profileInfo.value.dental && !this.profileInfo.value.hospitalDocsTestsOOP && !this.profileInfo.value.prescriptionDrugsOOP && !this.profileInfo.value.hearingVisionOOP && !this.profileInfo.value.dentalOOP) {
        this.profileInfo.controls['dental'].disable();
      }
      if (this.profileInfo.value.inRetirementCoverageType == 'PPO' && this.profileInfo.value.dental && !this.profileInfo.value.hospitalDocsTestsOOP && !this.profileInfo.value.prescriptionDrugsOOP && !this.profileInfo.value.hearingVisionOOP && !this.profileInfo.value.dentalOOP) {
        this.profileInfo.controls['dental'].disable();
      }
      if (this.profileInfo.value.inRetirementCoverageType == 'TM' && !this.profileInfo.value.medicarePartB && !this.profileInfo.value.medicarePartD && !this.profileInfo.value.supplemental && !this.profileInfo.value.dental && this.profileInfo.value.hospitalDocsTestsOOP && !this.profileInfo.value.prescriptionDrugsOOP && !this.profileInfo.value.hearingVisionOOP && !this.profileInfo.value.dentalOOP) {
        this.profileInfo.controls['hospitalDocsTestsOOP'].disable();
      }
      if (this.profileInfo.value.inRetirementCoverageType == 'HMO' && !this.profileInfo.value.dental && this.profileInfo.value.hospitalDocsTestsOOP && !this.profileInfo.value.prescriptionDrugsOOP && !this.profileInfo.value.hearingVisionOOP && !this.profileInfo.value.dentalOOP) {
        this.profileInfo.controls['hospitalDocsTestsOOP'].disable();
      }
      if (this.profileInfo.value.inRetirementCoverageType == 'PPO' && !this.profileInfo.value.dental && this.profileInfo.value.hospitalDocsTestsOOP && !this.profileInfo.value.prescriptionDrugsOOP && !this.profileInfo.value.hearingVisionOOP && !this.profileInfo.value.dentalOOP) {
        this.profileInfo.controls['hospitalDocsTestsOOP'].disable();
      }
      if (this.profileInfo.value.inRetirementCoverageType == 'TM' && !this.profileInfo.value.medicarePartB && !this.profileInfo.value.medicarePartD && !this.profileInfo.value.supplemental && !this.profileInfo.value.dental && !this.profileInfo.value.hospitalDocsTestsOOP && this.profileInfo.value.prescriptionDrugsOOP && !this.profileInfo.value.hearingVisionOOP && !this.profileInfo.value.dentalOOP) {
        this.profileInfo.controls['prescriptionDrugsOOP'].disable();
      }
      if (this.profileInfo.value.inRetirementCoverageType == 'HMO' && !this.profileInfo.value.dental && !this.profileInfo.value.hospitalDocsTestsOOP && this.profileInfo.value.prescriptionDrugsOOP && !this.profileInfo.value.hearingVisionOOP && !this.profileInfo.value.dentalOOP) {
        this.profileInfo.controls['prescriptionDrugsOOP'].disable();
      }
      if (this.profileInfo.value.inRetirementCoverageType == 'PPO' && !this.profileInfo.value.dental && !this.profileInfo.value.hospitalDocsTestsOOP && this.profileInfo.value.prescriptionDrugsOOP && !this.profileInfo.value.hearingVisionOOP && !this.profileInfo.value.dentalOOP) {
        this.profileInfo.controls['prescriptionDrugsOOP'].disable();
      }
      if (this.profileInfo.value.inRetirementCoverageType == 'TM' && !this.profileInfo.value.medicarePartB && !this.profileInfo.value.medicarePartD && !this.profileInfo.value.supplemental && !this.profileInfo.value.dental && !this.profileInfo.value.hospitalDocsTestsOOP && !this.profileInfo.value.prescriptionDrugsOOP && this.profileInfo.value.hearingVisionOOP && !this.profileInfo.value.dentalOOP) {
        this.profileInfo.controls['hearingVisionOOP'].disable();
      }
      if (this.profileInfo.value.inRetirementCoverageType == 'HMO' && !this.profileInfo.value.dental && !this.profileInfo.value.hospitalDocsTestsOOP && !this.profileInfo.value.prescriptionDrugsOOP && this.profileInfo.value.hearingVisionOOP && !this.profileInfo.value.dentalOOP) {
        this.profileInfo.controls['hearingVisionOOP'].disable();
      }
      if (this.profileInfo.value.inRetirementCoverageType == 'PPO' && !this.profileInfo.value.dental && !this.profileInfo.value.hospitalDocsTestsOOP && !this.profileInfo.value.prescriptionDrugsOOP && this.profileInfo.value.hearingVisionOOP && !this.profileInfo.value.dentalOOP) {
        this.profileInfo.controls['hearingVisionOOP'].disable();
      }
      if (this.profileInfo.value.inRetirementCoverageType == 'TM' && !this.profileInfo.value.medicarePartB && !this.profileInfo.value.medicarePartD && !this.profileInfo.value.supplemental && !this.profileInfo.value.dental && !this.profileInfo.value.hospitalDocsTestsOOP && !this.profileInfo.value.prescriptionDrugsOOP && !this.profileInfo.value.hearingVisionOOP && this.profileInfo.value.dentalOOP) {
        this.profileInfo.controls['dentalOOP'].disable();
      }
      if (this.profileInfo.value.inRetirementCoverageType == 'HMO' && !this.profileInfo.value.dental && !this.profileInfo.value.hospitalDocsTestsOOP && !this.profileInfo.value.prescriptionDrugsOOP && !this.profileInfo.value.hearingVisionOOP && this.profileInfo.value.dentalOOP) {
        this.profileInfo.controls['dentalOOP'].disable();
      }
      if (this.profileInfo.value.inRetirementCoverageType == 'PPO' && !this.profileInfo.value.dental && !this.profileInfo.value.hospitalDocsTestsOOP && !this.profileInfo.value.prescriptionDrugsOOP && !this.profileInfo.value.hearingVisionOOP && this.profileInfo.value.dentalOOP) {
        this.profileInfo.controls['dentalOOP'].disable();
      }
    } else if(this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {
      if(this.spouseProfileInfo.value.inRetirementCoverageType == 'TM' && !this.spouseProfileInfo.value.medicarePartB){
        this.spouseProfileInfo.controls['supplemental'].setValue(0);
        this.spouseProfileInfo.controls['supplemental'].disable();     
        
        // if(!this.spouseProfileInfo.value.medicarePartD && !this.spouseProfileInfo.value.dental){
        //   this.spouseProfileInfo.controls['medicarePartD'].setValue(1);
        //   this.spouseProfileInfo.controls['medicarePartD'].enable();     
        // }
      } else {
        this.spouseProfileInfo.controls['supplemental'].enable();     
      }

      if (this.spouseProfileInfo.value.medicarePartB && !this.spouseProfileInfo.value.medicarePartD && !this.spouseProfileInfo.value.supplemental && !this.spouseProfileInfo.value.dental && !this.spouseProfileInfo.value.hospitalDocsTestsOOP && !this.spouseProfileInfo.value.prescriptionDrugsOOP && !this.spouseProfileInfo.value.hearingVisionOOP && !this.spouseProfileInfo.value.dentalOOP) {
        this.spouseProfileInfo.controls['medicarePartB'].disable();
      }
      if (!this.spouseProfileInfo.value.medicarePartB && this.spouseProfileInfo.value.medicarePartD && !this.spouseProfileInfo.value.supplemental && !this.spouseProfileInfo.value.dental && !this.spouseProfileInfo.value.hospitalDocsTestsOOP && !this.spouseProfileInfo.value.prescriptionDrugsOOP && !this.spouseProfileInfo.value.hearingVisionOOP && !this.spouseProfileInfo.value.dentalOOP) {
        this.spouseProfileInfo.controls['medicarePartD'].disable();
      }
      if (!this.spouseProfileInfo.value.medicarePartB && !this.spouseProfileInfo.value.medicarePartD && this.spouseProfileInfo.value.supplemental && !this.spouseProfileInfo.value.dental && !this.spouseProfileInfo.value.hospitalDocsTestsOOP && !this.spouseProfileInfo.value.prescriptionDrugsOOP && !this.spouseProfileInfo.value.hearingVisionOOP && !this.spouseProfileInfo.value.dentalOOP) {
        this.spouseProfileInfo.controls['supplemental'].disable();
      }
      if (this.spouseProfileInfo.value.inRetirementCoverageType == 'TM' && !this.spouseProfileInfo.value.medicarePartB && !this.spouseProfileInfo.value.medicarePartD && !this.spouseProfileInfo.value.supplemental && this.spouseProfileInfo.value.dental && !this.spouseProfileInfo.value.hospitalDocsTestsOOP && !this.spouseProfileInfo.value.prescriptionDrugsOOP && !this.spouseProfileInfo.value.hearingVisionOOP && !this.spouseProfileInfo.value.dentalOOP) {
        this.spouseProfileInfo.controls['dental'].disable();
      }
      if (this.spouseProfileInfo.value.inRetirementCoverageType == 'HMO' && this.spouseProfileInfo.value.dental && !this.spouseProfileInfo.value.hospitalDocsTestsOOP && !this.spouseProfileInfo.value.prescriptionDrugsOOP && !this.spouseProfileInfo.value.hearingVisionOOP && !this.spouseProfileInfo.value.dentalOOP) {
        this.spouseProfileInfo.controls['dental'].disable();
      }
      if (this.spouseProfileInfo.value.inRetirementCoverageType == 'PPO' && this.spouseProfileInfo.value.dental && !this.spouseProfileInfo.value.hospitalDocsTestsOOP && !this.spouseProfileInfo.value.prescriptionDrugsOOP && !this.spouseProfileInfo.value.hearingVisionOOP && !this.spouseProfileInfo.value.dentalOOP) {
        this.spouseProfileInfo.controls['dental'].disable();
      }
      if (this.spouseProfileInfo.value.inRetirementCoverageType == 'TM' && !this.spouseProfileInfo.value.medicarePartB && !this.spouseProfileInfo.value.medicarePartD && !this.spouseProfileInfo.value.supplemental && !this.spouseProfileInfo.value.dental && this.spouseProfileInfo.value.hospitalDocsTestsOOP && !this.spouseProfileInfo.value.prescriptionDrugsOOP && !this.spouseProfileInfo.value.hearingVisionOOP && !this.spouseProfileInfo.value.dentalOOP) {
        this.spouseProfileInfo.controls['hospitalDocsTestsOOP'].disable();
      }
      if (this.spouseProfileInfo.value.inRetirementCoverageType == 'HMO' && !this.spouseProfileInfo.value.dental && this.spouseProfileInfo.value.hospitalDocsTestsOOP && !this.spouseProfileInfo.value.prescriptionDrugsOOP && !this.spouseProfileInfo.value.hearingVisionOOP && !this.spouseProfileInfo.value.dentalOOP) {
        this.spouseProfileInfo.controls['hospitalDocsTestsOOP'].disable();
      }
      if (this.spouseProfileInfo.value.inRetirementCoverageType == 'PPO' && !this.spouseProfileInfo.value.dental && this.spouseProfileInfo.value.hospitalDocsTestsOOP && !this.spouseProfileInfo.value.prescriptionDrugsOOP && !this.spouseProfileInfo.value.hearingVisionOOP && !this.spouseProfileInfo.value.dentalOOP) {
        this.spouseProfileInfo.controls['hospitalDocsTestsOOP'].disable();
      }
      if (this.spouseProfileInfo.value.inRetirementCoverageType == 'TM' && !this.spouseProfileInfo.value.medicarePartB && !this.spouseProfileInfo.value.medicarePartD && !this.spouseProfileInfo.value.supplemental && !this.spouseProfileInfo.value.dental && !this.spouseProfileInfo.value.hospitalDocsTestsOOP && this.spouseProfileInfo.value.prescriptionDrugsOOP && !this.spouseProfileInfo.value.hearingVisionOOP && !this.spouseProfileInfo.value.dentalOOP) {
        this.spouseProfileInfo.controls['prescriptionDrugsOOP'].disable();
      }
      if (this.spouseProfileInfo.value.inRetirementCoverageType == 'HMO' && !this.spouseProfileInfo.value.dental && !this.spouseProfileInfo.value.hospitalDocsTestsOOP && this.spouseProfileInfo.value.prescriptionDrugsOOP && !this.spouseProfileInfo.value.hearingVisionOOP && !this.spouseProfileInfo.value.dentalOOP) {
        this.spouseProfileInfo.controls['prescriptionDrugsOOP'].disable();
      }
      if (this.spouseProfileInfo.value.inRetirementCoverageType == 'PPO' && !this.spouseProfileInfo.value.dental && !this.spouseProfileInfo.value.hospitalDocsTestsOOP && this.spouseProfileInfo.value.prescriptionDrugsOOP && !this.spouseProfileInfo.value.hearingVisionOOP && !this.spouseProfileInfo.value.dentalOOP) {
        this.spouseProfileInfo.controls['prescriptionDrugsOOP'].disable();
      }
      if (this.spouseProfileInfo.value.inRetirementCoverageType == 'TM' && !this.spouseProfileInfo.value.medicarePartB && !this.spouseProfileInfo.value.medicarePartD && !this.spouseProfileInfo.value.supplemental && !this.spouseProfileInfo.value.dental && !this.spouseProfileInfo.value.hospitalDocsTestsOOP && !this.spouseProfileInfo.value.prescriptionDrugsOOP && this.spouseProfileInfo.value.hearingVisionOOP && !this.spouseProfileInfo.value.dentalOOP) {
        this.spouseProfileInfo.controls['hearingVisionOOP'].disable();
      }
      if (this.spouseProfileInfo.value.inRetirementCoverageType == 'HMO' && !this.spouseProfileInfo.value.dental && !this.spouseProfileInfo.value.hospitalDocsTestsOOP && !this.spouseProfileInfo.value.prescriptionDrugsOOP && this.spouseProfileInfo.value.hearingVisionOOP && !this.spouseProfileInfo.value.dentalOOP) {
        this.spouseProfileInfo.controls['hearingVisionOOP'].disable();
      }
      if (this.spouseProfileInfo.value.inRetirementCoverageType == 'PPO' && !this.spouseProfileInfo.value.dental && !this.spouseProfileInfo.value.hospitalDocsTestsOOP && !this.spouseProfileInfo.value.prescriptionDrugsOOP && this.spouseProfileInfo.value.hearingVisionOOP && !this.spouseProfileInfo.value.dentalOOP) {
        this.spouseProfileInfo.controls['hearingVisionOOP'].disable();
      }
      if (this.spouseProfileInfo.value.inRetirementCoverageType == 'TM' && !this.spouseProfileInfo.value.medicarePartB && !this.spouseProfileInfo.value.medicarePartD && !this.spouseProfileInfo.value.supplemental && !this.spouseProfileInfo.value.dental && !this.spouseProfileInfo.value.hospitalDocsTestsOOP && !this.spouseProfileInfo.value.prescriptionDrugsOOP && !this.spouseProfileInfo.value.hearingVisionOOP && this.spouseProfileInfo.value.dentalOOP) {
        this.spouseProfileInfo.controls['dentalOOP'].disable();
      }
      if (this.spouseProfileInfo.value.inRetirementCoverageType == 'HMO' && !this.spouseProfileInfo.value.dental && !this.spouseProfileInfo.value.hospitalDocsTestsOOP && !this.spouseProfileInfo.value.prescriptionDrugsOOP && !this.spouseProfileInfo.value.hearingVisionOOP && this.spouseProfileInfo.value.dentalOOP) {
        this.spouseProfileInfo.controls['dentalOOP'].disable();
      }
      if (this.spouseProfileInfo.value.inRetirementCoverageType == 'PPO' && !this.spouseProfileInfo.value.dental && !this.spouseProfileInfo.value.hospitalDocsTestsOOP && !this.spouseProfileInfo.value.prescriptionDrugsOOP && !this.spouseProfileInfo.value.hearingVisionOOP && this.spouseProfileInfo.value.dentalOOP) {
        this.profileInfo.controls['dentalOOP'].disable();
      }
    }
   

  }
  enableControls(scenario) {
    if (scenario == 'client') {
      // if (this.isPre65) {
      //   this.profileInfo.controls['medicarePartB'].disable();
      //   this.profileInfo.controls['medicarePartD'].disable();
      //   this.profileInfo.controls['medicareAdvHMO'].disable();
      //   this.profileInfo.controls['medicareAdvPPO'].disable();
      //   this.profileInfo.controls['supplemental'].disable();
      // } else {
      //   this.profileInfo.controls['medicarePartB'].enable();
      //   this.profileInfo.controls['medicarePartD'].enable();
      //   this.profileInfo.controls['medicareAdvHMO'].enable();
      //   this.profileInfo.controls['medicareAdvPPO'].enable();
      //   this.profileInfo.controls['supplemental'].enable();
      // }
      this.profileInfo.controls['medicarePartB'].enable();
      this.profileInfo.controls['medicarePartD'].enable();
      this.profileInfo.controls['medicareAdvHMO'].enable();
      this.profileInfo.controls['medicareAdvPPO'].enable();
      this.profileInfo.controls['supplemental'].enable();
      this.profileInfo.controls['dental'].enable();
      this.profileInfo.controls['hospitalDocsTestsOOP'].enable();
      this.profileInfo.controls['prescriptionDrugsOOP'].enable();
      this.profileInfo.controls['hearingVisionOOP'].enable();
      this.profileInfo.controls['dentalOOP'].enable();
    } else {
      // if (this.isSpousePre65) {
      //   this.spouseProfileInfo.controls['medicarePartB'].disable();
      //   this.spouseProfileInfo.controls['medicarePartD'].disable();
      //   this.spouseProfileInfo.controls['medicareAdvHMO'].disable();
      //   this.spouseProfileInfo.controls['medicareAdvPPO'].disable();
      //   this.spouseProfileInfo.controls['supplemental'].disable();
      // } else {
      //   this.spouseProfileInfo.controls['medicarePartB'].enable();
      //   this.spouseProfileInfo.controls['medicarePartD'].enable();
      //   this.spouseProfileInfo.controls['medicareAdvHMO'].enable();
      //   this.spouseProfileInfo.controls['medicareAdvPPO'].enable();
      //   this.spouseProfileInfo.controls['supplemental'].enable();

      // }

      this.spouseProfileInfo.controls['medicarePartB'].enable();
      this.spouseProfileInfo.controls['medicarePartD'].enable();
      this.spouseProfileInfo.controls['medicareAdvHMO'].enable();
      this.spouseProfileInfo.controls['medicareAdvPPO'].enable();
      this.spouseProfileInfo.controls['supplemental'].enable();
      this.spouseProfileInfo.controls['dental'].enable();
      this.spouseProfileInfo.controls['hospitalDocsTestsOOP'].enable();
      this.spouseProfileInfo.controls['prescriptionDrugsOOP'].enable();
      this.spouseProfileInfo.controls['hearingVisionOOP'].enable();
      this.spouseProfileInfo.controls['dentalOOP'].enable();
    }
  }

  /* privateHealthInsuranceAdjustment(event, isClient){
    if(isClient && event.value == "true"){
      
    } else if(!isClient && event.value == "true"){

    }
  } */

  coverageAdjustment(isClient){
    console.log('what is spouse coverage');
    console.log('this.isPre65', this.isPre65);
    console.log('this.clientEligibleForPre65', this.clientEligibleForPre65);
    let retirementAge = this.client.clientProfile.RetirementAge;
    this.isPre65 = (Number(retirementAge || 0) >= 65 || !this.profileInfo.value.privateHealthInsurance) ? false 
    : (Number(this.globalService.calculateAge(this.client.client.DOB)) >= 65) ? false 
    : true;
    // let retirementAge = this.client.clientProfile.RetirementAge;
    // let isPre65 = (Number(retirementAge || 0) >= 65 || (Number(this.globalService.calculateAge(this.client.client.DOB)) >= 65)) ? false:  true;
    if(isClient){
      if(!this.profileInfo.value.partBPremium){
        this.profileInfo.controls['supplemental'].setValue(0);
        this.profileInfo.controls['supplemental'].disable();
        // if(!this.profileInfo.value.medicarePartD && !this.profileInfo.value.dental){
        //   this.profileInfo.controls['medicarePartD'].setValue(1);
        //   this.profileInfo.controls['medicarePartD'].enable();     
        // }
      }
      console.log('here i am 01')
      console.log('this.profileInfo.value.privateHealthInsurance', this.profileInfo.value.privateHealthInsurance)
      console.log('this.profileInfo.value.preRetirementCoverageType', this.profileInfo.value.preRetirementCoverageType )
      if (this.profileInfo.value.privateHealthInsurance && (this.profileInfo.value.preRetirementCoverageType == ' ' || this.profileInfo.value.preRetirementCoverageType == '--')) {
        this.profileInfo.controls['preRetirementCoverageType'].setValue('HMO');
      }
    } else { //spouse
      if(!this.spouseProfileInfo.value.partBPremium){
        this.spouseProfileInfo.controls['supplemental'].setValue(0);
        this.spouseProfileInfo.controls['supplemental'].disable();
        // if(!this.spouseProfileInfo.value.medicarePartD && !this.spouseProfileInfo.value.dental){
        //   this.spouseProfileInfo.controls['medicarePartD'].setValue(1);
        //   this.spouseProfileInfo.controls['medicarePartD'].enable();     
        // }
      }
      if (this.spouseProfileInfo.value.privateHealthInsurance && (this.spouseProfileInfo.value.preRetirementCoverageType == ' ' || this.spouseProfileInfo.value.preRetirementCoverageType == '--')) {
        this.spouseProfileInfo.controls['preRetirementCoverageType'].setValue('HMO');
      }    
    }

    if(this.clientEligibleForPre65 && isClient && this.isPre65){
      // if(this.profileInfo.value.privateHealthInsurance == 'false'){
      //   // (document.getElementById('preRetirementCoverageType') as HTMLInputElement).disabled = true;
      // } else {
        console.log('this.profileInfo.value.preRetirementCoverageType', this.profileInfo.value.preRetirementCoverageType);
        if (!this.profileInfo.value.preRetirementCoverageType) {
          console.log('inside change 01')
          this.profileInfo.controls['preRetirementCoverageType'].setValue('PPO');
          // (document.getElementById('preRetirementCoverageType') as HTMLInputElement).disabled = false;
        }
      // }
    }
    console.log('this.partnerActive', this.partnerActive);
    console.log('this.spouseEligibleForPre65', this.spouseEligibleForPre65);
    //console.log('this.spouseProfileInfo.value.privateHealthInsurance', this.spouseProfileInfo.value.privateHealthInsurance)

    console.log('this.profileInfo.value.inRetirementCoverageType')
    if(this.profileInfo.value.inRetirementCoverageType == "PPO"){
      this.profileInfo.controls['medicareAdvPPO'].setValue(true);
      this.calculateCoverageTotal(this.profileInfo.value.medicareAdvPPO, this.p1CostsV2[0].Premiums[2], true, ['medicareAdvPPO'], 'client');
    } else {
      this.profileInfo.controls['medicareAdvPPO'].setValue(false);
    }
    console.log('this.profileInfo.value.inRetirementCoverageType 02')
    if(this.profileInfo.value.inRetirementCoverageType == "HMO"){
      this.profileInfo.controls['medicareAdvHMO'].setValue(true);
      this.calculateCoverageTotal(this.profileInfo.value.medicareAdvHMO, this.p1CostsV2[0].Premiums[2], true, ['medicareAdvHMO'], 'client');
    } else {
      this.profileInfo.controls['medicareAdvHMO'].setValue(false);
      //(document.getElementById('clientMedicareAdvHMO') as HTMLInputElement).disabled = false;
    }
    console.log('this.profileInfo.value.inRetirementCoverageType 03')
    if(this.partnerActive) {
      let spouseRetirementAge = Number(this.client.clientProfile.Spouses[0].retirementAge || 0);
      let spouseAge =  Number(this.globalService.calculateAge(this.client.clientProfile.Spouses[0].dob));
      this.isSpousePre65 = ((spouseRetirementAge >= 65 || spouseAge >= 65 || !this.spouseProfileInfo.value.privateHealthInsurance) ? false: true);
      if(this.spouseEligibleForPre65 && !isClient && this.isSpousePre65){
          if (!this.spouseProfileInfo.value.preRetirementCoverageType) {
            this.spouseProfileInfo.controls['preRetirementCoverageType'].setValue('PPO');
          }
      }
      if(this.spouseProfileInfo.value.inRetirementCoverageType){
        console.log('what is spouse coverage', this.spouseProfileInfo.value.preRetirementCoverageType);
        if(this.spouseProfileInfo.value.inRetirementCoverageType == "PPO"){
          this.spouseProfileInfo.controls['medicareAdvPPO'].setValue(true);
          this.calculateCoverageTotal(this.spouseProfileInfo.value.medicareAdvPPO, this.p2CostsV2[0].Premiums[2], true, ['medicareAdvPPO'], 'spouse');
        } else {
          this.spouseProfileInfo.controls['medicareAdvPPO'].setValue(false);
        }
        console.log('this.profileInfo.value.inRetirementCoverageType 04')
        if(this.spouseProfileInfo.value.inRetirementCoverageType == "HMO"){
          this.spouseProfileInfo.controls['medicareAdvHMO'].setValue(true);
          this.calculateCoverageTotal(this.spouseProfileInfo.value.medicareAdvHMO, this.p2CostsV2[0].Premiums[2], true, ['medicareAdvHMO'], 'spouse');
        } else {
          this.spouseProfileInfo.controls['medicareAdvHMO'].setValue(false);
          //(document.getElementById('clientMedicareAdvHMO') as HTMLInputElement).disabled = false;
        }
      }
      if (((this.spouseProfileInfo.value.privateHealthInsurance && this.spouseEligibleForPre65) || (this.spouseProfileInfo.value.preRetirementCoverageType && this.spouseEligibleForPre65)) && this.profileInfo.value.runReportWithSpouse && this.clientEligibleForPre65) {
        this.runReportWithSpouse(false);
      }

    }

    
    //remove premiums on toggle?
    // this.profileInfo.controls['medicarePartB'].setValue(false);
    // this.profileInfo.controls['medicareAdvHMO'].setValue(false);
    // this.profileInfo.controls['medicareAdvPPO'].setValue(false);
    // this.profileInfo.controls['medicarePartD'].setValue(false);
    // this.profileInfo.controls['supplemental'].setValue(false);
    // this.profileInfo.controls['dental'].setValue(false);

    // if(this.partnerActive){
    //   this.spouseProfileInfo.controls['medicarePartB'].setValue(false);
    //   this.spouseProfileInfo.controls['medicareAdvHMO'].setValue(false);
    //   this.spouseProfileInfo.controls['medicareAdvPPO'].setValue(false);
    //   this.spouseProfileInfo.controls['medicarePartD'].setValue(false);
    //   this.spouseProfileInfo.controls['supplemental'].setValue(false);
    //   this.spouseProfileInfo.controls['dental'].setValue(false);
    // }

    this.getHCData(this.client, this.partnerActive);
  }

  animateValue(el, start, formattedNumber): void {
    var end = parseFloat(formattedNumber.shortValue);
    var current = start;
    var increment = start < 0 ? -1 : 1;
    var stepTime = Math.abs(1);

    if (formattedNumber.shortValue > 0) {
      el.nativeElement.innerHTML = `$${end.toFixed(2)}${formattedNumber.suffix || ''}`;

      // var timer = setInterval(function () {

      //   if (Math.abs(current - end) < 5) {
      //     increment = start < 0 ? -0.1 : 0.1;
      //   }

      //   current += increment;
      //   el.nativeElement.innerHTML = `$${current.toFixed(2)}${formattedNumber.suffix || ''}`;

      //   if (current.toFixed(2) == end.toFixed(2)) {
      //     clearInterval(timer);
      //   }
      // }, stepTime);
    } else {
      el.nativeElement.innerHTML = `$0`;
    }
  }

  roundAndFormat(num, fixed) {
    if (num === null) { return null; }
    if (num === 0) { return '0'; }
    fixed = (!fixed || fixed < 0) ? 0 : fixed;
    var b = (num).toPrecision(2).split("e"),
      k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3),
      c = k < 1 ? num.toFixed(0 + fixed) : (num / Math.pow(10, k * 3)).toFixed(1 + fixed),
      d = c < 0 ? c : Math.abs(c),
      e = d + ['', 'K', 'M', 'B', 'T'][k];

    return { shortValue: e.split(/[A-z]/)[0], suffix: e.substring(e.length - 1, e.length) };
  }

  public weeklyCost: Number = 0;
  public yearlyCost: Number = 0;

  public futureYearlyCost: Number = 0;
  public futureWeeklyCost: Number = 0;

  calcAnnualSavings(el, el2) {

    el2.value = el.value;
    // el.value = el2.value;

    this.getHCData(this.client, this.partnerActive);

    // this.futureYearlyCost = this.hcDataV2.FundingOptions.CalcPayments.AnnualPaymentAmount * years.val;

    // var value = this.getFutureValueOfCost(this.totalRemainingGap, this.annualEl.nativeElement.value, 0.02);

    // var result = Number(value / this.annualEl.nativeElement.value).toFixed();

    // this.yearlyCost = Number(result).toFixed();
    // this.futureYearlyCost = value.toFixed();
    // return Number(result) < 0 ? 0 : result;
  }

  calcWeeklySavings(isAnnual) {
    if (isAnnual)
      this.weeklyEl.nativeElement.value = this.annualEl.nativeElement.value;
    else
      this.annualEl.nativeElement.value = this.weeklyEl.nativeElement.value;
    this.getHCData(this.client, this.partnerActive);

    // var value = this.getFutureValueOfCost(this.totalRemainingGap, this.weeklyEl.nativeElement.value, 0.02);
    // var result = Number(value / ((this.weeklyEl.nativeElement.value * 12) * 52)).toFixed();
    // this.weeklyCost = Number(result).toFixed();
    // this.futureWeeklyCost = value.toFixed();
    //return Number(result) < 0 ? 0 : result;
  }

  handleIllustrationModal(e) {
    this.modalService.add('hc-projections', { Data: this.projectedYears });
  }

  
  removeSocialSecurity: boolean = false;
  returnedSocialSecurity(data){
    //TODO: need to recalc without SS
    console.log('triggered SS return from header');
    //this.socialSecuritySourceEvent.emit(data);
    this.removeSocialSecurity = data;

    //adjust the graph
    this.getInvestmentGrowthData();

    //adjust the unfunded costs
    this.beginningBalance = (this.removeSocialSecurity) ? this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0) - this.hcDataV2.Illustrations[0].NetIncrease.toFixed(0) : this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0);

    //TODO: do we need to adjust the Cost of Waiting too?
    //this.generateLineChartData({});
  }

  investmentGrowthData;
  getInvestmentGrowthData(){
    //reset object array
    let isRetirementGreaterThanCurrent = false;
    this.investmentGrowthData = [];
    let currentYear = new Date().getFullYear();
    let retirementYearFromAPI = this.partnerActive ? (this.hcDataV2.RetireYear < this.hcDataV2.RetirementYear ? this.hcDataV2.RetireYear : this.hcDataV2.RetirementYear): this.hcDataV2.RetirementYear;
    let retirementYear = this.hcDataV2.RetirementYear < currentYear ? currentYear : retirementYearFromAPI;

    //get values for graph
    var projectedYears = this.hcDataV2.IllustrationEntriesWithFunding.map(entry => {
      return {
        Year: currentYear++,
        BeginningBalance: (entry.BeginningBalance ? parseInt(entry.BeginningBalance.toFixed(0)) : 0),
        //ExpectedRateReturn: (entry.CashFlowEntry.ExpectedRor ? entry.CashFlowEntry.ExpectedRor * 100 + '%' : 0),
        // Premiums: '$' + 0,
        //Contribution: Utils.formatToCurrency(entry.CashFlowEntry.Contribution > 0 ? entry.CashFlowEntry.Contribution.toFixed(0) : (entry.CashFlowEntry.TotalIncome + entry.CashFlowEntry.Contribution).toFixed(0)),
        // AdditionalCosts: '$' + 0,
        //Total: Utils.formatToCurrency(entry.CashFlowEntry.Expense ? entry.CashFlowEntry.Expense.toFixed(0) : 0),
        // NetOfSSDeductions: ((this.removeSocialSecurity) ? 0 : (parseInt(entry.CashFlowEntry.Expense.toFixed(0)) - parseInt(entry.CashFlowEntry.HealthAllocatedIncome.toFixed(0)))),
        NetOfSSDeductions: ((this.removeSocialSecurity) ? 0 : (Math.max(0, parseInt((entry.CashFlowEntry.Expense - entry.CashFlowEntry.HealthAllocatedIncome).toFixed(0))))),
        //EngingBalance: Utils.formatToCurrency(Math.abs((entry.EndingBalance ? entry.EndingBalance.toFixed(0) : 0))),
      }
    });

    var investmentGrowthDecumation = [];
    for(var i in projectedYears){
      if(projectedYears[i].Year < retirementYear){
        isRetirementGreaterThanCurrent = true;
        //pre-retirement
        investmentGrowthDecumation.push({        
          name: projectedYears[i].Year.toString(),
          series:[
            {
              name: "Investment Value, Pre-Retirement",
              value: projectedYears[i].BeginningBalance
            }
          ]
        });
      } else {
        // Temporary fix for creating illusion of overlapping chart
        // TLDR - ngx charts doesn't have a overlapping vertical bar chart
        // if (projectedYears[i].BeginningBalance > projectedYears[i].NetOfSSDeductions) {
        //   //in-retirement
        //   investmentGrowthDecumation.push({
        //     name: projectedYears[i].Year.toString(),
        //     series: [
        //       {
        //         name: "Annual Healthcare Spend",
        //         value: projectedYears[i].NetOfSSDeductions
        //       },
        //       {
        //         name: "Investment Value, In-Retirement",
        //         value: Math.abs(projectedYears[i].BeginningBalance - projectedYears[i].NetOfSSDeductions)
        //       }
        //     ]
        //   });
        // } else {
        //   //in-retirement
        //   investmentGrowthDecumation.push({
        //     name: projectedYears[i].Year.toString(),
        //     series: [
        //       {
        //         name: "Investment Value, In-Retirement",
        //         value: projectedYears[i].BeginningBalance
        //       },
        //       {
        //         name: "Annual Healthcare Spend",
        //         value: Math.abs(projectedYears[i].NetOfSSDeductions - projectedYears[i].BeginningBalance)
        //       }
        //     ]
        //   });
        // }
        investmentGrowthDecumation.push({
          name: projectedYears[i].Year.toString(),
          series: [
            {
              name: "Annual Net Healthcare Spend",
              value: projectedYears[i].NetOfSSDeductions
            },
            {
              name: "Investment Value, In-Retirement",
              value: Math.max(0, projectedYears[i].BeginningBalance - projectedYears[i].NetOfSSDeductions)
            }
          ]
        });
      }
    }

    this.investmentGrowthData = investmentGrowthDecumation;
    if (!isRetirementGreaterThanCurrent) {
      this.barVerticalStackedChartOption = {
        showXAxis: true,
        showYAxis: true,
        gradient: false,
        showLegend: false,
        showXAxisLabel: false,
    
        showYAxisLabel: false,
    
    
        roundEdges: false,
        colorScheme: {
          //domain: ['#3385C5', '#E58931', '#20a59f']
          // domain: ['#5270ad', '#487879', '#63a49e']
          // domain: ['#63a49e', '#5270ad','#487879']
          domain: ['#5270ad', '#487879','#487879']
        },
        autoScale: true
    
      };
    }
  }

  checkAllPremiums() {
    var enabled = this.pcheck.nativeElement.checked;

    this.hdt.nativeElement.checked = enabled;
    this.pd.nativeElement.checked = enabled;
    this.si.nativeElement.checked = enabled;
    this.di.nativeElement.checked = enabled;

    this.calculateCoverageTotal();

    //this.getHCData(this.client);
  }

  checkAllOOP() {
    var enabled = this.oopcheck.nativeElement.checked;

    this.hd.nativeElement.checked = enabled;
    this.hvc.nativeElement.checked = enabled;
    this.dins.nativeElement.checked = enabled;
    this.pdrg.nativeElement.checked = enabled;

    this.calculateCoverageTotal();
    //this.getHCData(this.client);
  }

  onRateSelected(rate) {
    if (rate === 1)
      this.investmentOption = 1;
    else if (rate === 2)
      this.investmentOption = 2;
    else if (rate === 3)
      this.investmentOption = 3;

    this.getHCData(this.client, this.partnerActive);
  }

  valueToggle(e) {
    this.FrmPV = e;//Number(e.target.value);
    this.getHCData(this.client, this.partnerActive);
  }

  spouseToggle(e) {    
    this.spouseHC = e;
  }

  formatCurrency(val) {
    return Utils.formatToCurrency(Utils.formatToNumber(val));
  }

  formatNumber3(val) {

    return Utils.formatToNumber(val);
  }

  formatNumber4(val1) {

    return Utils.formatToNumber(val1);
  }


  textCheck() {
    if (this.fundingSource) {
      this.showFundingBorder = false;
    } else {
      this.showFundingBorder = true;
    }

    if ((this.annContribution) && (this.annContribution >= 100 && this.annContribution <= 1000000)) {
      this.showAnnContrBorder = false;
    } else {
      this.showAnnContrBorder = true;
    }

    if (this.startAge) {
      this.showStartAgeBorder = false;
    } else {
      this.showStartAgeBorder = true;
    }

    if (this.endAge) {
      this.showEndAgeBorder = false;
    } else {
      this.showEndAgeBorder = true;
    }

    if (this.inflationRate) {
      this.showInflationBorder = false;
    } else {
      this.showInflationBorder = true;
    }
    if (!this.fundingSource && !this.annContribution && !this.startAge && !this.endAge && !this.inflationRate) {
      this.showFundingBorder = false;
      this.showAnnContrBorder = false;
      this.showStartAgeBorder = false;
      this.showEndAgeBorder = false;
      this.showInflationBorder = false;
    }
  }

  fundingTableCount() {
    this.fundingItems;
    let count = this.fundingItems.length 
    if (count >= 1) {
      this.showTable = true;
    } else {
      this.showTable = false;      
    }
  }

  fundingSourceModal(modalName): void {
    const dialogRef = this.dialog.open(FundingSourceComponent, {
      width: '1000px',
      height: '700px',
      data: { client: this.client, hcDataV2: this.hcDataV2, modalName: modalName }
    });

    dialogRef.afterClosed().subscribe(result => {

      this.fundingItems.push(result.data);
      this.fundingTableCount();

    });
  }

  formatName() {
    if (this.client) {
      return this.client.clientProfile && this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].firstName ?
        this.client.client.FirstName + ' and ' + this.client.clientProfile.Spouses[0].firstName + ' ' + this.client.client.LastName
        : this.client.client.FirstName + ' ' + this.client.client.LastName
    }
  }

  AddFundingSource() {
    
  }

  toggleSpouseHC() {
    this.spouseHCOptionsVisible = !this.spouseHCOptionsVisible;
  }

  toggleDuration() {
    this.FrmPV = this.FrmPV == 0 ? 1 : 0;
    this.getHCData(this.client, this.partnerActive);
  }

  handleEditClientModal(e) {
    this.modalService.add('add-edit-client', { ID: this.client.client.ID });
  }

  selectInvestmentOption(option) {
    this.investmentOptionValue = option;
  }

  bodyCardSelection(scenario) {
    console.log('bodyCardSelection');
    console.log(scenario);
    this.selected.isoneTimeInvestmentSelect = false;
    this.selected.isannuallyRecurringInvestmentSelect = false;
    this.selected.isweeklyRecurringInvestmentSelect = false;
    if (scenario == 'isoneTimeInvestmentSelect') {
      this.selected.isoneTimeInvestmentSelect = true;
      // this.investmentDescription = "test"
      this.investmentOption = 1;
    }
    if (scenario == 'isannuallyRecurringInvestmentSelect') {
      // let bodyCardSelectedIndex = (this.bodyCardSelectedIndex ? this.bodyCardSelectedIndex : this.dropDownSelectedIndex).toString();
      let dropDownSelectedIndex = this.dropDownSelectedIndexAnnually ? this.dropDownSelectedIndexAnnually :(Number(this.annuallyWeeklyTtlYear) < 10 ? 1: 10);
      let bodyCardSelectedIndex = (this.bodyCardSelectedIndexAnnually? this.bodyCardSelectedIndexAnnually : dropDownSelectedIndex).toString();
      this.investmentDescription = "Annually for " + bodyCardSelectedIndex + " years"
      this.selected.isannuallyRecurringInvestmentSelect = true;
      this.investmentOption = 2;
    }
    if (scenario == 'isweeklyRecurringInvestmentSelect') {
      let dropDownSelectedIndex = this.dropDownSelectedIndexWeekly ? this.dropDownSelectedIndexWeekly :(Number(this.annuallyWeeklyTtlYear) < 10 ? 1: 10);
      let bodyCardSelectedIndex = (this.bodyCardSelectedIndexWeekly? this.bodyCardSelectedIndexWeekly : dropDownSelectedIndex).toString();
      this.investmentDescription = "Weekly for " + bodyCardSelectedIndex + " years"
      this.selected.isweeklyRecurringInvestmentSelect = true;
      this.investmentOption = 3;
    }

  }

  returnedAdjustStartInvestment(data){
    console.log('data', data);
    console.log('from funding year dropdown', data.selectedBalance);
    if(data.isWeekly){
      this.weeklyCost = data.selectedBalance;
      this.bodyCardSelectedIndexWeekly = data.selectedDropDownIndex;
    } else {
      this.yearlyCost = data.selectedBalance;
      this.bodyCardSelectedIndexAnnually = data.selectedDropDownIndex;
    }
    // this.bodyCardSelectedIndex = data.selectedDropDownIndex;
  }

  formatDataLabel(value, model)
  {
    let projectedYear;

    if (this.projectedYears) {
      for (var i = 0; i < this.projectedYears.length; i++) {
        if (this.projectedYears[i].Year + i == Number(model.series)) {
          projectedYear = this.projectedYears[i];
        }
      }
    }

    // if (projectedYear && Utils.formatToNumber(projectedYear.BeginningBalance) > Utils.formatToNumber(projectedYear.NetOfSSDeductions)) {
    //   if(model && model.label == "Investment Value, In-Retirement") {
    //     return Utils.formatToCurrency(value + Utils.formatToNumber(projectedYear.NetOfSSDeductions));
    //   }
    // } else if (projectedYear) {
    //   if(model && model.label == "Annual Healthcare Spend") {
    //     return Utils.formatToCurrency(value + Utils.formatToNumber(projectedYear.BeginningBalance));
    //   }
    // }

    if (projectedYear) {
      if(model && model.label == "Investment Value, In-Retirement") {
        return Utils.formatToCurrency(value + Utils.formatToNumber(projectedYear.NetOfSSDeductions));
      }
    }
    
    return Utils.formatToCurrency(value);
  }

  mmtModalData;
  public ssClientAge: string = '65';
  public ssSpouseAge: string = '65';
  public ssClientAgeChanged: Subject<string> = new Subject<string>();
  public ssSpouseAgeChanged: Subject<string> = new Subject<string>();
  startingIllustration;
  mmtTotalSurcharges;
  getMMTData() {
        
    var tempReportVals = {
        InflationRate: 0.03,
        MagiIncomePercent: this.client.clientProfile.MAGIPercentIncome || 100,
        IncludePartner: this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Married',
        SocialSecurityRetirementAge: this.ssClientAge,
        SSMonthlyBenefit: this.client.clientProfile.PIA,
        PartnerSSMonthlyBenefit: this.client.clientProfile.Spouses[0] && typeof this.client.clientProfile.Spouses[0].pia === 'string' ? Number(this.client.clientProfile.Spouses[0].pia.replace(/,/g, "").replace("$", "")) || 0 : this.client.clientProfile.Spouses[0] ? Number(this.client.clientProfile.Spouses[0].pia) || 0 : 0,
        PartnerSocialSecurityAge: this.ssSpouseAge
    }

    var user = {
        UserID: Number(localStorage.getItem('roleId')) <= 2 ? localStorage.getItem('selectedAdvisorID') : localStorage.getItem('userId'),
        CompanyCode: Number(localStorage.getItem('roleId')) <= 2 ? localStorage.getItem('selectedAdvisorOrgID') : localStorage.getItem('orgID'),
        ClientID: localStorage.getItem('selectedClient')
    }

    if ((Number(this.ssClientAge) >= 60 || Number(this.ssClientAge) <= 70) && (Number(this.ssSpouseAge) >= 60 || Number(this.ssSpouseAge) <= 70)) {
        
        this.globalService.getMMTData(this.client, tempReportVals, user)
            .subscribe(
                data => {
                    console.log('mmt data', data);
                    //this.createIRMAAAreaChartData(data);
                    //this.createIRMAALineChartData(data);
                    //this.calculateTotals(data);
                    this.startingIllustration = data.IllustrationEntries;
                    
                    //this.clientBenefit = Util.formatToCurrency(Number(data.clientSSBenfit / 12).toFixed(0) || 0);
                    //this.spouseBenefit = Util.formatToCurrency(Number(data.spouseSSBenefit / 12).toFixed(0) || 0);

                    this.mmtModalData = data.IllustrationEntries.map((entry, idx) => {
                      if (entry.ClientAge >= data.Client.RetirementAge || (entry.PartnerAge && entry.PartnerAge >= data.Partner.RetirementAge)) {
                            //this.mmtData = data;

                            entry.ClientAge = entry.ClientAge < this.client.clientProfile.RetirementAge ? '--' : entry.ClientAge;

                            if (entry.PartnerAge)
                                entry.PartnerAge = entry.PartnerAge < this.client.clientProfile.Spouses[0].retirementAge ? '--' : entry.PartnerAge;

                            let updatedEntry = {
                                yearWithAge: entry.PartnerAge ? `${entry.Year}(${entry.ClientAge}/${entry.PartnerAge})` : `${entry.Year} (${entry.ClientAge})`,
                                //magi: this.magi,
                                fullMAGI: this.formatCurrency(entry.HouseholdIncome),
                                percentMAGI: this.formatCurrency(entry.MagiAdjustedHouseholdIncome),
                                updatedBracket: entry.MagiAdjustedIncomeBracket,
                                premiums: this.formatCurrency(entry.HouseholdExpenseByBracket[0]),
                                surcharges: this.formatCurrency(entry.MagiAdjustedIncomeBracket === 1 ? 0 : entry.HouseholdExpenseByBracket[entry.MagiAdjustedIncomeBracket - 1] - entry.HouseholdExpenseByBracket[0]),
                                total: entry.MagiAdjustedIncomeBracket === 1 ? entry.HouseholdExpenseByBracket[entry.MagiAdjustedIncomeBracket - 1] : entry.HouseholdExpenseByBracket[0] + entry.HouseholdExpenseByBracket[entry.MagiAdjustedIncomeBracket - 1] - entry.HouseholdExpenseByBracket[0],
                                savings: this.formatCurrency(Math.max(0, Math.abs((entry.MagiAdjustedIncomeBracket === 1 ? 0 : entry.HouseholdExpenseByBracket[entry.MagiAdjustedIncomeBracket - 1] - entry.HouseholdExpenseByBracket[0]) - (this.startingIllustration[idx].MagiAdjustedIncomeBracket === 1 ? 0 : this.startingIllustration[idx].HouseholdExpenseByBracket[this.startingIllustration[idx].MagiAdjustedIncomeBracket - 1] - this.startingIllustration[idx].HouseholdExpenseByBracket[0]))))
                            }

                            updatedEntry.total = this.formatCurrency(updatedEntry.total);
                            return updatedEntry;
                        }
                    });

                    const totalPremiums = this.formatCurrency(this.mmtModalData.reduce( (r, e) => { if (e) { return r + Util.removeCurrencyFormatting(e.premiums) } else { return r }}, 0));
                    const totalSurcharges = this.formatCurrency(this.mmtModalData.reduce( (r, e) => { if (e) { return r + Util.removeCurrencyFormatting(e.surcharges); } else { return r }}, 0));
                    const total = this.formatCurrency(this.mmtModalData.reduce( (r, e) => { if (e) { return r + Util.removeCurrencyFormatting(e.total) } else { return r }}, 0));
                    const savings = this.formatCurrency(this.mmtModalData.reduce( (r, e) => { if (e) { return r + Util.removeCurrencyFormatting(e.savings) } else { return r }}, 0));

                    this.mmtModalData.push({
                        yearWithAge: 'Total',
                        magi: '',
                        fullMAGI: '',
                        percentMAGI: '',
                        updatedBracket: '',
                        premiums: totalPremiums,
                        surcharges: totalSurcharges,
                        total: total,
                        savings: savings,
                    })

                    this.mmtModalData = this.mmtModalData.filter((item) => {return item != undefined});
                  
                    this.mmtTotalSurcharges = totalSurcharges;
                },
                error => console.log(error));
    }
  }

  //Risk Tolerance  
  getRiskTolPhaseAOrAn(phase): string {
    return ['Aggressive','Income & Growth', 'Income'].includes(phase) ? 'an' : 'a'
  }

  saveClientRiskTol(isAdvisoryAgreementSave: boolean = false){
    var body = {
      ClientID: localStorage.getItem('selectedClient'),
      LvlOfInvestExpID: this.objRiskTolerance.levelOfInvestment,
      LngthOfInvestID: this.objRiskTolerance.lengthOfInvestment,
      ToleranceOfRiskID: this.objRiskTolerance.toleranceOfRisk,
      NeedRedeemID: this.objRiskTolerance.isRedeemAccount,

      //below comes from the Advisor Agreement/Open Account modal object
      AccountType: (this.objRickToleranceAccountAgreement) ? this.objRickToleranceAccountAgreement.accountType : 0,
      HasSignedAdvisoryAgreement: (this.objRickToleranceAccountAgreement) ? this.objRickToleranceAccountAgreement.advisorAgreement : 0,//advisorAgreement
      HasSignedUpForManagedAccount: (this.objRickToleranceAccountAgreement) ? this.objRickToleranceAccountAgreement.wantsToOpenAnAccount : 0,//aggrement || wantsToOpenAnAccount
      SignedAdvisoryAgreementDate: (this.objRickToleranceAccountAgreement) ? this.objRickToleranceAccountAgreement.advisorAgreementSignDate : null //advisorAgreementSignDate
    };

    this.globalService.updateClientRiskTolerance(body)
    .subscribe(
      resp => {
        //boolean returned here
        console.log('client updated RT', resp);
        this.getPortfolioRecommendation();

        if(isAdvisoryAgreementSave){
          if(this.objRickToleranceAccountAgreement.notCandidateToOpenAccount){
            this.snackBarService.add("Unfortunately, you are not a candidate for HealthView Asset management. Based on your risk tolerance response, we suggest a portfolio of money market and CDs.", 0);            
          } else {
            this.snackBarService.add("Thank you! HealthView Asset management will be in touch shortly.", 0);
          }
        }
      });    
  }

    portfolioRecommendationObjectAge;
   getPortfolioRecommendation() {
    if(!this.globalService.featRiskTolerance){
      return;
    }

    if (this.globalService.featRiskTolerance && !this.hasRiskTolBeenRan) {
      let unfundeHealthCareCost = 0;
      unfundeHealthCareCost = this.currentRemainingTotalForRiskTolPort ? this.currentRemainingTotalForRiskTolPort: this.currentRemainingTotal;
      for(var item of this.fundingItems) {
  
        if (item.remainingUnfunded) {
          unfundeHealthCareCost += item.remainingUnfunded;
        }
      }
      let isClientRetiringFirst = this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? Number(this.client.clientProfile.RetirementAge - this.calculateAge(this.client.client.DOB)) <= Number(this.client.clientProfile.Spouses[0].retirementAge - this.calculateAge(this.client.clientProfile.Spouses[0].dob)) : true;
      let isClientRetired = this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ?(Number(this.client.clientProfile.RetirementAge - this.calculateAge(this.client.client.DOB)) < 0 ? true: false)  :false ;
			let isSpouseRetired = this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ?(Number(this.client.clientProfile.Spouses[0].retirementAge - this.calculateAge(this.client.clientProfile.Spouses[0].dob)) < 0 ? true: false)  :false ;
      let clientAge = '';
      let clientRetirementAge = '';

      if((isClientRetired && isSpouseRetired) || (!isClientRetired && !isSpouseRetired)) {
        clientAge = isClientRetiringFirst ? JSON.stringify(this.calculateAge(this.client.client.DOB)) : JSON.stringify(this.calculateAge(this.client.clientProfile.Spouses[0].dob));
        clientRetirementAge = isClientRetiringFirst ? JSON.stringify(this.client.clientProfile.RetirementAge) : this.client.clientProfile.Spouses[0].retirementAge;
      } else if (isClientRetired) {
        clientAge = JSON.stringify(this.calculateAge(this.client.clientProfile.Spouses[0].dob));
        clientRetirementAge = this.client.clientProfile.Spouses[0].retirementAge;
      } else {
        clientAge = JSON.stringify(this.calculateAge(this.client.client.DOB));
        clientRetirementAge = JSON.stringify(this.client.clientProfile.RetirementAge);
      }

      var riskTolerance = {
        ClientID: localStorage.getItem('selectedClient'),
        ClientAge: clientAge,
        ClientRetirementAge: clientRetirementAge,
        estimateLifeTimeCostInFuture: JSON.stringify(this.futureTotalCost),
        unfundedHealthCareCost: JSON.stringify(unfundeHealthCareCost),
        LevelOfInvestmentID: this.objRiskTolerance.levelOfInvestment,
        LengthOfInvestmentID: this.objRiskTolerance.lengthOfInvestment,
        ToleranceOfRiskID: this.objRiskTolerance.toleranceOfRisk,
        NeedRedeemID: this.objRiskTolerance.isRedeemAccount
      }

      console.log('risk obj: ', riskTolerance);

      this.globalService.getRiskTolerancePortfolio(riskTolerance).subscribe(
        resp => {
          console.log('resp for RT: ', resp);
          let clientRealAge = JSON.stringify(this.calculateAge(this.client.client.DOB));
          if (resp.PhaseOneRecommend) {
            this.portfolioRecommendationVisible = true;
          }
          
          if(!this.portfolioRecommendationObject){
            this.portfolioRecommendationObject = {
              year: String(isClientRetiringFirst ? this.getRetirementYear(this.client.clientProfile.RetirementAge, this.client.client.DOB) : this.getRetirementYear(this.client.clientProfile.Spouses[0].retirementAge, this.client.clientProfile.Spouses[0].dob)),
              phase1Portfolio: resp.PhaseOneRecommend,
              phase2Portfolio: resp.PhaseTwoRecommend,
              phase3Portfolio: resp.PhaseThreeRecommend,
              phase1Val: resp.PhaseOneROR,
              phase2Val: resp.PhaseTwoROR,
              phase3Val: resp.PhaseThreeROR,
              clientAge: clientAge,
              spouseAge: this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? `${this.calculateAge(this.client.clientProfile.Spouses[0].dob)}` : '0' ,
              clientRetirementAge: clientRetirementAge,
              spouseRetirementAge: this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? this.client.clientProfile.Spouses[0].retirementAge : '0' ,
              singleInvestment: (resp.SingleInvestment && resp.SingleInvestment != 0) ? Utils.formatToCurrency(resp.SingleInvestment) : (this.portfolioRecommendationObject) ? this.portfolioRecommendationObject.singleInvestment || 0 : this.beginningBalance,
              unfundedAmount: this.futureTotalCost ? String(Utils.formatToCurrency(this.futureTotalCost)): '$0',
              isMarried: this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? true: false,
              clientRealAge: clientRealAge,
              clientRealRetirementAge: this.client.clientProfile.RetirementAge,
              spouseFirstName: this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? this.client.clientProfile.Spouses[0].firstName: '',
              spouseLastName: this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? this.client.clientProfile.Spouses[0].lastName: '',
              hcReport: this.HCReport,
              user: this.user
            }
          }

          if(!this.objAdjustRates){
            this.objAdjustRates = {
              rorOne: Number(this.portfolioRecommendationObject.phase1Val),
              throughYearOne: this.getPhaseAgeDiff(1),
              rorTwo: Number(this.portfolioRecommendationObject.phase2Val),
              throughYearTwo: this.getPhaseAgeDiff(2),
              rorThree: Number(this.portfolioRecommendationObject.phase3Val)
            }
          }

          this.beginningBalance = this.portfolioRecommendationObject.singleInvestment;

          if (Number(clientAge) >= Number(this.client.clientProfile.RetirementAge)) {
            this.isAlreadyRetired = true;
          } else {
            this.isAlreadyRetired = false;
          }

          let age;
          if (this.portfolioRecommendationObject.isMarried && !this.isHCIllustration) {
            this.portfolioRecommendationObjectAge = age = isClientRetiringFirst ? (Math.max(this.portfolioRecommendationObject.clientAge, this.portfolioRecommendationObject.clientRetirementAge)  + "/" + Math.max(this.portfolioRecommendationObject.spouseAge && this.portfolioRecommendationObject.spouseRetirementAge)) 
              : (Math.max(this.portfolioRecommendationObject.spouseAge && this.portfolioRecommendationObject.spouseRetirementAge) + "/" + Math.max(this.portfolioRecommendationObject.clientAge, this.portfolioRecommendationObject.clientRetirementAge));
          } else {
            this.portfolioRecommendationObjectAge = age = Math.max(this.portfolioRecommendationObject.clientAge, this.portfolioRecommendationObject.clientRetirementAge);
          }
          if (this.isHCIllustration) {
            this.rorPhaseOneYear = this.isRetired ? "Through Retirement" : "Through " + this.portfolioRecommendationObject.year + " (Age "+ age + ")"
          } else {
            this.rorPhaseOneYear = this.isRetired ? "Distribution Through Retirement" : "Through " + this.portfolioRecommendationObject.year + " (Age "+ age + ")"
          }

          this.hasRiskTolBeenRan = true;
          this.setRiskTolRates(this.portfolioRecommendationObject.phase1Portfolio);
          this.getHCData(this.client, this.partnerActive, true);
          //this.getHCData(this.client, this.partnerActive, true);
          //this.getClient();
          //this.riskToleranceWhileInstantiate(this.totalSocialSecurity, this.futureTotalCost, this.portfolioRecommendationObject);
        },
        error => {
          this.error = <any>error;
        });
    }
  }

  getPhaseDiff(phase) {
    const clientAge = Number(this.calculateAge(this.client.client.DOB));
    const clientRetirementAge = Number(this.client.clientProfile.RetirementAge);
    const clientLE = Number(this.client.clientProfile.LifeExpectancy);
    const spouseAge = Number(this.calculateAge(this.client.clientProfile.Spouses[0].dob)) || 0;
    const spouseRetirementAge = Number(this.client.clientProfile.Spouses[0].retirementAge) || 0;
    const spouseLE = Number(this.client.clientProfile.Spouses[0].LifeExpectancy) || 0;

    if (spouseAge && spouseRetirementAge) {
      if (phase == 1)
        return Math.min(Math.max(0, clientRetirementAge - clientAge), Math.max(0, spouseRetirementAge - spouseAge));
      if (phase == 2)
        return Math.min(Math.max(0, clientLE - clientRetirementAge), Math.max(0, spouseLE - spouseRetirementAge));
    } else {
      if (phase == 1)
        return Math.max(0, clientRetirementAge - clientAge);
      if (phase == 2)
        return Math.max(0, clientLE - clientRetirementAge);
    }
  }

  getPhaseAgeDiff(phase) {
    let clientYearsToRetire = 0;
    let spouseYearsToRetire = 0;
    let clientRetirementYears = 0;
    let spouseRetirementYears = 0;
    
    clientYearsToRetire = Math.max(0, Number(this.portfolioRecommendationObject.clientRetirementAge)) - Number(this.portfolioRecommendationObject.clientAge);
    spouseYearsToRetire = Math.max(0, Number(this.portfolioRecommendationObject.spouseRetirementAge)) - Number(this.portfolioRecommendationObject.spouseAge);
    let year = this.currentYear + (Number(this.portfolioRecommendationObject.spouseAge) > 0 ? Math.min(clientYearsToRetire, spouseYearsToRetire) : Math.max(0, clientYearsToRetire));

    if (phase === 1) {
      /* clientYearsToRetire = Math.max(0, Number(this.portfolioRecommendationObject.clientRetirementAge)) - Number(this.portfolioRecommendationObject.clientAge);
      spouseYearsToRetire = Math.max(0, Number(this.portfolioRecommendationObject.spouseRetirementAge)) - Number(this.portfolioRecommendationObject.spouseAge); */
      return year;
    } else {
      clientRetirementYears = Math.max(0, Number(this.client.clientProfile.LifeExpectancy)) - Number(this.portfolioRecommendationObject.clientRetirementAge);
      console.log('return of phase 2', this.portfolioRecommendationObject);
      spouseRetirementYears = Math.max(0, Number(this.client.clientProfile.Spouses[0].LifeExpectancy)) - Number(this.portfolioRecommendationObject.spouseRetirementAge);
      return year + (Number(this.portfolioRecommendationObject.spouseAge) > 0 ? Math.min(clientRetirementYears, spouseRetirementYears) : Math.max(0, clientRetirementYears));
    }    
  }

  handleSavingRiskToleranceHC() {

    //var report = this.HCReport;//this.getHealthcarePDfValues();
    //localStorage.setItem('riskTolReportObject', JSON.stringify(report));
    //let Values = report;//JSON.parse(localStorage.getItem('riskTolReportObject'));
    //let HCValues = this.getHealthcarePDfValues();
    //Values.Report.ReportTypeID = 5;
    var Report = {
      ClientID: this.client.client.ID,
      AdvisorID: this.client.client.AdvisorID,
      CompanyCode: this.client.client.OrganizationID,
      ReportTypeID: 5,
    }

    var investmentItems = [];

    var investmentItem;

    var currentAge = this.calculateAge(this.client.client.DOB);
    var currentYear = new Date().getFullYear();

    for (var item in this.fundingItems) {

      var contribution = {
        Description: this.fundingItems[item].fundingSource,
        Begins: this.fundingItems[item].startAge,
        StartAmount: this.fundingItems[item].annContribution,
        Ends: this.fundingItems[item].endAge,
        Cola: this.fundingItems[item].inflationRate,
        // ContributionType: 0,
      }

      investmentItems.push(contribution);
    }

    // InvestmentItems: JSON.stringify({ investmentItems }),
    let spouseDOB = this.client.clientProfile.Spouses[0].dobStr ? this.client.clientProfile.Spouses[0].dobStr : (new Date(this.client.clientProfile.Spouses[0].dob) ? this.client.clientProfile.Spouses[0].dob : '');
    let isIncome = (this.client.clientProfile.CurrentIncome && this.client.clientProfile.InflationRate && this.client.clientProfile.IRR) || this.client.clientProfile.HouseholdYearOneIncome ? true : false;
    // console.log('this.isOptionCurrentIncome ', this.isOptionCurrentIncome)
    var ReportHC = {
      // ID: 0,
      InvestmentItems:  JSON.stringify({ investmentItems }),

      //client
      P_Part_A_And_B: this.profileInfo.value.medicarePartB ? 1 : 0,//this.hdt ? this.hdt.nativeElement.checked ? 1 : 0 : 1,
      P_Part_D: ((this.profileInfo.value.medicareAdvHMO && this.profileInfo.value.inRetirementCoverageType == 'HMO') || (this.profileInfo.value.medicareAdvPPO && this.profileInfo.value.inRetirementCoverageType == 'PPO')) ? 0 : this.profileInfo.value.medicarePartD ? 1 : 0,//this.pd ? this.pd.nativeElement.checked ? 1 : 0 : 1,
      P_MediGap: this.profileInfo.value.supplemental ? 1 : 0,//this.si ? this.si.nativeElement.checked ? 1 : 0 : 0,
      P_Dental: this.profileInfo.value.dental ? 1 : 0,//this.di ? this.di.nativeElement.checked ? 1 : 0 : 0,
      OOP_Hosp_Docs: this.profileInfo.value.hospitalDocsTestsOOP ? 1 : 0,//this.hd ? this.hd.nativeElement.checked ? 1 : 0 : 0,
      OOP_Presc_Drug: this.profileInfo.value.prescriptionDrugsOOP ? 1 : 0,//this.pdrg ? this.pdrg.nativeElement.checked ? 1 : 0 : 0,
      OOP_Hearing_Vision: this.profileInfo.value.hearingVisionOOP ? 1 : 0,//this.hvc ? this.hvc.nativeElement.checked ? 1 : 0 : 0,
      OOP_Dental: this.profileInfo.value.dentalOOP ? 1 : 0,//this.dins ? this.dins.nativeElement.checked ? 1 : 0 : 0,

      //spouse/partner
      P_Part_A_And_B1: this.partnerActive ? this.spouseProfileInfo.value.medicarePartB ? 1 : 0 : 0,
      P_Part_D1: this.partnerActive ? ((this.spouseProfileInfo.value.medicareAdvHMO && this.spouseProfileInfo.value.inRetirementCoverageType == 'HMO') || (this.spouseProfileInfo.value.medicareAdvPPO && this.spouseProfileInfo.value.inRetirementCoverageType == 'PPO')) ? 0 : this.spouseProfileInfo.value.medicarePartD ? 1 : 0 : 0,
      P_MediGap1: this.partnerActive ? this.spouseProfileInfo.value.supplemental ? 1 : 0 : 0,
      P_Dental1: this.partnerActive ? this.spouseProfileInfo.value.dental ? 1 : 0 : 0,
      OOP_Hosp_Docs1: this.partnerActive ? this.spouseProfileInfo.value.hospitalDocsTestsOOP ? 1 : 0 : 0,
      OOP_Presc_Drug1: this.partnerActive ? this.spouseProfileInfo.value.prescriptionDrugsOOP ? 1 : 0 : 0,
      OOP_Hearing_Vision1: this.partnerActive ? this.spouseProfileInfo.value.hearingVisionOOP ? 1 : 0 : 0,
      OOP_Dental1: this.partnerActive ? this.spouseProfileInfo.value.dentalOOP ? 1 : 0 : 0,

      FrmName0: this.client.client.FirstName + "/" + this.client.client.LastName,
      FrmName1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].firstName + "/" + this.client.clientProfile.Spouses[0].lastName : "",
      FrmHasPartner: this.partnerActive,
      FrmQType: this.client.clientProfile.HCT1D,
      FrmQExcercise: 1,
      FrmGender: this.client.client.GenderID,
      FrmQTypeII: this.client.clientProfile.HCT2D,
      FrmQTobacco: this.client.clientProfile.HCT,
      FrmQCancer: this.client.clientProfile.HCC,
      FrmQHistory: this.client.clientProfile.HCFHDC,
      FrmQCardio: this.client.clientProfile.HCCD,
      FrmQPhysical: 1,
      FrmQHighColesterol: this.client.clientProfile.HCHC,
      FrmQDiet: 1,
      FrmQHBP: this.client.clientProfile.HCHBP,
      FrmQDCW: this.client.clientProfile.HCDCW,
      FrmQMS: this.client.clientProfile.HCMS,

      FrmQAlzheimer: this.client.clientProfile.HCALZ,
      FrmQParkinson: this.client.clientProfile.HCPARK,
      FrmQPTSD: this.client.clientProfile.HCPTSD,
      FrmQAmputation: this.client.clientProfile.HCAMP,
      FrmQObesity: this.client.clientProfile.HCOBS,

      FrmCurrentAge: this.calculateAge(this.client.client.DOB),

      FrmPlanUntil: this.hcDataV2.PlanUntilYear,
      FrmPlanUntil0: this.hcDataV2.PlanUntilYear,
      FrmPlanUntil1: this.hcDataV2.PlanUntil1,
      SpouseFrmPlanUntil: this.hcDataV2.PlanUntil1,

      SpouseFrmQTobacco: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT ? 1 : 0 : 0,
      SpouseFrmQCancer: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCC ? 1 : 0 : 0,
      SpouseFrmQDiet: 1,
      SpouseFrmQCardio: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCCD ? 1 : 0 : 0,
      SpouseFrmQPhysical: 1,
      SpouseFrmGender: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].gender : 0,
      SpouseQHBP: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHBP ? 1 : 0 : 0,
      SpouseFrmQHBP: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHBP ? 1 : 0 : 0,
      SpouseFrmQDCW: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCDCW ? 1 : 0 : 0,
      SpouseFrmQMS: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCMS ? 1 : 0 : 0,

      SpouseCurrentAge: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.calculateAge(this.client.clientProfile.Spouses[0].dob) : 0,
      SpouseFrmQHighColesterol: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHC ? 1 : 0 : 0,
      SpouseQHighColesterol: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHC ? 1 : 0 : 0,
      SpouseQTypeII: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT2D ? 1 : 0 : 0,
      SpouseFrmQType: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT1D ? 1 : 0 : 0,

      SpouseFrmQAlzheimer: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCALZ ? 1 : 0 : 0,
      SpouseFrmQParkinson: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCPARK ? 1 : 0 : 0,
      SpouseFrmQPTSD: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCPTSD ? 1 : 0 : 0,
      SpouseFrmQAmputation: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCAMP ? 1 : 0 : 0,
      SpouseFrmQObesity: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCOBS ? 1 : 0 : 0,


      SpouseQExcercise: 1,
      SpouseQHistory: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCFHDC ? 1 : 0 : 0,

      PaymentTotal: 0,
      //PaymentYears: this.annualEl && this.annualEl.nativeElement ? this.annualEl.nativeElement.value : 10,
      PaymentYears: (this.investmentOption == 1) ? this.annualEl && this.annualEl.nativeElement ? this.annualEl.nativeElement.value : (this.annuallyWeeklyTtlYear < 10 ? 1 : 10) 
        : (this.investmentOption == 2) ? this.bodyCardSelectedIndexAnnually : this.bodyCardSelectedIndexWeekly,

      FrmIncome: this.hcDataV2.FrmIncome,

      FrmPhase1Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorOne)) : 6,
      FrmPhase1Periods: this.objAdjustRates ? Number(this.objAdjustRates.throughYearOne) : Math.max(65 - Number(this.calculateAge(this.client.client.DOB))),
      FrmPhase2Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorTwo)) : 6,
      FrmPhase2Periods: this.objAdjustRates ? (Number(this.objAdjustRates.throughYearTwo)) : 10,
      FrmPhase3Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorThree)) : 6,

      FrmRetireYear1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? Math.max(currentYear,this.getRetirementYear(this.client.clientProfile.Spouses[0].retirementAge, this.client.clientProfile.Spouses[0].dob)) : 0,
      //FrmRetireYear1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? Math.max(currentYear,this.getRetirementYear(this.spouseRetirementAge, this.client.clientProfile.Spouses[0].dob)) : 0,

      FrmPV: this.FrmPV,
      FrmRetireYear0: Math.max(currentYear, this.getRetirementYear(this.client.clientProfile.RetirementAge, this.client.client.DOB)),
      //FrmRetireYear0: Math.max(currentYear, this.getRetirementYear(this.retirementAge, this.client.client.DOB)),

      FrmState: this.client.clientProfile.RetirementState,
      FundCosts: this.futureTotalCost,

      SelfLifeExpectancy: this.client.clientProfile.LifeExpectancy || 0,
      SpouseLifeExpectancy: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].LifeExpectancy || 0 : 0,
      InvestmentOption: this.investmentOption,
      UseNationalAverage: this.client.clientProfile.UseNationalAverage ? 1 : 0,
      SpouseDOB: spouseDOB,
      SelfDOB: this.client.client.DOB,

      SelfRetirementAge: this.client.clientProfile.RetirementAge,
      //SelfRetirementAge: this.retirementAge,
      //IsClientRetireEarly: (this.client.clientProfile.RetirementAge < 65),
      SpouseRetirementAge: this.client.clientProfile.Spouses[0].retirementAge,
      //SpouseRetirementAge: this.spouseRetirementAge,
      //IsSpouseRetireEarly: (this.client.clientProfile.Spouses[0].retirementAge < 65),
      
      MaritalState: this.client.clientProfile.Spouses[0].maritalStatus,

      Bracket: (!this.client.clientProfile.CurrentIncome) ? this.client.clientProfile.Bracket : null,
      HouseholdYearOneIncome: this.client.clientProfile.HouseholdYearOneIncome || 0,
      PreRetirementInflationRate: (this.client.clientProfile.InflationRate == null) ? 0.03 : this.client.clientProfile.InflationRate / 100,
      InRetirementInflationRate: (this.client.clientProfile.InRetirementInflationRate == null) ? 0.03 : this.client.clientProfile.InRetirementInflationRate / 100,
      FrmState1: this.client.clientProfile.Spouses[0].state || '',
      SelfIRR: (this.client.clientProfile.IRR != null && this.client.clientProfile.IRR != undefined) ? this.client.clientProfile.IRR : 0,      
      MAGI: (this.client.clientProfile.MAGIPercentIncome == null) ? 100 : this.client.clientProfile.MAGIPercentIncome,
      
      ClientPIA: this.client.clientProfile.PIA,
      SelfPIA: (this.client.clientProfile.PIA) ? this.client.clientProfile.PIA : 0,
      SpousePIA: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? Number(this.client.clientProfile.Spouses[0].pia) || 0 : 0,
      
      PremiumType: this.profileInfo.value.inRetirementCoverageType == 'TM' ? 0 : this.profileInfo.value.inRetirementCoverageType == 'HMO' ? 1 : 2,
      PremiumType1: (this.partnerActive) ? this.spouseProfileInfo.value.inRetirementCoverageType == 'TM' ? 0 : this.spouseProfileInfo.value.inRetirementCoverageType == 'HMO' ? 1 : 2 : 0,
      PrivateInsurance: (this.profileInfo.value.privateHealthInsurance == 'true' || this.profileInfo.value.privateHealthInsurance == true) ? 1: 0,
      PrivateInsurance1: (this.partnerActive) ? (this.spouseProfileInfo.value.privateHealthInsurance == 'true' || this.spouseProfileInfo.value.privateHealthInsurance == true) ? 1 : 0: 0,
      SelfCurrentIncome: (this.client.clientProfile.CurrentIncome != null && this.client.clientProfile.CurrentIncome != undefined) ? this.client.clientProfile.CurrentIncome : 0,
      SpouseCurrentIncome: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && isIncome ? Number(this.client.clientProfile.Spouses[0].currentIncome) || 0 : 0,
      P_Advantage: ((this.profileInfo.value.medicareAdvHMO && this.profileInfo.value.inRetirementCoverageType == 'HMO') || (this.profileInfo.value.medicareAdvPPO && this.profileInfo.value.inRetirementCoverageType == 'PPO'))? 1 : 0,
      P_Advantage1: this.partnerActive ? ((this.spouseProfileInfo.value.medicareAdvHMO && this.spouseProfileInfo.value.inRetirementCoverageType == 'HMO') || (this.spouseProfileInfo.value.medicareAdvPPO && this.spouseProfileInfo.value.inRetirementCoverageType == 'PPO')) ? 1 : 0 : 0,
      CoverageType: this.profileInfo.value.preRetirementCoverageType == 'PPO' ? 0 : this.profileInfo.value.preRetirementCoverageType == 'HMO' ? 1 : 2,
      CoverageType1: (this.partnerActive) ? this.spouseProfileInfo.value.preRetirementCoverageType == 'PPO' ? 0 : this.spouseProfileInfo.value.preRetirementCoverageType == 'HMO' ? 1 : 2 : 0,

      SelfSupplementalPlan: this.profileInfo.value.supplementalPlanType,
      SpouseSupplementalPlan: (this.partnerActive) ? this.spouseProfileInfo.value.supplementalPlanType : "",
      BracketRange: this.selectedIRMAABracketDisplay,

      MidRetAdjYear: this.client.midRetirementAdj ? this.client.midRetirementAdj.Year : 0,
      MidRetRedPer:  this.client.midRetirementAdj ? this.client.midRetirementAdj.ReductionPerc : 0,/// 100 : 0,
      MidRetRedDollar:  this.client.midRetirementAdj ? this.client.midRetirementAdj.ReductionDollar : 0,
      MidRetIncomeInflationRate: this.client.midRetirementAdj ? (this.client.midRetirementAdj.IncomeInflationRate) : 0,// / 100 : 0,
    }
    
    if(this.profileInfo.value.inRetirementCoverageType != 'TM'){
      ReportHC.P_Part_A_And_B = 1;
    }

    if (this.partnerActive) {
      if(this.spouseProfileInfo.value.inRetirementCoverageType != 'TM'){
        ReportHC.P_Part_A_And_B1 = 1;
      }
    }

    //HACK: trick object to allow new fields to be added...
    var stringifiedReportHC = JSON.stringify(ReportHC);
    var ReportHCAdj = JSON.parse(stringifiedReportHC);

    //healthcare
    ReportHCAdj.FrmPhase1Periods = (this.objAdjustRates) ? this.objAdjustRates.throughYearOne : this.getPhaseAgeDiff(1);//this.getPhaseDiff(1);
    ReportHCAdj.FrmPhase1Rate = this.portfolioRecommendationObject.phase1Val || 0;
    ReportHCAdj.FrmPhase2Periods = (this.objAdjustRates) ? this.objAdjustRates.throughYearTwo : this.getPhaseAgeDiff(2);//this.getPhaseDiff(2);
    ReportHCAdj.FrmPhase2Rate = this.isRetired ? this.portfolioRecommendationObject.phase1Val || 0: this.portfolioRecommendationObject.phase2Val || 0;
    //ReportHCAdj.FrmPhase3Rate = this.isRetired ? this.portfolioRecommendationObject.phase1Val || 0: this.portfolioRecommendationObject.phase2Val || 0;

    //Values.ReportHC.FinancialObjectiveID = this.getNumber(this.riskToleranceQuestionnaire.value.financialObjective) || 0;
    ReportHCAdj.LevelOfInvestmentID = this.objRiskTolerance.levelOfInvestment || 0;//getNumber(Values.RiskTol.levelOfInvestment) || 0;
    ReportHCAdj.LengthOfInvestmentID = this.objRiskTolerance.lengthOfInvestment || 0;//this.getNumber(Values.RiskTol.lengthOfInvestment) || 0;
    ReportHCAdj.ToleranceOfRiskID = this.objRiskTolerance.toleranceOfRisk || 0;//this.getNumber(Values.RiskTol.toleranceOfRisk) || 0;
    ReportHCAdj.NeedRedeemID = this.objRiskTolerance.isRedeemAccount || 0;//this.getNumber(Values.RiskTol.isRedeemAccount) || 0;

    this.globalService.createReportHC(Report, ReportHCAdj)
    .subscribe(
      resp => {
        this.snackBarService.add("Please wait while your risk tolerance healthcare report is being generated.", 0);
        
        this.downloadReport(resp.ReportID, resp.AdvisorID, resp.ClientID, resp.CompanyCode, resp.ReportTypeID);
      },
        error => this.error = <any>error);
  }
  
  setRiskTolRates(phase) {
    console.log('phase', phase);
    if (phase == "Conservative Income" || phase == "Stable Value" || phase == null || phase == "")
    {
        this.equitiesLargeCap = 5;
        this.equitiesMidCap = 2;
        this.equitiesSmallCap = 0;
        this.equitiesInternational = 3;
        this.equitiesReturn = 10;
        this.fixedGovBonds = 60;
        this.fixedCorpBonds = 10;
        this.fixedReturn = 70;
        this.cashMoneyMarket = 20;
        this.cashMoneyMarketReturn = 20;
    }
    else if (phase == "Income")
    {
      this.equitiesLargeCap = 10;
      this.equitiesMidCap = 5;
      this.equitiesSmallCap = 0;
      this.equitiesInternational = 5;
      this.equitiesReturn = 20;
      this.fixedGovBonds = 50;
      this.fixedCorpBonds = 25;
      this.fixedReturn = 75;
      this.cashMoneyMarket = 5;
      this.cashMoneyMarketReturn = 5;
    }
    else if (phase == "Growth & Income")
    {
      this.equitiesLargeCap = 20;
      this.equitiesMidCap = 15;
      this.equitiesSmallCap = 10;
      this.equitiesInternational = 15;
      this.equitiesReturn = 60;
      this.fixedGovBonds = 20;
      this.fixedCorpBonds = 18;
      this.fixedReturn = 38;
      this.cashMoneyMarket = 2;
      this.cashMoneyMarketReturn = 2;
    }
    else if (phase == "Growth")
    {
      this.equitiesLargeCap = 22;
      this.equitiesMidCap = 20;
      this.equitiesSmallCap = 18;
      this.equitiesInternational = 20;
      this.equitiesReturn = 80;
      this.fixedGovBonds = 9;
      this.fixedCorpBonds = 10;
      this.fixedReturn = 19;
      this.cashMoneyMarket = 1;
      this.cashMoneyMarketReturn = 1;
    }
    else if (phase == "Income & Growth")
    {
      this.equitiesLargeCap = 15;
      this.equitiesMidCap = 10;
      this.equitiesSmallCap = 5;
      this.equitiesInternational = 10;
      this.equitiesReturn = 40;
      this.fixedGovBonds = 32;
      this.fixedCorpBonds = 25;
      this.fixedReturn = 57;
      this.cashMoneyMarket = 3;
      this.cashMoneyMarketReturn = 3;
    }
    else if (phase == "Aggressive")
    {
      this.equitiesLargeCap = 25;
      this.equitiesMidCap = 23;
      this.equitiesSmallCap = 20;
      this.equitiesInternational = 22;
      this.equitiesReturn = 90;
      this.fixedGovBonds = 4;
      this.fixedCorpBonds = 5;
      this.fixedReturn = 9;
      this.cashMoneyMarket = 1;
      this.cashMoneyMarketReturn = 1;
    }
  }
}
